/**
 * 교우회지 목록 데이터
 */
const AlumniData = [
    {
        "book_id": 10332,
        "book_title": "(監理敎會協成神學校) 神學世界 第10券 第2號",
        "book_title_ko": "(감리교회협성신학교) 신학세계 제10권 제2호",
        "publish_date": "1925.04.01",
        "publish_year": 1925,
        "publish_month": 4,
        "publish_day": 1,
        "publisher": "河鯉泳 新學世界 編輯部",
        "publisher_ko": "하리영 신학세계 편집부",
        "library": "국회도서관;연세대○",
        "school_id": 52757,
        "primaryname": "監理敎會協成神學校",
        "primaryname_ko": "감리교회협성신학교"
    },
    {
        "book_id": 10333,
        "book_title": "(監理敎會協成神學校) 神學世界 第11券 第1號",
        "book_title_ko": "(감리교회협성신학교) 신학세계 제11권 제1호",
        "publish_date": "1926.02.23",
        "publish_year": 1926,
        "publish_month": 2,
        "publish_day": 23,
        "publisher": "河鯉泳 朝鮮耶蘇敎書會",
        "publisher_ko": "하리영 조선야소교서회",
        "library": "연세대",
        "school_id": 52757,
        "primaryname": "監理敎會協成神學校",
        "primaryname_ko": "감리교회협성신학교"
    },
    {
        "book_id": 10334,
        "book_title": "(監理敎會協成神學校) 神學世界 第11券 第3號",
        "book_title_ko": "(감리교회협성신학교) 신학세계 제11권 제3호",
        "publish_date": "1926.07.08",
        "publish_year": 1926,
        "publish_month": 7,
        "publish_day": 8,
        "publisher": "河鯉泳 朝鮮耶蘇敎書會",
        "publisher_ko": "하리영 조선야소교서회",
        "library": "국회도서관;연세대○",
        "school_id": 52757,
        "primaryname": "監理敎會協成神學校",
        "primaryname_ko": "감리교회협성신학교"
    },
    {
        "book_id": 10335,
        "book_title": "(監理敎會協成神學校) 神學世界 第11券 第4號",
        "book_title_ko": "(감리교회협성신학교) 신학세계 제11권 제4호",
        "publish_date": "1926.09.05",
        "publish_year": 1926,
        "publish_month": 9,
        "publish_day": 5,
        "publisher": "河鯉泳 朝鮮耶蘇敎書會",
        "publisher_ko": "하리영 조선야소교서회",
        "library": "연세대",
        "school_id": 52757,
        "primaryname": "監理敎會協成神學校",
        "primaryname_ko": "감리교회협성신학교"
    },
    {
        "book_id": 10336,
        "book_title": "(監理敎會協成神學校) 神學世界 第11券 第5號",
        "book_title_ko": "(감리교회협성신학교) 신학세계 제11권 제5호",
        "publish_date": "1926.11.27",
        "publish_year": 1926,
        "publish_month": 11,
        "publish_day": 27,
        "publisher": "河鯉泳 朝鮮耶蘇敎書會",
        "publisher_ko": "하리영 조선야소교서회",
        "library": "연세대",
        "school_id": 52757,
        "primaryname": "監理敎會協成神學校",
        "primaryname_ko": "감리교회협성신학교"
    },
    {
        "book_id": 10337,
        "book_title": "(監理敎會協成神學校) 神學世界 第12券 第1號",
        "book_title_ko": "(감리교회협성신학교) 신학세계 제12권 제1호",
        "publish_date": "1927.03.16",
        "publish_year": 1927,
        "publish_month": 3,
        "publish_day": 16,
        "publisher": "班禹巨 朝鮮耶蘇敎書會",
        "publisher_ko": "반우거 조선야소교서회",
        "library": "국회도서관;연세대○",
        "school_id": 52757,
        "primaryname": "監理敎會協成神學校",
        "primaryname_ko": "감리교회협성신학교"
    },
    {
        "book_id": 10338,
        "book_title": "(監理敎會協成神學校) 神學世界 第12券 第6號",
        "book_title_ko": "(감리교회협성신학교) 신학세계 제12권 제6호",
        "publish_date": "1927.00.00",
        "publish_year": 1927,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "R. A. Hardie",
        "publisher_ko": "R. A. Hardie",
        "library": "연세대",
        "school_id": 52757,
        "primaryname": "監理敎會協成神學校",
        "primaryname_ko": "감리교회협성신학교"
    },
    {
        "book_id": 10339,
        "book_title": "(監理敎會協成神學校) 神學世界 第13券 第1號",
        "book_title_ko": "(감리교회협성신학교) 신학세계 제13권 제1호",
        "publish_date": "1928.00.00",
        "publish_year": 1928,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "",
        "publisher_ko": "",
        "library": "연세대",
        "school_id": 52757,
        "primaryname": "監理敎會協成神學校",
        "primaryname_ko": "감리교회협성신학교"
    },
    {
        "book_id": 10340,
        "book_title": "(監理敎會協成神學校) 神學世界 第15券 第2號",
        "book_title_ko": "(감리교회협성신학교) 신학세계 제15권 제2호",
        "publish_date": "1930.03.30",
        "publish_year": 1930,
        "publish_month": 3,
        "publish_day": 30,
        "publisher": "河鯉泳 新學世界 編輯部",
        "publisher_ko": "하리영 신학세계 편집부",
        "library": "연세대",
        "school_id": 52757,
        "primaryname": "監理敎會協成神學校",
        "primaryname_ko": "감리교회협성신학교"
    },
    {
        "book_id": 10341,
        "book_title": "(監理敎會神學校) 神學世界 第16券 第6號",
        "book_title_ko": "(감리교회신학교) 신학세계 제16권 제6호",
        "publish_date": "1931.12.22",
        "publish_year": 1931,
        "publish_month": 12,
        "publish_day": 22,
        "publisher": "河鯉泳 新學世界 編輯部",
        "publisher_ko": "하리영 신학세계 편집부",
        "library": "연세대",
        "school_id": 52758,
        "primaryname": "監理敎會神學校",
        "primaryname_ko": "감리교회협성신학교"
    },
    {
        "book_id": 10342,
        "book_title": "(監理敎會神學校) 神學世界 第17券 第3號",
        "book_title_ko": "(감리교회신학교) 신학세계 제17권 제3호",
        "publish_date": "1932.05.23",
        "publish_year": 1932,
        "publish_month": 5,
        "publish_day": 23,
        "publisher": "邊永瑞 新學世界社 編輯部",
        "publisher_ko": "변영서 신학세계사 편집부",
        "library": "연세대△",
        "school_id": 52759,
        "primaryname": "監理敎會神學校",
        "primaryname_ko": "감리교회신학교"
    },
    {
        "book_id": 10343,
        "book_title": "(監理敎會神學校) 神學世界 第18券 第2號",
        "book_title_ko": "(감리교회신학교) 신학세계 제18권 제2호",
        "publish_date": "1933.03.09",
        "publish_year": 1933,
        "publish_month": 3,
        "publish_day": 9,
        "publisher": "邊永瑞 新學世界社 編輯部",
        "publisher_ko": "변영서 신학세계사 편집부",
        "library": "연세대△",
        "school_id": 52759,
        "primaryname": "監理敎會神學校",
        "primaryname_ko": "감리교회신학교"
    },
    {
        "book_id": 10344,
        "book_title": "(監理敎會神學校) 神學世界 第18券 第3號",
        "book_title_ko": "(감리교회신학교) 신학세계 제18권 제3호",
        "publish_date": "1933.05.15",
        "publish_year": 1933,
        "publish_month": 5,
        "publish_day": 15,
        "publisher": "邊永瑞 新學世界社 編輯部",
        "publisher_ko": "변영서 신학세계사 편집부",
        "library": "연세대△",
        "school_id": 52759,
        "primaryname": "監理敎會神學校",
        "primaryname_ko": "감리교회신학교"
    },
    {
        "book_id": 10345,
        "book_title": "(監理敎會神學校) 神學世界 第18券 第6號",
        "book_title_ko": "(감리교회신학교) 신학세계 제18권 제6호",
        "publish_date": "1933.11.17",
        "publish_year": 1933,
        "publish_month": 11,
        "publish_day": 17,
        "publisher": "河鯉泳 新學世界 編輯部",
        "publisher_ko": "하리영 신학세계 편집부",
        "library": "연세대",
        "school_id": 52759,
        "primaryname": "監理敎會神學校",
        "primaryname_ko": "감리교회신학교"
    },
    {
        "book_id": 10346,
        "book_title": "(監理敎會神學校) 神學世界 第19券 第1號",
        "book_title_ko": "(감리교회신학교) 신학세계 제19권 제1호",
        "publish_date": "1934.01.14",
        "publish_year": 1934,
        "publish_month": 1,
        "publish_day": 14,
        "publisher": "河鯉泳 新學世界 編輯部",
        "publisher_ko": "하리영 신학세계 편집부",
        "library": "국회도서관;연세대○",
        "school_id": 52759,
        "primaryname": "監理敎會神學校",
        "primaryname_ko": "감리교회신학교"
    },
    {
        "book_id": 10347,
        "book_title": "(監理敎會神學校) 神學世界 第19券 第2號",
        "book_title_ko": "(감리교회신학교) 신학세계 제19권 제2호",
        "publish_date": "1934.03.10",
        "publish_year": 1934,
        "publish_month": 3,
        "publish_day": 10,
        "publisher": "河鯉泳 新學世界 編輯部",
        "publisher_ko": "하리영 신학세계 편집부",
        "library": "국회도서관;연세대○",
        "school_id": 52759,
        "primaryname": "監理敎會神學校",
        "primaryname_ko": "감리교회신학교"
    },
    {
        "book_id": 10348,
        "book_title": "(監理敎會神學校) 神學世界 第19券 第3號",
        "book_title_ko": "(감리교회신학교) 신학세계 제19권 제3호",
        "publish_date": "1934.05.05",
        "publish_year": 1934,
        "publish_month": 5,
        "publish_day": 5,
        "publisher": "河鯉泳 新學世界 編輯部",
        "publisher_ko": "하리영 신학세계 편집부",
        "library": "국회도서관;연세대○",
        "school_id": 52759,
        "primaryname": "監理敎會神學校",
        "primaryname_ko": "감리교회신학교"
    },
    {
        "book_id": 10349,
        "book_title": "(監理敎會神學校) 神學世界 第19券 第5號",
        "book_title_ko": "(감리교회신학교) 신학세계 제19권 제5호",
        "publish_date": "1934.09.13",
        "publish_year": 1934,
        "publish_month": 9,
        "publish_day": 13,
        "publisher": "河鯉泳 新學世界 編輯部",
        "publisher_ko": "하리영 신학세계 편집부",
        "library": "국회도서관;연세대○",
        "school_id": 52759,
        "primaryname": "監理敎會神學校",
        "primaryname_ko": "감리교회신학교"
    },
    {
        "book_id": 10350,
        "book_title": "(監理敎會神學校) 神學世界 第20券 第3號",
        "book_title_ko": "(감리교회신학교) 신학세계 제20권 제3호",
        "publish_date": "1935.05.13",
        "publish_year": 1935,
        "publish_month": 5,
        "publish_day": 13,
        "publisher": "邊永瑞 新學世界 編輯部",
        "publisher_ko": "변영서 신학세계 편집부",
        "library": "국회도서관;연세대○",
        "school_id": 52759,
        "primaryname": "監理敎會神學校",
        "primaryname_ko": "감리교회신학교"
    },
    {
        "book_id": 10351,
        "book_title": "(監理敎會神學校) 神學世界 第21券 第2號",
        "book_title_ko": "(감리교회신학교) 신학세계 제21권 제2호",
        "publish_date": "1936.05.13",
        "publish_year": 1936,
        "publish_month": 5,
        "publish_day": 13,
        "publisher": "邊永瑞 新學世界 編輯部",
        "publisher_ko": "변영서 신학세계 편집부",
        "library": "국회도서관;연세대○",
        "school_id": 52759,
        "primaryname": "監理敎會神學校",
        "primaryname_ko": "감리교회신학교"
    },
    {
        "book_id": 10352,
        "book_title": "(監理敎會神學校) 神學世界 第21券 第3號",
        "book_title_ko": "(감리교회신학교) 신학세계 제21권 제3호",
        "publish_date": "1936.07.12",
        "publish_year": 1936,
        "publish_month": 7,
        "publish_day": 12,
        "publisher": "邊永瑞 新學世界 編輯部",
        "publisher_ko": "변영서 신학세계 편집부",
        "library": "연세대",
        "school_id": 52759,
        "primaryname": "監理敎會神學校",
        "primaryname_ko": "감리교회신학교"
    },
    {
        "book_id": 10353,
        "book_title": "(監理敎會神學校) 神學世界 第21券 第4號",
        "book_title_ko": "(감리교회신학교) 신학세계 제21권 제4호",
        "publish_date": "1936.09.20",
        "publish_year": 1936,
        "publish_month": 9,
        "publish_day": 20,
        "publisher": "邊永瑞 新學世界 編輯部",
        "publisher_ko": "변영서 신학세계 편집부",
        "library": "연세대",
        "school_id": 52759,
        "primaryname": "監理敎會神學校",
        "primaryname_ko": "감리교회신학교"
    },
    {
        "book_id": 10354,
        "book_title": "(監理敎會神學校) 神學世界 第22券 第2號",
        "book_title_ko": "(감리교회신학교) 신학세계 제22권 제2호",
        "publish_date": "1937.04.27",
        "publish_year": 1937,
        "publish_month": 4,
        "publish_day": 27,
        "publisher": "邊永瑞 新學世界 編輯部",
        "publisher_ko": "변영서 신학세계 편집부",
        "library": "연세대△",
        "school_id": 52759,
        "primaryname": "監理敎會神學校",
        "primaryname_ko": "감리교회신학교"
    },
    {
        "book_id": 10355,
        "book_title": "(監理敎會神學校) 神學世界 第22券 第3號",
        "book_title_ko": "(감리교회신학교) 신학세계 제22권 제3호",
        "publish_date": "1937.07.05",
        "publish_year": 1937,
        "publish_month": 7,
        "publish_day": 5,
        "publisher": "邊永瑞 新學世界 編輯部",
        "publisher_ko": "변영서 신학세계 편집부",
        "library": "연세대",
        "school_id": 52759,
        "primaryname": "監理敎會神學校",
        "primaryname_ko": "감리교회신학교"
    },
    {
        "book_id": 10356,
        "book_title": "(監理敎會神學校) 神學世界 第22券 第4號",
        "book_title_ko": "(감리교회신학교) 신학세계 제22권 제4호",
        "publish_date": "1937.09.28",
        "publish_year": 1937,
        "publish_month": 9,
        "publish_day": 28,
        "publisher": "邊永瑞 新學世界 編輯部",
        "publisher_ko": "변영서 신학세계 편집부",
        "library": "연세대",
        "school_id": 52759,
        "primaryname": "監理敎會神學校",
        "primaryname_ko": "감리교회신학교"
    },
    {
        "book_id": 10357,
        "book_title": "(監理敎會神學校) 神學世界 第22券 第6號",
        "book_title_ko": "(감리교회신학교) 신학세계 제22권 제6호",
        "publish_date": "1937.11.00",
        "publish_year": 1937,
        "publish_month": 11,
        "publish_day": 0,
        "publisher": "B.W.Billings",
        "publisher_ko": "B.W.Billings",
        "library": "연세대",
        "school_id": 52759,
        "primaryname": "監理敎會神學校",
        "primaryname_ko": "감리교회신학교"
    },
    {
        "book_id": 10358,
        "book_title": "(監理敎會神學校) 神學世界 第23券 第2號",
        "book_title_ko": "(감리교회신학교) 신학세계 제23권 제2호",
        "publish_date": "1938.05.06",
        "publish_year": 1938,
        "publish_month": 5,
        "publish_day": 6,
        "publisher": "邊永瑞 新學世界 編輯部",
        "publisher_ko": "변영서 신학세계 편집부",
        "library": "연세대△",
        "school_id": 52759,
        "primaryname": "監理敎會神學校",
        "primaryname_ko": "감리교회신학교"
    },
    {
        "book_id": 10359,
        "book_title": "(監理敎會神學校) 神學世界 第23券 第5號",
        "book_title_ko": "(감리교회신학교) 신학세계 제23권 제5호",
        "publish_date": "1938.11.03",
        "publish_year": 1938,
        "publish_month": 11,
        "publish_day": 3,
        "publisher": "邊永瑞 新學世界 編輯部",
        "publisher_ko": "변영서 신학세계 편집부",
        "library": "연세대",
        "school_id": 52759,
        "primaryname": "監理敎會神學校",
        "primaryname_ko": "감리교회신학교"
    },
    {
        "book_id": 10360,
        "book_title": "(監理敎會神學校) 神學世界 第24券 第1號",
        "book_title_ko": "(감리교회신학교) 신학세계 제24권 제1호",
        "publish_date": "1939.02.25",
        "publish_year": 1939,
        "publish_month": 2,
        "publish_day": 25,
        "publisher": "邊永瑞 新學世界 編輯部",
        "publisher_ko": "변영서 신학세계 편집부",
        "library": "연세대",
        "school_id": 52759,
        "primaryname": "監理敎會神學校",
        "primaryname_ko": "감리교회신학교"
    },
    {
        "book_id": 10361,
        "book_title": "(監理敎會神學校) 神學世界 第24券 第2號",
        "book_title_ko": "(감리교회신학교) 신학세계 제24권 제2호",
        "publish_date": "1939.05.07",
        "publish_year": 1939,
        "publish_month": 5,
        "publish_day": 7,
        "publisher": "邊永瑞 新學世界 編輯部",
        "publisher_ko": "변영서 신학세계 편집부",
        "library": "연세대△",
        "school_id": 52759,
        "primaryname": "監理敎會神學校",
        "primaryname_ko": "감리교회신학교"
    },
    {
        "book_id": 10362,
        "book_title": "(監理敎會神學校) 神學世界 第24券 第3號",
        "book_title_ko": "(감리교회신학교) 신학세계 제24권 제3호",
        "publish_date": "1939.06.23",
        "publish_year": 1939,
        "publish_month": 6,
        "publish_day": 23,
        "publisher": "邊永瑞 新學世界 編輯部",
        "publisher_ko": "변영서 신학세계 편집부",
        "library": "연세대",
        "school_id": 52759,
        "primaryname": "監理敎會神學校",
        "primaryname_ko": "감리교회신학교"
    },
    {
        "book_id": 10363,
        "book_title": "(監理敎會神學校) 神學世界 第24券 第4號",
        "book_title_ko": "(감리교회신학교) 신학세계 제24권 제4호",
        "publish_date": "1939.09.15",
        "publish_year": 1939,
        "publish_month": 9,
        "publish_day": 15,
        "publisher": "邊永瑞 新學世界 編輯部",
        "publisher_ko": "변영서 신학세계 편집부",
        "library": "연세대",
        "school_id": 52759,
        "primaryname": "監理敎會神學校",
        "primaryname_ko": "감리교회신학교"
    },
    {
        "book_id": 10364,
        "book_title": "(監理敎會神學校) 神學世界 第25券 第1號",
        "book_title_ko": "(감리교회신학교) 신학세계 제25권 제1호",
        "publish_date": "1940.03.08",
        "publish_year": 1940,
        "publish_month": 3,
        "publish_day": 8,
        "publisher": "邊永瑞 新學世界 編輯部",
        "publisher_ko": "변영서 신학세계 편집부",
        "library": "국회도서관;연세대○",
        "school_id": 52759,
        "primaryname": "監理敎會神學校",
        "primaryname_ko": "감리교회신학교"
    },
    {
        "book_id": 10365,
        "book_title": "(監理敎會神學校) 神學世界 第25券 第2號 第146號 春季特輯",
        "book_title_ko": "(감리교회신학교) 신학세계 제25권 제2호 제146호 춘계특집",
        "publish_date": "1940.05.20",
        "publish_year": 1940,
        "publish_month": 5,
        "publish_day": 20,
        "publisher": "邊永瑞 新學世界 編輯部",
        "publisher_ko": "변영서 신학세계 편집부",
        "library": "연세대△",
        "school_id": 52759,
        "primaryname": "監理敎會神學校",
        "primaryname_ko": "감리교회신학교"
    },
    {
        "book_id": 10366,
        "book_title": "(監理敎會協成神學校) 神學世界 第8券 第1號",
        "book_title_ko": "(감리교회협성신학교) 신학세계 제8권 제1호",
        "publish_date": "1923.01.31",
        "publish_year": 1923,
        "publish_month": 1,
        "publish_day": 31,
        "publisher": "河鯉泳 新學世界 編輯部",
        "publisher_ko": "하리영 신학세계 편집부",
        "library": "국회도서관;연세대○",
        "school_id": 52757,
        "primaryname": "監理敎會協成神學校",
        "primaryname_ko": "감리교회협성신학교"
    },
    {
        "book_id": 10367,
        "book_title": "(監理敎會協成神學校) 神學世界 第8券 第5號",
        "book_title_ko": "(감리교회협성신학교) 신학세계 제8권 제5호",
        "publish_date": "1923.11.10",
        "publish_year": 1923,
        "publish_month": 11,
        "publish_day": 10,
        "publisher": "河鯉泳 新學世界 編輯部",
        "publisher_ko": "하리영 신학세계 편집부",
        "library": "국회도서관;연세대○",
        "school_id": 52757,
        "primaryname": "監理敎會協成神學校",
        "primaryname_ko": "감리교회협성신학교"
    },
    {
        "book_id": 10368,
        "book_title": "(監理敎會協成神學校) 神學世界 第9券 第2號",
        "book_title_ko": "(감리교회협성신학교) 신학세계 제9권 제2호",
        "publish_date": "1924.04.01",
        "publish_year": 1924,
        "publish_month": 4,
        "publish_day": 1,
        "publisher": "河鯉泳 新學世界 編輯部",
        "publisher_ko": "하리영 신학세계 편집부",
        "library": "국회도서관;연세대○",
        "school_id": 52757,
        "primaryname": "監理敎會協成神學校",
        "primaryname_ko": "감리교회협성신학교"
    },
    {
        "book_id": 10369,
        "book_title": "(儆新學校) 儆新 創刊號",
        "book_title_ko": "(경신학교) 경신 창간호",
        "publish_date": "1929.04.18",
        "publish_year": 1929,
        "publish_month": 4,
        "publish_day": 18,
        "publisher": "君芮彬= E.W. Koons 儆新學校 同窓會",
        "publisher_ko": "군예빈= E.W. Koons 경신학교 동창회",
        "library": "국립중앙도서관;서울대△",
        "school_id": 52760,
        "primaryname": "儆新學校",
        "primaryname_ko": "경신학교"
    },
    {
        "book_id": 10370,
        "book_title": "(大邱信明女學校) 信明 第1號",
        "book_title_ko": "(대구신명여학교) 신명 제1호",
        "publish_date": "1934.03.20",
        "publish_year": 1934,
        "publish_month": 3,
        "publish_day": 20,
        "publisher": "崔良熹 大邱信明女學校 校友會",
        "publisher_ko": "최량희 대구신명여학교 교우회",
        "library": "△",
        "school_id": 52761,
        "primaryname": "大邱信明女學校",
        "primaryname_ko": "대구신명여학교"
    },
    {
        "book_id": 10371,
        "book_title": "(東萊日新女學校) 日新 第10號",
        "book_title_ko": "(동래일신여학교) 일신 제10호",
        "publish_date": "1938.07.10",
        "publish_year": 1938,
        "publish_month": 7,
        "publish_day": 10,
        "publisher": "Margaret Davis 東萊日新女學校 校友會",
        "publisher_ko": "Margaret Davis 동래일신여학교 교우회",
        "library": "△",
        "school_id": 52762,
        "primaryname": "東萊日新女學校",
        "primaryname_ko": "동래일신여학교"
    },
    {
        "book_id": 10372,
        "book_title": "(崇實學校) 崇實學報 第1號",
        "book_title_ko": "(숭실학교) 숭실학보 제1호",
        "publish_date": "1915.09.10",
        "publish_year": 1915,
        "publish_month": 9,
        "publish_day": 10,
        "publisher": "裵緯良  崇實學校",
        "publisher_ko": "배위량  숭실학교",
        "library": "△",
        "school_id": 52938,
        "primaryname": "崇實學校",
        "primaryname_ko": "숭실학교"
    },
    {
        "book_id": 10372,
        "book_title": "(崇實學校) 崇實學報 第1號",
        "book_title_ko": "(숭실학교) 숭실학보 제1호",
        "publish_date": "1915.09.10",
        "publish_year": 1915,
        "publish_month": 9,
        "publish_day": 10,
        "publisher": "裵緯良  崇實學校",
        "publisher_ko": "배위량  숭실학교",
        "library": "△",
        "school_id": 52763,
        "primaryname": "崇實學校",
        "primaryname_ko": "숭실학교"
    },
    {
        "book_id": 10373,
        "book_title": "(崇實學校) 崇實學報 第2號",
        "book_title_ko": "(숭실학교) 숭실학보 제2호",
        "publish_date": "1917.06.11",
        "publish_year": 1917,
        "publish_month": 6,
        "publish_day": 11,
        "publisher": "羅道來=ライナト  崇實學校",
        "publisher_ko": "아도래=ライナト  숭실학교",
        "library": "△",
        "school_id": 52938,
        "primaryname": "崇實學校",
        "primaryname_ko": "숭실학교"
    },
    {
        "book_id": 10373,
        "book_title": "(崇實學校) 崇實學報 第2號",
        "book_title_ko": "(숭실학교) 숭실학보 제2호",
        "publish_date": "1917.06.11",
        "publish_year": 1917,
        "publish_month": 6,
        "publish_day": 11,
        "publisher": "羅道來=ライナト  崇實學校",
        "publisher_ko": "아도래=ライナト  숭실학교",
        "library": "△",
        "school_id": 52763,
        "primaryname": "崇實學校",
        "primaryname_ko": "숭실학교"
    },
    {
        "book_id": 10374,
        "book_title": "(崇實學校) 崇實活泉 第12號",
        "book_title_ko": "(숭실학교) 숭실활천 제12호",
        "publish_date": "1932.10.24",
        "publish_year": 1932,
        "publish_month": 10,
        "publish_day": 24,
        "publisher": "尹山溫 崇實大學學生 Y.M.C.A. 智育部",
        "publisher_ko": "윤산온 숭실대학학생 Y.M.C.A. 지육부",
        "library": "",
        "school_id": 52763,
        "primaryname": "崇實學校",
        "primaryname_ko": "숭실학교"
    },
    {
        "book_id": 10375,
        "book_title": "(崇實學校) 崇實活泉 第4號",
        "book_title_ko": "(숭실학교) 숭실활천 제4호",
        "publish_date": "1925.12.28",
        "publish_year": 1925,
        "publish_month": 12,
        "publish_day": 28,
        "publisher": "馬布三悅 崇實學校學生會",
        "publisher_ko": "마포삼열 숭실학교학생회",
        "library": "",
        "school_id": 52763,
        "primaryname": "崇實學校",
        "primaryname_ko": "숭실학교"
    },
    {
        "book_id": 10376,
        "book_title": "(義明學校) 義明 ",
        "book_title_ko": "(의명학교) 의명 ",
        "publish_date": "1920.00.00",
        "publish_year": 1920,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "義明學校",
        "publisher_ko": "의명학교",
        "library": "",
        "school_id": 27617,
        "primaryname": "義明學校",
        "primaryname_ko": "의명학교"
    },
    {
        "book_id": 10376,
        "book_title": "(義明學校) 義明 ",
        "book_title_ko": "(의명학교) 의명 ",
        "publish_date": "1920.00.00",
        "publish_year": 1920,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "義明學校",
        "publisher_ko": "의명학교",
        "library": "",
        "school_id": 52764,
        "primaryname": "義明學校",
        "primaryname_ko": "의명학교"
    },
    {
        "book_id": 10377,
        "book_title": "(義明學校) 義明 第2號",
        "book_title_ko": "(의명학교) 의명 제2호",
        "publish_date": "1931.04.13",
        "publish_year": 1931,
        "publish_month": 4,
        "publish_day": 13,
        "publisher": "東文吾 順安義明學校 校友會 文藝部",
        "publisher_ko": "동문오 순안의명학교 교우회 문예부",
        "library": "△",
        "school_id": 52764,
        "primaryname": "義明學校",
        "primaryname_ko": "의명학교"
    },
    {
        "book_id": 10378,
        "book_title": "(全州新興學校) 新興 第2號",
        "book_title_ko": "(전주신흥학교) 신흥 제2호",
        "publish_date": "1937.03.10",
        "publish_year": 1937,
        "publish_month": 3,
        "publish_day": 10,
        "publisher": "印敦 全州新興學校 希顯會",
        "publisher_ko": "인돈 전주신흥학교 희현회",
        "library": "국립중앙도서관○",
        "school_id": 52765,
        "primaryname": "全州新興學校",
        "primaryname_ko": "전주신흥학교"
    },
    {
        "book_id": 10379,
        "book_title": "(貞信女學校) 貞信 第2號",
        "book_title_ko": "(정신여학교) 정신 제2호",
        "publish_date": "1936.03.03",
        "publish_year": 1936,
        "publish_month": 3,
        "publish_day": 3,
        "publisher": "孫珍珠 貞信女學生基督敎靑年會",
        "publisher_ko": "손진주 정신여학생기독교청년회",
        "library": "○",
        "school_id": 52766,
        "primaryname": "貞信女學校",
        "primaryname_ko": "정신여학교"
    },
    {
        "book_id": 10380,
        "book_title": "(貞信女學校) 貞信 第3號",
        "book_title_ko": "(정신여학교) 정신 제3호",
        "publish_date": "1937.03.03",
        "publish_year": 1937,
        "publish_month": 3,
        "publish_day": 3,
        "publisher": "孫珍珠 貞信女學生基督敎靑年會",
        "publisher_ko": "손진주 정신여학생기독교청년회",
        "library": "○",
        "school_id": 52766,
        "primaryname": "貞信女學校",
        "primaryname_ko": "정신여학교"
    },
    {
        "book_id": 10381,
        "book_title": "(貞信女學校) 貞信 創刊號",
        "book_title_ko": "(정신여학교) 정신 창간호",
        "publish_date": "1935.03.20",
        "publish_year": 1935,
        "publish_month": 3,
        "publish_day": 20,
        "publisher": "孫珍珠 貞信女學生基督敎靑年會",
        "publisher_ko": "손진주 정신여학생기독교청년회",
        "library": "△",
        "school_id": 52766,
        "primaryname": "貞信女學校",
        "primaryname_ko": "정신여학교"
    },
    {
        "book_id": 10382,
        "book_title": "(朝鮮耶蘇敎長老敎神學校) 神學指南 ",
        "book_title_ko": "(조선야소교장로교신학교) 신학지남 ",
        "publish_date": "1918.00.00.",
        "publish_year": 1918,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "長老會神學校",
        "publisher_ko": "장로회신학교",
        "library": "국회도서관;DBpia",
        "school_id": 52939,
        "primaryname": "長老會神學校",
        "primaryname_ko": "장로회신학교"
    },
    {
        "book_id": 10382,
        "book_title": "(朝鮮耶蘇敎長老敎神學校) 神學指南 ",
        "book_title_ko": "(조선야소교장로교신학교) 신학지남 ",
        "publish_date": "1918.00.00.",
        "publish_year": 1918,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "長老會神學校",
        "publisher_ko": "장로회신학교",
        "library": "국회도서관;DBpia",
        "school_id": 52767,
        "primaryname": "朝鮮耶蘇敎長老敎神學校",
        "primaryname_ko": "조선야소교장로교신학교"
    },
    {
        "book_id": 10383,
        "book_title": "(朝鮮耶蘇敎長老敎神學校) 神學指南 ",
        "book_title_ko": "(조선야소교장로교신학교) 신학지남 ",
        "publish_date": "1919.00.00.",
        "publish_year": 1919,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "長老會神學校",
        "publisher_ko": "장로회신학교",
        "library": "국회도서관;DBpia",
        "school_id": 52939,
        "primaryname": "長老會神學校",
        "primaryname_ko": "장로회신학교"
    },
    {
        "book_id": 10383,
        "book_title": "(朝鮮耶蘇敎長老敎神學校) 神學指南 ",
        "book_title_ko": "(조선야소교장로교신학교) 신학지남 ",
        "publish_date": "1919.00.00.",
        "publish_year": 1919,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "長老會神學校",
        "publisher_ko": "장로회신학교",
        "library": "국회도서관;DBpia",
        "school_id": 52767,
        "primaryname": "朝鮮耶蘇敎長老敎神學校",
        "primaryname_ko": "조선야소교장로교신학교"
    },
    {
        "book_id": 10384,
        "book_title": "(朝鮮耶蘇敎長老敎神學校) 神學指南 ",
        "book_title_ko": "(조선야소교장로교신학교) 신학지남 ",
        "publish_date": "1920.00.00.",
        "publish_year": 1920,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "長老會神學校",
        "publisher_ko": "장로회신학교",
        "library": "국회도서관;DBpia",
        "school_id": 52939,
        "primaryname": "長老會神學校",
        "primaryname_ko": "장로회신학교"
    },
    {
        "book_id": 10384,
        "book_title": "(朝鮮耶蘇敎長老敎神學校) 神學指南 ",
        "book_title_ko": "(조선야소교장로교신학교) 신학지남 ",
        "publish_date": "1920.00.00.",
        "publish_year": 1920,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "長老會神學校",
        "publisher_ko": "장로회신학교",
        "library": "국회도서관;DBpia",
        "school_id": 52767,
        "primaryname": "朝鮮耶蘇敎長老敎神學校",
        "primaryname_ko": "조선야소교장로교신학교"
    },
    {
        "book_id": 10385,
        "book_title": "(朝鮮耶蘇敎長老敎神學校) 神學指南 ",
        "book_title_ko": "(조선야소교장로교신학교) 신학지남 ",
        "publish_date": "1921.00.00.",
        "publish_year": 1921,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "長老會神學校",
        "publisher_ko": "장로회신학교",
        "library": "국회도서관;DBpia",
        "school_id": 52939,
        "primaryname": "長老會神學校",
        "primaryname_ko": "장로회신학교"
    },
    {
        "book_id": 10385,
        "book_title": "(朝鮮耶蘇敎長老敎神學校) 神學指南 ",
        "book_title_ko": "(조선야소교장로교신학교) 신학지남 ",
        "publish_date": "1921.00.00.",
        "publish_year": 1921,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "長老會神學校",
        "publisher_ko": "장로회신학교",
        "library": "국회도서관;DBpia",
        "school_id": 52767,
        "primaryname": "朝鮮耶蘇敎長老敎神學校",
        "primaryname_ko": "조선야소교장로교신학교"
    },
    {
        "book_id": 10386,
        "book_title": "(朝鮮耶蘇敎長老敎神學校) 神學指南 ",
        "book_title_ko": "(조선야소교장로교신학교) 신학지남 ",
        "publish_date": "1922.00.00.",
        "publish_year": 1922,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "長老會神學校",
        "publisher_ko": "장로회신학교",
        "library": "국회도서관;DBpia",
        "school_id": 52939,
        "primaryname": "長老會神學校",
        "primaryname_ko": "장로회신학교"
    },
    {
        "book_id": 10386,
        "book_title": "(朝鮮耶蘇敎長老敎神學校) 神學指南 ",
        "book_title_ko": "(조선야소교장로교신학교) 신학지남 ",
        "publish_date": "1922.00.00.",
        "publish_year": 1922,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "長老會神學校",
        "publisher_ko": "장로회신학교",
        "library": "국회도서관;DBpia",
        "school_id": 52767,
        "primaryname": "朝鮮耶蘇敎長老敎神學校",
        "primaryname_ko": "조선야소교장로교신학교"
    },
    {
        "book_id": 10387,
        "book_title": "(朝鮮耶蘇敎長老敎神學校) 神學指南 ",
        "book_title_ko": "(조선야소교장로교신학교) 신학지남 ",
        "publish_date": "1927.00.00.",
        "publish_year": 1927,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "長老會神學校",
        "publisher_ko": "장로회신학교",
        "library": "국회도서관;DBpia",
        "school_id": 52939,
        "primaryname": "長老會神學校",
        "primaryname_ko": "장로회신학교"
    },
    {
        "book_id": 10387,
        "book_title": "(朝鮮耶蘇敎長老敎神學校) 神學指南 ",
        "book_title_ko": "(조선야소교장로교신학교) 신학지남 ",
        "publish_date": "1927.00.00.",
        "publish_year": 1927,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "長老會神學校",
        "publisher_ko": "장로회신학교",
        "library": "국회도서관;DBpia",
        "school_id": 52767,
        "primaryname": "朝鮮耶蘇敎長老敎神學校",
        "primaryname_ko": "조선야소교장로교신학교"
    },
    {
        "book_id": 10388,
        "book_title": "(朝鮮耶蘇敎長老敎神學校) 神學指南 ",
        "book_title_ko": "(조선야소교장로교신학교) 신학지남 ",
        "publish_date": "1928.00.00.",
        "publish_year": 1928,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "長老會神學校",
        "publisher_ko": "장로회신학교",
        "library": "국회도서관;DBpia",
        "school_id": 52939,
        "primaryname": "長老會神學校",
        "primaryname_ko": "장로회신학교"
    },
    {
        "book_id": 10388,
        "book_title": "(朝鮮耶蘇敎長老敎神學校) 神學指南 ",
        "book_title_ko": "(조선야소교장로교신학교) 신학지남 ",
        "publish_date": "1928.00.00.",
        "publish_year": 1928,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "長老會神學校",
        "publisher_ko": "장로회신학교",
        "library": "국회도서관;DBpia",
        "school_id": 52767,
        "primaryname": "朝鮮耶蘇敎長老敎神學校",
        "primaryname_ko": "조선야소교장로교신학교"
    },
    {
        "book_id": 10389,
        "book_title": "(朝鮮耶蘇敎長老敎神學校) 神學指南 ",
        "book_title_ko": "(조선야소교장로교신학교) 신학지남 ",
        "publish_date": "1934.00.00.",
        "publish_year": 1934,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "長老會神學校",
        "publisher_ko": "장로회신학교",
        "library": "국회도서관;DBpia",
        "school_id": 52939,
        "primaryname": "長老會神學校",
        "primaryname_ko": "장로회신학교"
    },
    {
        "book_id": 10389,
        "book_title": "(朝鮮耶蘇敎長老敎神學校) 神學指南 ",
        "book_title_ko": "(조선야소교장로교신학교) 신학지남 ",
        "publish_date": "1934.00.00.",
        "publish_year": 1934,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "長老會神學校",
        "publisher_ko": "장로회신학교",
        "library": "국회도서관;DBpia",
        "school_id": 52767,
        "primaryname": "朝鮮耶蘇敎長老敎神學校",
        "primaryname_ko": "조선야소교장로교신학교"
    },
    {
        "book_id": 10390,
        "book_title": "(朝鮮耶蘇敎長老敎神學校) 神學指南 ",
        "book_title_ko": "(조선야소교장로교신학교) 신학지남 ",
        "publish_date": "1936.00.00.",
        "publish_year": 1936,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "長老會神學校",
        "publisher_ko": "장로회신학교",
        "library": "국회도서관;DBpia",
        "school_id": 52939,
        "primaryname": "長老會神學校",
        "primaryname_ko": "장로회신학교"
    },
    {
        "book_id": 10390,
        "book_title": "(朝鮮耶蘇敎長老敎神學校) 神學指南 ",
        "book_title_ko": "(조선야소교장로교신학교) 신학지남 ",
        "publish_date": "1936.00.00.",
        "publish_year": 1936,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "長老會神學校",
        "publisher_ko": "장로회신학교",
        "library": "국회도서관;DBpia",
        "school_id": 52767,
        "primaryname": "朝鮮耶蘇敎長老敎神學校",
        "primaryname_ko": "조선야소교장로교신학교"
    },
    {
        "book_id": 10391,
        "book_title": "(朝鮮耶蘇敎長老敎神學校) 神學指南 ",
        "book_title_ko": "(조선야소교장로교신학교) 신학지남 ",
        "publish_date": "1937.00.00.",
        "publish_year": 1937,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "長老會神學校",
        "publisher_ko": "장로회신학교",
        "library": "국회도서관;DBpia",
        "school_id": 52939,
        "primaryname": "長老會神學校",
        "primaryname_ko": "장로회신학교"
    },
    {
        "book_id": 10391,
        "book_title": "(朝鮮耶蘇敎長老敎神學校) 神學指南 ",
        "book_title_ko": "(조선야소교장로교신학교) 신학지남 ",
        "publish_date": "1937.00.00.",
        "publish_year": 1937,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "長老會神學校",
        "publisher_ko": "장로회신학교",
        "library": "국회도서관;DBpia",
        "school_id": 52767,
        "primaryname": "朝鮮耶蘇敎長老敎神學校",
        "primaryname_ko": "조선야소교장로교신학교"
    },
    {
        "book_id": 10392,
        "book_title": "(朝鮮耶蘇敎長老敎神學校) 神學指南 ",
        "book_title_ko": "(조선야소교장로교신학교) 신학지남 ",
        "publish_date": "1938.00.00.",
        "publish_year": 1938,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "長老會神學校",
        "publisher_ko": "장로회신학교",
        "library": "국회도서관;DBpia",
        "school_id": 52939,
        "primaryname": "長老會神學校",
        "primaryname_ko": "장로회신학교"
    },
    {
        "book_id": 10392,
        "book_title": "(朝鮮耶蘇敎長老敎神學校) 神學指南 ",
        "book_title_ko": "(조선야소교장로교신학교) 신학지남 ",
        "publish_date": "1938.00.00.",
        "publish_year": 1938,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "長老會神學校",
        "publisher_ko": "장로회신학교",
        "library": "국회도서관;DBpia",
        "school_id": 52767,
        "primaryname": "朝鮮耶蘇敎長老敎神學校",
        "primaryname_ko": "조선야소교장로교신학교"
    },
    {
        "book_id": 10393,
        "book_title": "(朝鮮耶蘇敎長老敎神學校) 學友會報 第1號",
        "book_title_ko": "(조선야소교장로교신학교) 학우회보 제1호",
        "publish_date": "1923.01.01",
        "publish_year": 1923,
        "publish_month": 1,
        "publish_day": 1,
        "publisher": "朝鮮耶蘇敎長老敎神學校 學友會",
        "publisher_ko": "조선야소교장로교신학교 학우회",
        "library": "△",
        "school_id": 52768,
        "primaryname": "朝鮮耶蘇敎長老敎神學校",
        "primaryname_ko": "조선야소교장로회신학교"
    },
    {
        "book_id": 10394,
        "book_title": "(朝鮮耶蘇敎長老敎神學校) 學友會報 第2號",
        "book_title_ko": "(조선야소교장로교신학교) 학우회보 제2호",
        "publish_date": "1923.06.08",
        "publish_year": 1923,
        "publish_month": 6,
        "publish_day": 8,
        "publisher": "朝鮮耶蘇敎長老敎神學校 學友會",
        "publisher_ko": "조선야소교장로교신학교 학우회",
        "library": "△",
        "school_id": 52768,
        "primaryname": "朝鮮耶蘇敎長老敎神學校",
        "primaryname_ko": "조선야소교장로회신학교"
    },
    {
        "book_id": 10395,
        "book_title": "(協成學校) 協成 第1號",
        "book_title_ko": "(협성학교) 협성 제1호",
        "publish_date": "1925.12.15",
        "publish_year": 1925,
        "publish_month": 12,
        "publish_day": 15,
        "publisher": "朴玄寰 協成同窓會",
        "publisher_ko": "박현환 협성동창회",
        "library": "서강대○",
        "school_id": 52769,
        "primaryname": "協成學校",
        "primaryname_ko": "협성학교"
    },
    {
        "book_id": 10415,
        "book_title": "(京畿高等女學校) 慶雲 ",
        "book_title_ko": "(경기고등여학교) 경운 ",
        "publish_date": "1942.12.03",
        "publish_year": 1942,
        "publish_month": 12,
        "publish_day": 3,
        "publisher": "京畿公立高等女學校 慶雲會",
        "publisher_ko": "경기공립고등여학교 경운회",
        "library": "△",
        "school_id": 52780,
        "primaryname": "京畿高等女學校",
        "primaryname_ko": "경기고등여학교"
    },
    {
        "book_id": 10416,
        "book_title": "(京城第二高等女學校) ときは會志 ",
        "book_title_ko": "(경성제이고등여학교) ときは회지 ",
        "publish_date": "1940.00.00",
        "publish_year": 1940,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城第二高等女學校",
        "publisher_ko": "경성제이고등여학교",
        "library": "",
        "school_id": 27295,
        "primaryname": "京城第二高等女學校",
        "primaryname_ko": "경성제이고등여학교"
    },
    {
        "book_id": 10416,
        "book_title": "(京城第二高等女學校) ときは會志 ",
        "book_title_ko": "(경성제이고등여학교) ときは회지 ",
        "publish_date": "1940.00.00",
        "publish_year": 1940,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城第二高等女學校",
        "publisher_ko": "경성제이고등여학교",
        "library": "",
        "school_id": 52781,
        "primaryname": "京城第二高等女學校",
        "primaryname_ko": "경성제이고등여학교"
    },
    {
        "book_id": 10417,
        "book_title": "(同德高等女學校) 同德 第11號",
        "book_title_ko": "(동덕고등여학교) 동덕 제11호",
        "publish_date": "1939.03.20",
        "publish_year": 1939,
        "publish_month": 3,
        "publish_day": 20,
        "publisher": "辛島子路 同德學友會",
        "publisher_ko": "신도자로 동덕학우회",
        "library": "국회도서관○",
        "school_id": 52782,
        "primaryname": "同德高等女學校",
        "primaryname_ko": "동덕고등여학교"
    },
    {
        "book_id": 10418,
        "book_title": "(全州高等女學校) 梧陰 第18號",
        "book_title_ko": "(전주고등여학교) 오음 제18호",
        "publish_date": "1941.05.00",
        "publish_year": 1941,
        "publish_month": 5,
        "publish_day": 0,
        "publisher": "全州公立高等女學校 校友會",
        "publisher_ko": "전주공립고등여학교 교우회",
        "library": "",
        "school_id": 52783,
        "primaryname": "全州高等女學校",
        "primaryname_ko": "전주고등여학교"
    },
    {
        "book_id": 10419,
        "book_title": "(進明高等女學校) 進明 ",
        "book_title_ko": "(진명고등여학교) 진명 ",
        "publish_date": "1941.00.00",
        "publish_year": 1941,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "進明高等女學校",
        "publisher_ko": "진명고등여학교",
        "library": "",
        "school_id": 27355,
        "primaryname": "進明高等女學校",
        "primaryname_ko": "진명고등여학교"
    },
    {
        "book_id": 10419,
        "book_title": "(進明高等女學校) 進明 ",
        "book_title_ko": "(진명고등여학교) 진명 ",
        "publish_date": "1941.00.00",
        "publish_year": 1941,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "進明高等女學校",
        "publisher_ko": "진명고등여학교",
        "library": "",
        "school_id": 52784,
        "primaryname": "進明高等女學校",
        "primaryname_ko": "진명고등여학교"
    },
    {
        "book_id": 10420,
        "book_title": "(進明高等女學校) 進明 財團設立30週年 學校創立35週年 記念特輯",
        "book_title_ko": "(진명고등여학교) 진명 재단설립30주년 학교창립35주년 기념특집",
        "publish_date": "1942.04.22",
        "publish_year": 1942,
        "publish_month": 4,
        "publish_day": 22,
        "publisher": "岩元實  進明高等女學校",
        "publisher_ko": "암원실  진명고등여학교",
        "library": "한국학중앙연구원○",
        "school_id": 27355,
        "primaryname": "進明高等女學校",
        "primaryname_ko": "진명고등여학교"
    },
    {
        "book_id": 10420,
        "book_title": "(進明高等女學校) 進明 財團設立30週年 學校創立35週年 記念特輯",
        "book_title_ko": "(진명고등여학교) 진명 재단설립30주년 학교창립35주년 기념특집",
        "publish_date": "1942.04.22",
        "publish_year": 1942,
        "publish_month": 4,
        "publish_day": 22,
        "publisher": "岩元實  進明高等女學校",
        "publisher_ko": "암원실  진명고등여학교",
        "library": "한국학중앙연구원○",
        "school_id": 52784,
        "primaryname": "進明高等女學校",
        "primaryname_ko": "진명고등여학교"
    },
    {
        "book_id": 10421,
        "book_title": "(好壽敦高等女學校) 好鍾 第11號",
        "book_title_ko": "(호수돈고등여학교) 호종 제11호",
        "publish_date": "1941.00.00",
        "publish_year": 1941,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "好壽敦高等女學校 校友會",
        "publisher_ko": "호수돈고등여학교 교우회",
        "library": "",
        "school_id": 52785,
        "primaryname": "好壽敦高等女學校",
        "primaryname_ko": "호수돈고등여학교"
    },
    {
        "book_id": 10439,
        "book_title": "(京城第二高等普通學校) 校友會誌 第2號",
        "book_title_ko": "(경성제이고등보통학교) 교우회지 제2호",
        "publish_date": "1936.00.00",
        "publish_year": 1936,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城第二公立高等普通學校 校友會",
        "publisher_ko": "경성제이공립고등보통학교 교우회",
        "library": "",
        "school_id": 52800,
        "primaryname": "京城第二高等普通學校",
        "primaryname_ko": "경성제이고등보통학교"
    },
    {
        "book_id": 10440,
        "book_title": "(景福中學校) 校友會誌 第4號",
        "book_title_ko": "(경복중학교) 교우회지 제4호",
        "publish_date": "1938.03.03",
        "publish_year": 1938,
        "publish_month": 3,
        "publish_day": 3,
        "publisher": "木村竹治 景福公立中學校 校友會",
        "publisher_ko": "목촌죽치 경복공립중학교 교우회",
        "library": "국회도서관○",
        "school_id": 52801,
        "primaryname": "景福中學校",
        "primaryname_ko": "경복중학교"
    },
    {
        "book_id": 10441,
        "book_title": "(景福中學校) 校友會誌 第5號",
        "book_title_ko": "(경복중학교) 교우회지 제5호",
        "publish_date": "1939.03.04",
        "publish_year": 1939,
        "publish_month": 3,
        "publish_day": 4,
        "publisher": "笠松重雄 景福公立中學校 校友會",
        "publisher_ko": "입송중웅 경복공립중학교 교우회",
        "library": "국회도서관○",
        "school_id": 52801,
        "primaryname": "景福中學校",
        "primaryname_ko": "경복중학교"
    },
    {
        "book_id": 10442,
        "book_title": "(景福中學校) 校友會誌 第6號",
        "book_title_ko": "(경복중학교) 교우회지 제6호",
        "publish_date": "1940.04.10",
        "publish_year": 1940,
        "publish_month": 4,
        "publish_day": 10,
        "publisher": "笠松重雄 景福公立中學校 校友會",
        "publisher_ko": "입송중웅 경복공립중학교 교우회",
        "library": "국회도서관○",
        "school_id": 52801,
        "primaryname": "景福中學校",
        "primaryname_ko": "경복중학교"
    },
    {
        "book_id": 10443,
        "book_title": "(京城第二高等普通學校) 學友會誌 創刊號",
        "book_title_ko": "(경성제이고등보통학교) 학우회지 창간호",
        "publish_date": "1935.03.03",
        "publish_year": 1935,
        "publish_month": 3,
        "publish_day": 3,
        "publisher": "木村竹治 京城第二公立高等普通學校 學友會",
        "publisher_ko": "목촌죽치 경성제이공립고등보통학교 학우회",
        "library": "국회도서관○",
        "school_id": 52800,
        "primaryname": "京城第二高等普通學校",
        "primaryname_ko": "경성제이고등보통학교"
    },
    {
        "book_id": 10444,
        "book_title": "(京城第一高等普通學校) 學友會報 第3號 開校35週年記念號",
        "book_title_ko": "(경성제일고등보통학교) 학우회보 제3호 개교35주년기념호",
        "publish_date": "1936.04.10",
        "publish_year": 1936,
        "publish_month": 4,
        "publish_day": 10,
        "publisher": "增山凱馬 京城第一公立高等普通學校 學友會 會報部",
        "publisher_ko": "증산개마 경성제일공립고등보통학교 학우회 회보부",
        "library": "국회도서관;서강대○",
        "school_id": 52802,
        "primaryname": "京城第一高等普通學校",
        "primaryname_ko": "경성제일고등보통학교"
    },
    {
        "book_id": 10445,
        "book_title": "(京城第一高等普通學校) 學友會誌 第4號",
        "book_title_ko": "(경성제일고등보통학교) 학우회지 제4호",
        "publish_date": "1937.05.20",
        "publish_year": 1937,
        "publish_month": 5,
        "publish_day": 20,
        "publisher": "中江勝 京城第一公立高等普通學校 學友會 會報部",
        "publisher_ko": "중강승 경성제일공립고등보통학교 학우회 회보부",
        "library": "국회도서관○",
        "school_id": 52802,
        "primaryname": "京城第一高等普通學校",
        "primaryname_ko": "경성제일고등보통학교"
    },
    {
        "book_id": 10446,
        "book_title": "(京城第一高等普通學校) 學友會誌 第8號",
        "book_title_ko": "(경성제일고등보통학교) 학우회지 제8호",
        "publish_date": "1940.00.00",
        "publish_year": 1940,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城第一高等普通學校",
        "publisher_ko": "경성제일고등보통학교",
        "library": "",
        "school_id": 28175,
        "primaryname": "京城第一高等普通學校",
        "primaryname_ko": "경성제일고등보통학교;경기고등학교"
    },
    {
        "book_id": 10446,
        "book_title": "(京城第一高等普通學校) 學友會誌 第8號",
        "book_title_ko": "(경성제일고등보통학교) 학우회지 제8호",
        "publish_date": "1940.00.00",
        "publish_year": 1940,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城第一高等普通學校",
        "publisher_ko": "경성제일고등보통학교",
        "library": "",
        "school_id": 52802,
        "primaryname": "京城第一高等普通學校",
        "primaryname_ko": "경성제일고등보통학교"
    },
    {
        "book_id": 10447,
        "book_title": "(京城第一高等普通學校) 學友會誌 創刊號",
        "book_title_ko": "(경성제일고등보통학교) 학우회지 창간호",
        "publish_date": "1934.00.00",
        "publish_year": 1934,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城第一高等普通學校 學友會 會報部",
        "publisher_ko": "경성제일고등보통학교 학우회 회보부",
        "library": "",
        "school_id": 52802,
        "primaryname": "京城第一高等普通學校",
        "primaryname_ko": "경성제일고등보통학교"
    },
    {
        "book_id": 10448,
        "book_title": "(京城第一高等普通學校) 向上 第5號",
        "book_title_ko": "(경성제일고등보통학교) 향상 제5호",
        "publish_date": "1937.00.00",
        "publish_year": 1937,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城第一高等普通學校 學藝部",
        "publisher_ko": "경성제일고등보통학교 학예부",
        "library": "",
        "school_id": 52802,
        "primaryname": "京城第一高等普通學校",
        "primaryname_ko": "경성제일고등보통학교"
    },
    {
        "book_id": 10449,
        "book_title": "(高敞高等普通學校) 高敞 第10號",
        "book_title_ko": "(고창고등보통학교) 고창 제10호",
        "publish_date": "1935.06.14",
        "publish_year": 1935,
        "publish_month": 6,
        "publish_day": 14,
        "publisher": "金宗洽 高敞高等普通學校 學友會",
        "publisher_ko": "금종흡 고창고등보통학교 학우회",
        "library": "국립중앙도서관",
        "school_id": 52803,
        "primaryname": "高敞高等普通學校",
        "primaryname_ko": "고창고등보통학교"
    },
    {
        "book_id": 10450,
        "book_title": "(高敞高等普通學校) 學友會報 第3號",
        "book_title_ko": "(고창고등보통학교) 학우회보 제3호",
        "publish_date": "1927.00.00",
        "publish_year": 1927,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "高敞高等普通學校 學友會",
        "publisher_ko": "고창고등보통학교 학우회",
        "library": "",
        "school_id": 52803,
        "primaryname": "高敞高等普通學校",
        "primaryname_ko": "고창고등보통학교"
    },
    {
        "book_id": 10451,
        "book_title": "(高敞高等普通學校) 學友會報 第9號",
        "book_title_ko": "(고창고등보통학교) 학우회보 제9호",
        "publish_date": "1934.00.00",
        "publish_year": 1934,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "高敞高等普通學校 學友會",
        "publisher_ko": "고창고등보통학교 학우회",
        "library": "",
        "school_id": 52803,
        "primaryname": "高敞高等普通學校",
        "primaryname_ko": "고창고등보통학교"
    },
    {
        "book_id": 10452,
        "book_title": "(公州高等普通學校) 校友會誌 ",
        "book_title_ko": "(공주고등보통학교) 교우회지 ",
        "publish_date": "1935.00.00",
        "publish_year": 1935,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "公州公立高等普通學校 校友會",
        "publisher_ko": "공주공립고등보통학교 교우회",
        "library": "",
        "school_id": 52804,
        "primaryname": "公州高等普通學校",
        "primaryname_ko": "공주고등보통학교"
    },
    {
        "book_id": 10453,
        "book_title": "(公州高等普通學校) 校友會誌 創刊號",
        "book_title_ko": "(공주고등보통학교) 교우회지 창간호",
        "publish_date": "1927.04.10",
        "publish_year": 1927,
        "publish_month": 4,
        "publish_day": 10,
        "publisher": "公州高等普通學校 校友會",
        "publisher_ko": "공주고등보통학교 교우회",
        "library": "△",
        "school_id": 52804,
        "primaryname": "公州高等普通學校",
        "primaryname_ko": "공주고등보통학교"
    },
    {
        "book_id": 10454,
        "book_title": "(公州高等普通學校) 校友會誌 충남토속자료호",
        "book_title_ko": "(공주고등보통학교) 교우회지 충남토속자료호",
        "publish_date": "1935.00.00",
        "publish_year": 1935,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "公州高等普通學校 校友會",
        "publisher_ko": "공주고등보통학교 교우회",
        "library": "",
        "school_id": 52804,
        "primaryname": "公州高等普通學校",
        "primaryname_ko": "공주고등보통학교"
    },
    {
        "book_id": 10455,
        "book_title": "(光成高等普通學校) 光成 第12號",
        "book_title_ko": "(광성고등보통학교) 광성 제12호",
        "publish_date": "1938.03.05",
        "publish_year": 1938,
        "publish_month": 3,
        "publish_day": 5,
        "publisher": "平壤光成高等普通學校 YMCA 智育部",
        "publisher_ko": "평양광성고등보통학교 YMCA 지육부",
        "library": "△",
        "school_id": 52805,
        "primaryname": "光成高等普通學校",
        "primaryname_ko": "광성고등보통학교"
    },
    {
        "book_id": 10456,
        "book_title": "(光成高等普通學校) 光成 第13號",
        "book_title_ko": "(광성고등보통학교) 광성 제13호",
        "publish_date": "1939.12.01",
        "publish_year": 1939,
        "publish_month": 12,
        "publish_day": 1,
        "publisher": "平壤光成高等普通學校 學友會",
        "publisher_ko": "평양광성고등보통학교 학우회",
        "library": "",
        "school_id": 52805,
        "primaryname": "光成高等普通學校",
        "primaryname_ko": "광성고등보통학교"
    },
    {
        "book_id": 10457,
        "book_title": "(光成高等普通學校) 光成 第2號",
        "book_title_ko": "(광성고등보통학교) 광성 제2호",
        "publish_date": "1925.04.18",
        "publish_year": 1925,
        "publish_month": 4,
        "publish_day": 18,
        "publisher": "平壤光成高等普通學校 學友會",
        "publisher_ko": "평양광성고등보통학교 학우회",
        "library": "△",
        "school_id": 52805,
        "primaryname": "光成高等普通學校",
        "primaryname_ko": "광성고등보통학교"
    },
    {
        "book_id": 10458,
        "book_title": "(光成高等普通學校) 光成 第8號",
        "book_title_ko": "(광성고등보통학교) 광성 제8호",
        "publish_date": "1934.02.20",
        "publish_year": 1934,
        "publish_month": 2,
        "publish_day": 20,
        "publisher": "森口收 平壤光成高等普通學校 YMCA 智育部",
        "publisher_ko": "삼구수 평양광성고등보통학교 YMCA 지육부",
        "library": "△",
        "school_id": 52805,
        "primaryname": "光成高等普通學校",
        "primaryname_ko": "광성고등보통학교"
    },
    {
        "book_id": 10459,
        "book_title": "(光州高等普通學校) 校友會誌 第4號",
        "book_title_ko": "(광주고등보통학교) 교우회지 제4호",
        "publish_date": "1929.02.20",
        "publish_year": 1929,
        "publish_month": 2,
        "publish_day": 20,
        "publisher": "渡邊三吉 光州高等普通學校 校友會",
        "publisher_ko": "도변삼길 광주고등보통학교 교우회",
        "library": "○",
        "school_id": 52806,
        "primaryname": "光州高等普通學校",
        "primaryname_ko": "광성고등보통학교"
    },
    {
        "book_id": 10460,
        "book_title": "(光州高等普通學校) 校友會誌 第4號",
        "book_title_ko": "(광주고등보통학교) 교우회지 제4호",
        "publish_date": "1929.02.25",
        "publish_year": 1929,
        "publish_month": 2,
        "publish_day": 25,
        "publisher": "光州公立高等普通學校",
        "publisher_ko": "광주공립고등보통학교",
        "library": "",
        "school_id": 52956,
        "primaryname": "光州公立高等普通學校",
        "primaryname_ko": "광주공립고등보통학교"
    },
    {
        "book_id": 10460,
        "book_title": "(光州高等普通學校) 校友會誌 第4號",
        "book_title_ko": "(광주고등보통학교) 교우회지 제4호",
        "publish_date": "1929.02.25",
        "publish_year": 1929,
        "publish_month": 2,
        "publish_day": 25,
        "publisher": "光州公立高等普通學校",
        "publisher_ko": "광주공립고등보통학교",
        "library": "",
        "school_id": 52807,
        "primaryname": "光州高等普通學校",
        "primaryname_ko": "광주고등보통학교"
    },
    {
        "book_id": 10461,
        "book_title": "(大邱高等普通學校) 校友會誌 第10號",
        "book_title_ko": "(대구고등보통학교) 교우회지 제10호",
        "publish_date": "1935.00.00",
        "publish_year": 1935,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "大邱高等普通學校 校友會",
        "publisher_ko": "대구고등보통학교 교우회",
        "library": "",
        "school_id": 52808,
        "primaryname": "大邱高等普通學校",
        "primaryname_ko": "대구고등보통학교"
    },
    {
        "book_id": 10462,
        "book_title": "(大邱高等普通學校) 校友會誌 第11號",
        "book_title_ko": "(대구고등보통학교) 교우회지 제11호",
        "publish_date": "........",
        "publish_year": 0,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "大邱高等普通學校 校友會",
        "publisher_ko": "대구고등보통학교 교우회",
        "library": "",
        "school_id": 52808,
        "primaryname": "大邱高等普通學校",
        "primaryname_ko": "대구고등보통학교"
    },
    {
        "book_id": 10463,
        "book_title": "(大邱高等普通學校) 校友會誌 第12號",
        "book_title_ko": "(대구고등보통학교) 교우회지 제12호",
        "publish_date": "........",
        "publish_year": 0,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "大邱高等普通學校 校友會",
        "publisher_ko": "대구고등보통학교 교우회",
        "library": "",
        "school_id": 52808,
        "primaryname": "大邱高等普通學校",
        "primaryname_ko": "대구고등보통학교"
    },
    {
        "book_id": 10464,
        "book_title": "(大邱高等普通學校) 校友會誌 第13號",
        "book_title_ko": "(대구고등보통학교) 교우회지 제13호",
        "publish_date": "1939.00.00",
        "publish_year": 1939,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "大邱高等普通學校 校友會",
        "publisher_ko": "대구고등보통학교 교우회",
        "library": "",
        "school_id": 52808,
        "primaryname": "大邱高等普通學校",
        "primaryname_ko": "대구고등보통학교"
    },
    {
        "book_id": 10465,
        "book_title": "(大邱高等普通學校) 校友會誌 第1號",
        "book_title_ko": "(대구고등보통학교) 교우회지 제1호",
        "publish_date": "1926.00.00",
        "publish_year": 1926,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "大邱高等普通學校 校友會",
        "publisher_ko": "대구고등보통학교 교우회",
        "library": "",
        "school_id": 52808,
        "primaryname": "大邱高等普通學校",
        "primaryname_ko": "대구고등보통학교"
    },
    {
        "book_id": 10466,
        "book_title": "(大邱高等普通學校) 校友會誌 第6號",
        "book_title_ko": "(대구고등보통학교) 교우회지 제6호",
        "publish_date": "1931.00.00",
        "publish_year": 1931,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "大邱高等普通學校 校友會",
        "publisher_ko": "대구고등보통학교 교우회",
        "library": "",
        "school_id": 52808,
        "primaryname": "大邱高等普通學校",
        "primaryname_ko": "대구고등보통학교"
    },
    {
        "book_id": 10467,
        "book_title": "(大邱高等普通學校) 校友會誌 第7號",
        "book_title_ko": "(대구고등보통학교) 교우회지 제7호",
        "publish_date": "1932.12.13",
        "publish_year": 1932,
        "publish_month": 12,
        "publish_day": 13,
        "publisher": "廣瀨成之 大邱高等普通學校 校友會",
        "publisher_ko": "광뢰성지 대구고등보통학교 교우회",
        "library": "△",
        "school_id": 52808,
        "primaryname": "大邱高等普通學校",
        "primaryname_ko": "대구고등보통학교"
    },
    {
        "book_id": 10468,
        "book_title": "(大邱高等普通學校) 校友會誌 第8號",
        "book_title_ko": "(대구고등보통학교) 교우회지 제8호",
        "publish_date": "1933.00.00",
        "publish_year": 1933,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "大邱高等普通學校 校友會",
        "publisher_ko": "대구고등보통학교 교우회",
        "library": "",
        "school_id": 52808,
        "primaryname": "大邱高等普通學校",
        "primaryname_ko": "대구고등보통학교"
    },
    {
        "book_id": 10469,
        "book_title": "(培材高等普通學校) 培材 第11號",
        "book_title_ko": "(배재고등보통학교) 배재 제11호",
        "publish_date": "1928.03.05",
        "publish_year": 1928,
        "publish_month": 3,
        "publish_day": 5,
        "publisher": "亞扁薛羅 培材學生基督靑年會",
        "publisher_ko": "아편설라 배재학생기독청년회",
        "library": "국회도서관○",
        "school_id": 52809,
        "primaryname": "培材高等普通學校",
        "primaryname_ko": "배재고등보통학교"
    },
    {
        "book_id": 10470,
        "book_title": "(培材高等普通學校) 培材 第14號",
        "book_title_ko": "(배재고등보통학교) 배재 제14호",
        "publish_date": "1932.00.00",
        "publish_year": 1932,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "培材學生靑年會",
        "publisher_ko": "배재학생청년회",
        "library": "",
        "school_id": 52809,
        "primaryname": "培材高等普通學校",
        "primaryname_ko": "배재고등보통학교"
    },
    {
        "book_id": 10471,
        "book_title": "(培材高等普通學校) 培材 第15號",
        "book_title_ko": "(배재고등보통학교) 배재 제15호",
        "publish_date": "1933.00.00",
        "publish_year": 1933,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "培材學生靑年會",
        "publisher_ko": "배재학생청년회",
        "library": "",
        "school_id": 52809,
        "primaryname": "培材高等普通學校",
        "primaryname_ko": "배재고등보통학교"
    },
    {
        "book_id": 10472,
        "book_title": "(培材高等普通學校) 培材 第16號",
        "book_title_ko": "(배재고등보통학교) 배재 제16호",
        "publish_date": "1934.00.00",
        "publish_year": 1934,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "培材學生靑年會",
        "publisher_ko": "배재학생청년회",
        "library": "",
        "school_id": 52809,
        "primaryname": "培材高等普通學校",
        "primaryname_ko": "배재고등보통학교"
    },
    {
        "book_id": 10473,
        "book_title": "(培材高等普通學校) 培材 第17號",
        "book_title_ko": "(배재고등보통학교) 배재 제17호",
        "publish_date": "1935.07.18",
        "publish_year": 1935,
        "publish_month": 7,
        "publish_day": 18,
        "publisher": "培材學生靑年會",
        "publisher_ko": "배재학생청년회",
        "library": "",
        "school_id": 52809,
        "primaryname": "培材高等普通學校",
        "primaryname_ko": "배재고등보통학교"
    },
    {
        "book_id": 10474,
        "book_title": "(培材高等普通學校) 培材 第3號",
        "book_title_ko": "(배재고등보통학교) 배재 제3호",
        "publish_date": "1923.00.00",
        "publish_year": 1923,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "培材學生靑年會",
        "publisher_ko": "배재학생청년회",
        "library": "",
        "school_id": 52809,
        "primaryname": "培材高等普通學校",
        "primaryname_ko": "배재고등보통학교"
    },
    {
        "book_id": 10475,
        "book_title": "(培材高等普通學校) 培材 第5號",
        "book_title_ko": "(배재고등보통학교) 배재 제5호",
        "publish_date": "1924.03.22",
        "publish_year": 1924,
        "publish_month": 3,
        "publish_day": 22,
        "publisher": "白雅悳 培材學生基督靑年會",
        "publisher_ko": "백아덕 배재학생기독청년회",
        "library": "서강대○",
        "school_id": 52809,
        "primaryname": "培材高等普通學校",
        "primaryname_ko": "배재고등보통학교"
    },
    {
        "book_id": 10476,
        "book_title": "(培材高等普通學校) 培材 第8號",
        "book_title_ko": "(배재고등보통학교) 배재 제8호",
        "publish_date": "1925.00.00",
        "publish_year": 1925,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "培材學生靑年會",
        "publisher_ko": "배재학생청년회",
        "library": "",
        "school_id": 52809,
        "primaryname": "培材高等普通學校",
        "primaryname_ko": "배재고등보통학교"
    },
    {
        "book_id": 10477,
        "book_title": "(培材高等普通學校) 培材 創刊號",
        "book_title_ko": "(배재고등보통학교) 배재 창간호",
        "publish_date": "1922.11.01",
        "publish_year": 1922,
        "publish_month": 11,
        "publish_day": 1,
        "publisher": "亞扁薛羅 培材學生靑年會",
        "publisher_ko": "아편설라 배재학생청년회",
        "library": "○",
        "school_id": 52809,
        "primaryname": "培材高等普通學校",
        "primaryname_ko": "배재고등보통학교"
    },
    {
        "book_id": 10478,
        "book_title": "(培材高等普通學校) 培材學報 第2號",
        "book_title_ko": "(배재고등보통학교) 배재학보 제2호",
        "publish_date": "1921.04.25",
        "publish_year": 1921,
        "publish_month": 4,
        "publish_day": 25,
        "publisher": "羅慶孫 培材學報社",
        "publisher_ko": "아경손 배재학보사",
        "library": "서강대○",
        "school_id": 52809,
        "primaryname": "培材高等普通學校",
        "primaryname_ko": "배재고등보통학교"
    },
    {
        "book_id": 10479,
        "book_title": "(普成高等普通學校) 普成 第1號",
        "book_title_ko": "(보성고등보통학교) 보성 제1호",
        "publish_date": "1935.03.01",
        "publish_year": 1935,
        "publish_month": 3,
        "publish_day": 1,
        "publisher": "普成高等普通學校",
        "publisher_ko": "보성고등보통학교",
        "library": "",
        "school_id": 19029,
        "primaryname": "普成高等普通學校",
        "primaryname_ko": "보성고등보통학교"
    },
    {
        "book_id": 10479,
        "book_title": "(普成高等普通學校) 普成 第1號",
        "book_title_ko": "(보성고등보통학교) 보성 제1호",
        "publish_date": "1935.03.01",
        "publish_year": 1935,
        "publish_month": 3,
        "publish_day": 1,
        "publisher": "普成高等普通學校",
        "publisher_ko": "보성고등보통학교",
        "library": "",
        "school_id": 52810,
        "primaryname": "普成高等普通學校",
        "primaryname_ko": "보성고등보통학교"
    },
    {
        "book_id": 10480,
        "book_title": "(普成高等普通學校) 普成 第2號",
        "book_title_ko": "(보성고등보통학교) 보성 제2호",
        "publish_date": "1936.00.00",
        "publish_year": 1936,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "普成高等普通學校",
        "publisher_ko": "보성고등보통학교",
        "library": "",
        "school_id": 19029,
        "primaryname": "普成高等普通學校",
        "primaryname_ko": "보성고등보통학교"
    },
    {
        "book_id": 10480,
        "book_title": "(普成高等普通學校) 普成 第2號",
        "book_title_ko": "(보성고등보통학교) 보성 제2호",
        "publish_date": "1936.00.00",
        "publish_year": 1936,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "普成高等普通學校",
        "publisher_ko": "보성고등보통학교",
        "library": "",
        "school_id": 52810,
        "primaryname": "普成高等普通學校",
        "primaryname_ko": "보성고등보통학교"
    },
    {
        "book_id": 10481,
        "book_title": "(普成高等普通學校) 普成 第3號",
        "book_title_ko": "(보성고등보통학교) 보성 제3호",
        "publish_date": "1937.00.00",
        "publish_year": 1937,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "普成高等普通學校",
        "publisher_ko": "보성고등보통학교",
        "library": "",
        "school_id": 19029,
        "primaryname": "普成高等普通學校",
        "primaryname_ko": "보성고등보통학교"
    },
    {
        "book_id": 10481,
        "book_title": "(普成高等普通學校) 普成 第3號",
        "book_title_ko": "(보성고등보통학교) 보성 제3호",
        "publish_date": "1937.00.00",
        "publish_year": 1937,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "普成高等普通學校",
        "publisher_ko": "보성고등보통학교",
        "library": "",
        "school_id": 52810,
        "primaryname": "普成高等普通學校",
        "primaryname_ko": "보성고등보통학교"
    },
    {
        "book_id": 10482,
        "book_title": "(普成高等普通學校) 普成 第4號",
        "book_title_ko": "(보성고등보통학교) 보성 제4호",
        "publish_date": "1938.00.00",
        "publish_year": 1938,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "普成高等普通學校",
        "publisher_ko": "보성고등보통학교",
        "library": "",
        "school_id": 19029,
        "primaryname": "普成高等普通學校",
        "primaryname_ko": "보성고등보통학교"
    },
    {
        "book_id": 10482,
        "book_title": "(普成高等普通學校) 普成 第4號",
        "book_title_ko": "(보성고등보통학교) 보성 제4호",
        "publish_date": "1938.00.00",
        "publish_year": 1938,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "普成高等普通學校",
        "publisher_ko": "보성고등보통학교",
        "library": "",
        "school_id": 52810,
        "primaryname": "普成高等普通學校",
        "primaryname_ko": "보성고등보통학교"
    },
    {
        "book_id": 10483,
        "book_title": "(普成高等普通學校) 普成校友會報 第1號 母校創立15週年紀念",
        "book_title_ko": "(보성고등보통학교) 보성교우회보 제1호 모교창립15주년기념",
        "publish_date": "1921.07.02",
        "publish_year": 1921,
        "publish_month": 7,
        "publish_day": 2,
        "publisher": "鄭大鉉 普成高等普通學校 校友會",
        "publisher_ko": "정대현 보성고등보통학교 교우회",
        "library": "○",
        "school_id": 52810,
        "primaryname": "普成高等普通學校",
        "primaryname_ko": "보성고등보통학교"
    },
    {
        "book_id": 10484,
        "book_title": "(普成高等普通學校) 而習 創刊號",
        "book_title_ko": "(보성고등보통학교) 이습 창간호",
        "publish_date": "1928.03.10",
        "publish_year": 1928,
        "publish_month": 3,
        "publish_day": 10,
        "publisher": "田口貢 普成高等普通學校 而習會 文藝部",
        "publisher_ko": "전구공 보성고등보통학교 이습회 문예부",
        "library": "서울대",
        "school_id": 52810,
        "primaryname": "普成高等普通學校",
        "primaryname_ko": "보성고등보통학교"
    },
    {
        "book_id": 10485,
        "book_title": "(松都高等普通學校) 松都同窓會報 創刊號",
        "book_title_ko": "(송도고등보통학교) 송도동창회보 창간호",
        "publish_date": "1922.00.00",
        "publish_year": 1922,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "松都高等普通學校 同窓會",
        "publisher_ko": "송도고등보통학교 동창회",
        "library": "△",
        "school_id": 52811,
        "primaryname": "松都高等普通學校",
        "primaryname_ko": "송도고등보통학교"
    },
    {
        "book_id": 10486,
        "book_title": "(松都高等普通學校) 松友 第10號",
        "book_title_ko": "(송도고등보통학교) 송우 제10호",
        "publish_date": "1937.03.03",
        "publish_year": 1937,
        "publish_month": 3,
        "publish_day": 3,
        "publisher": "金俊玉 松都高等普通學校 校友會",
        "publisher_ko": "금준옥 송도고등보통학교 교우회",
        "library": "국회도서관○",
        "school_id": 52811,
        "primaryname": "松都高等普通學校",
        "primaryname_ko": "송도고등보통학교"
    },
    {
        "book_id": 10487,
        "book_title": "(松都高等普通學校) 松友 第13號",
        "book_title_ko": "(송도고등보통학교) 송우 제13호",
        "publish_date": "1941.00.00",
        "publish_year": 1941,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "松都高等普通學校 校友會",
        "publisher_ko": "송도고등보통학교 교우회",
        "library": "",
        "school_id": 52811,
        "primaryname": "松都高等普通學校",
        "primaryname_ko": "송도고등보통학교"
    },
    {
        "book_id": 10488,
        "book_title": "(松都高等普通學校) 松友 第1號",
        "book_title_ko": "(송도고등보통학교) 송우 제1호",
        "publish_date": "1925.00.00",
        "publish_year": 1925,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "松都高等普通學校 校友會",
        "publisher_ko": "송도고등보통학교 교우회",
        "library": "",
        "school_id": 52811,
        "primaryname": "松都高等普通學校",
        "primaryname_ko": "송도고등보통학교"
    },
    {
        "book_id": 10489,
        "book_title": "(松都高等普通學校) 松友 第7號",
        "book_title_ko": "(송도고등보통학교) 송우 제7호",
        "publish_date": "1933.03.18",
        "publish_year": 1933,
        "publish_month": 3,
        "publish_day": 18,
        "publisher": "李瑄根 松都高等普通學校 校友會 學藝部",
        "publisher_ko": "이선근 송도고등보통학교 교우회 학예부",
        "library": "△",
        "school_id": 52811,
        "primaryname": "松都高等普通學校",
        "primaryname_ko": "송도고등보통학교"
    },
    {
        "book_id": 10490,
        "book_title": "(松都高等普通學校) 松友 第9號",
        "book_title_ko": "(송도고등보통학교) 송우 제9호",
        "publish_date": "1936.00.00",
        "publish_year": 1936,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "松都高等普通學校 校友會",
        "publisher_ko": "송도고등보통학교 교우회",
        "library": "",
        "school_id": 52811,
        "primaryname": "松都高等普通學校",
        "primaryname_ko": "송도고등보통학교"
    },
    {
        "book_id": 10491,
        "book_title": "(新義州高等普通學校) 會誌 第2號",
        "book_title_ko": "(신의주고등보통학교) 회지 제2호",
        "publish_date": "1934.03.25",
        "publish_year": 1934,
        "publish_month": 3,
        "publish_day": 25,
        "publisher": "新義州高等普通學校 校友會",
        "publisher_ko": "신의주고등보통학교 교우회",
        "library": "△",
        "school_id": 52812,
        "primaryname": "新義州高等普通學校",
        "primaryname_ko": "신의주고등보통학교"
    },
    {
        "book_id": 10492,
        "book_title": "(養正高等普通學校) 養正 第10號",
        "book_title_ko": "(양정고등보통학교) 양정 제10호",
        "publish_date": "1933.12.30",
        "publish_year": 1933,
        "publish_month": 12,
        "publish_day": 30,
        "publisher": "養正高等普通學校 校友會",
        "publisher_ko": "양정고등보통학교 교우회",
        "library": "",
        "school_id": 52813,
        "primaryname": "養正高等普通學校",
        "primaryname_ko": "양정고등보통학교"
    },
    {
        "book_id": 10493,
        "book_title": "(養正高等普通學校) 養正 第11號",
        "book_title_ko": "(양정고등보통학교) 양정 제11호",
        "publish_date": "1934.00.00",
        "publish_year": 1934,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "養正高等普通學校 校友會",
        "publisher_ko": "양정고등보통학교 교우회",
        "library": "",
        "school_id": 52813,
        "primaryname": "養正高等普通學校",
        "primaryname_ko": "양정고등보통학교"
    },
    {
        "book_id": 10494,
        "book_title": "(養正高等普通學校) 養正 第12號",
        "book_title_ko": "(양정고등보통학교) 양정 제12호",
        "publish_date": "1935.12.26",
        "publish_year": 1935,
        "publish_month": 12,
        "publish_day": 26,
        "publisher": "磯部百三 養正高等普通學校 校友會",
        "publisher_ko": "기부백삼 양정고등보통학교 교우회",
        "library": "△",
        "school_id": 52813,
        "primaryname": "養正高等普通學校",
        "primaryname_ko": "양정고등보통학교"
    },
    {
        "book_id": 10495,
        "book_title": "(養正高等普通學校) 養正 第13號",
        "book_title_ko": "(양정고등보통학교) 양정 제13호",
        "publish_date": "1936.00.00",
        "publish_year": 1936,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "養正高等普通學校 校友會",
        "publisher_ko": "양정고등보통학교 교우회",
        "library": "",
        "school_id": 52813,
        "primaryname": "養正高等普通學校",
        "primaryname_ko": "양정고등보통학교"
    },
    {
        "book_id": 10496,
        "book_title": "(養正高等普通學校) 養正 第14號",
        "book_title_ko": "(양정고등보통학교) 양정 제14호",
        "publish_date": "1937.12.22",
        "publish_year": 1937,
        "publish_month": 12,
        "publish_day": 22,
        "publisher": "稻見俊次 養正高等普通學校 校友會",
        "publisher_ko": "도견준차 양정고등보통학교 교우회",
        "library": "△",
        "school_id": 52813,
        "primaryname": "養正高等普通學校",
        "primaryname_ko": "양정고등보통학교"
    },
    {
        "book_id": 10497,
        "book_title": "(養正高等普通學校) 養正 第1號",
        "book_title_ko": "(양정고등보통학교) 양정 제1호",
        "publish_date": "1924.00.00",
        "publish_year": 1924,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "養正高等普通學校 校友會",
        "publisher_ko": "양정고등보통학교 교우회",
        "library": "",
        "school_id": 52813,
        "primaryname": "養正高等普通學校",
        "primaryname_ko": "양정고등보통학교"
    },
    {
        "book_id": 10498,
        "book_title": "(養正高等普通學校) 養正 第2號",
        "book_title_ko": "(양정고등보통학교) 양정 제2호",
        "publish_date": "1925.12.19",
        "publish_year": 1925,
        "publish_month": 12,
        "publish_day": 19,
        "publisher": "養正高等普通學校 校友會",
        "publisher_ko": "양정고등보통학교 교우회",
        "library": "",
        "school_id": 52813,
        "primaryname": "養正高等普通學校",
        "primaryname_ko": "양정고등보통학교"
    },
    {
        "book_id": 10499,
        "book_title": "(養正高等普通學校) 養正 第6號",
        "book_title_ko": "(양정고등보통학교) 양정 제6호",
        "publish_date": "1930.02.25",
        "publish_year": 1930,
        "publish_month": 2,
        "publish_day": 25,
        "publisher": "磯部百三 養正高等普通學校 校友會",
        "publisher_ko": "기부백삼 양정고등보통학교 교우회",
        "library": "국립중앙도서관;서강대○",
        "school_id": 52813,
        "primaryname": "養正高等普通學校",
        "primaryname_ko": "양정고등보통학교"
    },
    {
        "book_id": 10500,
        "book_title": "(養正高等普通學校) 養正 第7號",
        "book_title_ko": "(양정고등보통학교) 양정 제7호",
        "publish_date": "1930.02.25",
        "publish_year": 1930,
        "publish_month": 2,
        "publish_day": 25,
        "publisher": "磯部百三 養正高等普通學校 校友會",
        "publisher_ko": "기부백삼 양정고등보통학교 교우회",
        "library": "",
        "school_id": 52813,
        "primaryname": "養正高等普通學校",
        "primaryname_ko": "양정고등보통학교"
    },
    {
        "book_id": 10501,
        "book_title": "(養正高等普通學校) 養正 第8號",
        "book_title_ko": "(양정고등보통학교) 양정 제8호",
        "publish_date": "1931.12.23",
        "publish_year": 1931,
        "publish_month": 12,
        "publish_day": 23,
        "publisher": "磯部百三 養正高等普通學校 校友會",
        "publisher_ko": "기부백삼 양정고등보통학교 교우회",
        "library": "독립기념관;서강대○",
        "school_id": 52813,
        "primaryname": "養正高等普通學校",
        "primaryname_ko": "양정고등보통학교"
    },
    {
        "book_id": 10502,
        "book_title": "(養正高等普通學校) 養正 第9號",
        "book_title_ko": "(양정고등보통학교) 양정 제9호",
        "publish_date": "1932.12.28",
        "publish_year": 1932,
        "publish_month": 12,
        "publish_day": 28,
        "publisher": "養正高等普通學校 校友會",
        "publisher_ko": "양정고등보통학교 교우회",
        "library": "",
        "school_id": 52813,
        "primaryname": "養正高等普通學校",
        "primaryname_ko": "양정고등보통학교"
    },
    {
        "book_id": 10503,
        "book_title": "(永生高等普通學校) 校友會報 第3號",
        "book_title_ko": "(영생고등보통학교) 교우회보 제3호",
        "publish_date": "1937.10.07",
        "publish_year": 1937,
        "publish_month": 10,
        "publish_day": 7,
        "publisher": "金觀植 永生高等普通學校 校友會 智育部",
        "publisher_ko": "금관식 영생고등보통학교 교우회 지육부",
        "library": "△",
        "school_id": 52814,
        "primaryname": "永生高等普通學校",
        "primaryname_ko": "영생고등보통학교"
    },
    {
        "book_id": 10504,
        "book_title": "(中央高等普通學校) 桂友 第10號",
        "book_title_ko": "(중앙고등보통학교) 계우 제10호",
        "publish_date": "1931.00.00",
        "publish_year": 1931,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "中央高等普通學校 同窓會",
        "publisher_ko": "중앙고등보통학교 동창회",
        "library": "",
        "school_id": 52815,
        "primaryname": "中央高等普通學校",
        "primaryname_ko": "중앙고등보통학교"
    },
    {
        "book_id": 10505,
        "book_title": "(中央高等普通學校) 桂友 第11號",
        "book_title_ko": "(중앙고등보통학교) 계우 제11호",
        "publish_date": "1932.00.00",
        "publish_year": 1932,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "中央高等普通學校 同窓會",
        "publisher_ko": "중앙고등보통학교 동창회",
        "library": "",
        "school_id": 52815,
        "primaryname": "中央高等普通學校",
        "primaryname_ko": "중앙고등보통학교"
    },
    {
        "book_id": 10506,
        "book_title": "(中央高等普通學校) 桂友 第12號",
        "book_title_ko": "(중앙고등보통학교) 계우 제12호",
        "publish_date": "1932.07.16",
        "publish_year": 1932,
        "publish_month": 7,
        "publish_day": 16,
        "publisher": "崔珵淳 中央高等普通學校 同窓會",
        "publisher_ko": "최정순 중앙고등보통학교 동창회",
        "library": "○",
        "school_id": 52815,
        "primaryname": "中央高等普通學校",
        "primaryname_ko": "중앙고등보통학교"
    },
    {
        "book_id": 10507,
        "book_title": "(中央高等普通學校) 桂友 第13號",
        "book_title_ko": "(중앙고등보통학교) 계우 제13호",
        "publish_date": "1933.07.16",
        "publish_year": 1933,
        "publish_month": 7,
        "publish_day": 16,
        "publisher": "崔珵淳 中央高等普通學校 同窓會",
        "publisher_ko": "최정순 중앙고등보통학교 동창회",
        "library": "○",
        "school_id": 52815,
        "primaryname": "中央高等普通學校",
        "primaryname_ko": "중앙고등보통학교"
    },
    {
        "book_id": 10508,
        "book_title": "(中央高等普通學校) 桂友 第14號",
        "book_title_ko": "(중앙고등보통학교) 계우 제14호",
        "publish_date": "1934.00.00",
        "publish_year": 1934,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "中央高等普通學校 同窓會",
        "publisher_ko": "중앙고등보통학교 동창회",
        "library": "",
        "school_id": 52815,
        "primaryname": "中央高等普通學校",
        "primaryname_ko": "중앙고등보통학교"
    },
    {
        "book_id": 10509,
        "book_title": "(中央高等普通學校) 桂友 第15號",
        "book_title_ko": "(중앙고등보통학교) 계우 제15호",
        "publish_date": "1935.00.00",
        "publish_year": 1935,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "中央高等普通學校 同窓會",
        "publisher_ko": "중앙고등보통학교 동창회",
        "library": "",
        "school_id": 52815,
        "primaryname": "中央高等普通學校",
        "primaryname_ko": "중앙고등보통학교"
    },
    {
        "book_id": 10510,
        "book_title": "(中央高等普通學校) 桂友 第16號",
        "book_title_ko": "(중앙고등보통학교) 계우 제16호",
        "publish_date": "1936.00.00",
        "publish_year": 1936,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "中央高等普通學校 同窓會",
        "publisher_ko": "중앙고등보통학교 동창회",
        "library": "",
        "school_id": 52815,
        "primaryname": "中央高等普通學校",
        "primaryname_ko": "중앙고등보통학교"
    },
    {
        "book_id": 10511,
        "book_title": "(中央高等普通學校) 桂友 第17號",
        "book_title_ko": "(중앙고등보통학교) 계우 제17호",
        "publish_date": "1937.00.00",
        "publish_year": 1937,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "中央高等普通學校 同窓會",
        "publisher_ko": "중앙고등보통학교 동창회",
        "library": "",
        "school_id": 52815,
        "primaryname": "中央高等普通學校",
        "primaryname_ko": "중앙고등보통학교"
    },
    {
        "book_id": 10512,
        "book_title": "(中央高等普通學校) 桂友 第19號",
        "book_title_ko": "(중앙고등보통학교) 계우 제19호",
        "publish_date": "1939.00.00",
        "publish_year": 1939,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "中央高等普通學校 同窓會",
        "publisher_ko": "중앙고등보통학교 동창회",
        "library": "",
        "school_id": 52815,
        "primaryname": "中央高等普通學校",
        "primaryname_ko": "중앙고등보통학교"
    },
    {
        "book_id": 10513,
        "book_title": "(中央高等普通學校) 桂友 第1號",
        "book_title_ko": "(중앙고등보통학교) 계우 제1호",
        "publish_date": "1927.00.00",
        "publish_year": 1927,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "中央高等普通學校 同窓會",
        "publisher_ko": "중앙고등보통학교 동창회",
        "library": "",
        "school_id": 52815,
        "primaryname": "中央高等普通學校",
        "primaryname_ko": "중앙고등보통학교"
    },
    {
        "book_id": 10514,
        "book_title": "(中央高等普通學校) 桂友 第3號",
        "book_title_ko": "(중앙고등보통학교) 계우 제3호",
        "publish_date": "1928.03.24",
        "publish_year": 1928,
        "publish_month": 3,
        "publish_day": 24,
        "publisher": "白南奎 中央高等普通學校 同窓會",
        "publisher_ko": "백남규 중앙고등보통학교 동창회",
        "library": "○",
        "school_id": 52815,
        "primaryname": "中央高等普通學校",
        "primaryname_ko": "중앙고등보통학교"
    },
    {
        "book_id": 10515,
        "book_title": "(中央高等普通學校) 桂友 第7號",
        "book_title_ko": "(중앙고등보통학교) 계우 제7호",
        "publish_date": "1929.00.00",
        "publish_year": 1929,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "權悳奎 中央校友會",
        "publisher_ko": "권덕규 중앙교우회",
        "library": "",
        "school_id": 52815,
        "primaryname": "中央高等普通學校",
        "primaryname_ko": "중앙고등보통학교"
    },
    {
        "book_id": 10516,
        "book_title": "(中央高等普通學校) 桂友 第9號",
        "book_title_ko": "(중앙고등보통학교) 계우 제9호",
        "publish_date": "1930.00.00",
        "publish_year": 1930,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "權悳奎 中央校友會",
        "publisher_ko": "권덕규 중앙교우회",
        "library": "",
        "school_id": 52815,
        "primaryname": "中央高等普通學校",
        "primaryname_ko": "중앙고등보통학교"
    },
    {
        "book_id": 10517,
        "book_title": "(中央高等普通學校) 中央校友會報 第2號",
        "book_title_ko": "(중앙고등보통학교) 중앙교우회보 제2호",
        "publish_date": "1922.00.00",
        "publish_year": 1922,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "中央校友會",
        "publisher_ko": "중앙교우회",
        "library": "",
        "school_id": 52815,
        "primaryname": "中央高等普通學校",
        "primaryname_ko": "중앙고등보통학교"
    },
    {
        "book_id": 10518,
        "book_title": "(中央高等普通學校) 中央校友會報 第4號",
        "book_title_ko": "(중앙고등보통학교) 중앙교우회보 제4호",
        "publish_date": "1925.00.00",
        "publish_year": 1925,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "中央校友會",
        "publisher_ko": "중앙교우회",
        "library": "",
        "school_id": 52815,
        "primaryname": "中央高等普通學校",
        "primaryname_ko": "중앙고등보통학교"
    },
    {
        "book_id": 10519,
        "book_title": "(中央高等普通學校) 中央校友會報 第6號",
        "book_title_ko": "(중앙고등보통학교) 중앙교우회보 제6호",
        "publish_date": "1932.00.00",
        "publish_year": 1932,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "中央校友會",
        "publisher_ko": "중앙교우회",
        "library": "",
        "school_id": 52815,
        "primaryname": "中央高等普通學校",
        "primaryname_ko": "중앙고등보통학교"
    },
    {
        "book_id": 10520,
        "book_title": "(中央高等普通學校) 中央校友會報 創刊號",
        "book_title_ko": "(중앙고등보통학교) 중앙교우회보 창간호",
        "publish_date": "1921.09.27",
        "publish_year": 1921,
        "publish_month": 9,
        "publish_day": 27,
        "publisher": "韓基岳 中央校友會",
        "publisher_ko": "한기악 중앙교우회",
        "library": "△",
        "school_id": 52815,
        "primaryname": "中央高等普通學校",
        "primaryname_ko": "중앙고등보통학교"
    },
    {
        "book_id": 10521,
        "book_title": "(淸州高等普通學校) 舟城 第2號",
        "book_title_ko": "(청주고등보통학교) 주성 제2호",
        "publish_date": "1930.03.05",
        "publish_year": 1930,
        "publish_month": 3,
        "publish_day": 5,
        "publisher": "雨宮安一 淸州公立高等普通學校 校友會",
        "publisher_ko": "우궁안일 청주공립고등보통학교 교우회",
        "library": "△",
        "school_id": 52816,
        "primaryname": "淸州高等普通學校",
        "primaryname_ko": "청주고등보통학교"
    },
    {
        "book_id": 10522,
        "book_title": "(淸州高等普通學校) 舟城 第3號",
        "book_title_ko": "(청주고등보통학교) 주성 제3호",
        "publish_date": "1931.03.31",
        "publish_year": 1931,
        "publish_month": 3,
        "publish_day": 31,
        "publisher": "淸州公立高等普通學校 校友會",
        "publisher_ko": "청주공립고등보통학교 교우회",
        "library": "",
        "school_id": 52816,
        "primaryname": "淸州高等普通學校",
        "primaryname_ko": "청주고등보통학교"
    },
    {
        "book_id": 10523,
        "book_title": "(淸州高等普通學校) 舟城 第4號",
        "book_title_ko": "(청주고등보통학교) 주성 제4호",
        "publish_date": "1932.03.30",
        "publish_year": 1932,
        "publish_month": 3,
        "publish_day": 30,
        "publisher": "淸州公立高等普通學校 校友會",
        "publisher_ko": "청주공립고등보통학교 교우회",
        "library": "",
        "school_id": 52816,
        "primaryname": "淸州高等普通學校",
        "primaryname_ko": "청주고등보통학교"
    },
    {
        "book_id": 10524,
        "book_title": "(淸州高等普通學校) 舟城 第5號",
        "book_title_ko": "(청주고등보통학교) 주성 제5호",
        "publish_date": "1933.03.15",
        "publish_year": 1933,
        "publish_month": 3,
        "publish_day": 15,
        "publisher": "安田芳太郞 淸州公立高等普通學校 校友會",
        "publisher_ko": "안전방태랑 청주공립고등보통학교 교우회",
        "library": "△",
        "school_id": 52816,
        "primaryname": "淸州高等普通學校",
        "primaryname_ko": "청주고등보통학교"
    },
    {
        "book_id": 10525,
        "book_title": "(淸州高等普通學校) 舟城 第6號",
        "book_title_ko": "(청주고등보통학교) 주성 제6호",
        "publish_date": "1934.11.05",
        "publish_year": 1934,
        "publish_month": 11,
        "publish_day": 5,
        "publisher": "淸州公立高等普通學校 校友會",
        "publisher_ko": "청주공립고등보통학교 교우회",
        "library": "",
        "school_id": 52816,
        "primaryname": "淸州高等普通學校",
        "primaryname_ko": "청주고등보통학교"
    },
    {
        "book_id": 10526,
        "book_title": "(淸州高等普通學校) 舟城 第7號",
        "book_title_ko": "(청주고등보통학교) 주성 제7호",
        "publish_date": "1936.04.05",
        "publish_year": 1936,
        "publish_month": 4,
        "publish_day": 5,
        "publisher": "堤眞一 淸州公立高等普通學校 校友會",
        "publisher_ko": "제진일 청주공립고등보통학교 교우회",
        "library": "△",
        "school_id": 52816,
        "primaryname": "淸州高等普通學校",
        "primaryname_ko": "청주고등보통학교"
    },
    {
        "book_id": 10527,
        "book_title": "(淸州高等普通學校) 舟城 創刊號",
        "book_title_ko": "(청주고등보통학교) 주성 창간호",
        "publish_date": "1929.03.05",
        "publish_year": 1929,
        "publish_month": 3,
        "publish_day": 5,
        "publisher": "安田芳太郞 淸州公立高等普通學校 校友會",
        "publisher_ko": "안전방태랑 청주공립고등보통학교 교우회",
        "library": "△",
        "school_id": 52816,
        "primaryname": "淸州高等普通學校",
        "primaryname_ko": "청주고등보통학교"
    },
    {
        "book_id": 10528,
        "book_title": "(海州高等普通學校) 校友會雜誌 創刊號",
        "book_title_ko": "(해주고등보통학교) 교우회잡지 창간호",
        "publish_date": "1926.07.25",
        "publish_year": 1926,
        "publish_month": 7,
        "publish_day": 25,
        "publisher": "海州高等普通學校 校友會",
        "publisher_ko": "해주고등보통학교 교우회",
        "library": "△",
        "school_id": 52817,
        "primaryname": "海州高等普通學校",
        "primaryname_ko": "해주고등보통학교"
    },
    {
        "book_id": 10529,
        "book_title": "(徽文高等普通學校) 徽文 臨時號",
        "book_title_ko": "(휘문고등보통학교) 휘문 임시호",
        "publish_date": "1935.03.04",
        "publish_year": 1935,
        "publish_month": 3,
        "publish_day": 4,
        "publisher": "金道泰  徽文高等普通學校 文友會 學藝部",
        "publisher_ko": "금도태  휘문고등보통학교 문우회 학예부",
        "library": "독립기념관",
        "school_id": 52818,
        "primaryname": "徽文高等普通學校",
        "primaryname_ko": "휘문고등보통학교"
    },
    {
        "book_id": 10530,
        "book_title": "(徽文高等普通學校) 徽文 第10號",
        "book_title_ko": "(휘문고등보통학교) 휘문 제10호",
        "publish_date": "1933.00.00",
        "publish_year": 1933,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "徽文高等普通學校 文友會 學藝部",
        "publisher_ko": "휘문고등보통학교 문우회 학예부",
        "library": "",
        "school_id": 52818,
        "primaryname": "徽文高等普通學校",
        "primaryname_ko": "휘문고등보통학교"
    },
    {
        "book_id": 10531,
        "book_title": "(徽文高等普通學校) 徽文 第11號",
        "book_title_ko": "(휘문고등보통학교) 휘문 제11호",
        "publish_date": "1933.12.20",
        "publish_year": 1933,
        "publish_month": 12,
        "publish_day": 20,
        "publisher": "新垣永昌  徽文高等普通學校 文友會 學藝部",
        "publisher_ko": "신원영창  휘문고등보통학교 문우회 학예부",
        "library": "독립기념관",
        "school_id": 52818,
        "primaryname": "徽文高等普通學校",
        "primaryname_ko": "휘문고등보통학교"
    },
    {
        "book_id": 10532,
        "book_title": "(徽文高等普通學校) 徽文 第13號",
        "book_title_ko": "(휘문고등보통학교) 휘문 제13호",
        "publish_date": "1935.12.30",
        "publish_year": 1935,
        "publish_month": 12,
        "publish_day": 30,
        "publisher": "徽文高等普通學校 文友會 學藝部",
        "publisher_ko": "휘문고등보통학교 문우회 학예부",
        "library": "",
        "school_id": 52818,
        "primaryname": "徽文高等普通學校",
        "primaryname_ko": "휘문고등보통학교"
    },
    {
        "book_id": 10533,
        "book_title": "(徽文高等普通學校) 徽文 第14號",
        "book_title_ko": "(휘문고등보통학교) 휘문 제14호",
        "publish_date": "1936.12.22",
        "publish_year": 1936,
        "publish_month": 12,
        "publish_day": 22,
        "publisher": "徽文高等普通學校 文友會 學藝部",
        "publisher_ko": "휘문고등보통학교 문우회 학예부",
        "library": "",
        "school_id": 52818,
        "primaryname": "徽文高等普通學校",
        "primaryname_ko": "휘문고등보통학교"
    },
    {
        "book_id": 10534,
        "book_title": "(徽文高等普通學校) 徽文 第15號",
        "book_title_ko": "(휘문고등보통학교) 휘문 제15호",
        "publish_date": "1937.00.00",
        "publish_year": 1937,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "徽文高等普通學校 文友會 學藝部",
        "publisher_ko": "휘문고등보통학교 문우회 학예부",
        "library": "",
        "school_id": 52818,
        "primaryname": "徽文高等普通學校",
        "primaryname_ko": "휘문고등보통학교"
    },
    {
        "book_id": 10535,
        "book_title": "(徽文高等普通學校) 徽文 第17號",
        "book_title_ko": "(휘문고등보통학교) 휘문 제17호",
        "publish_date": "1939.00.00",
        "publish_year": 1939,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "徽文高等普通學校 文友會 學藝部",
        "publisher_ko": "휘문고등보통학교 문우회 학예부",
        "library": "",
        "school_id": 52818,
        "primaryname": "徽文高等普通學校",
        "primaryname_ko": "휘문고등보통학교"
    },
    {
        "book_id": 10536,
        "book_title": "(徽文高等普通學校) 徽文 第19號",
        "book_title_ko": "(휘문고등보통학교) 휘문 제19호",
        "publish_date": "1942.05.08",
        "publish_year": 1942,
        "publish_month": 5,
        "publish_day": 8,
        "publisher": "金道泰  徽文高等普通學校 文友會 學藝部",
        "publisher_ko": "금도태  휘문고등보통학교 문우회 학예부",
        "library": "독립기념관",
        "school_id": 52818,
        "primaryname": "徽文高等普通學校",
        "primaryname_ko": "휘문고등보통학교"
    },
    {
        "book_id": 10537,
        "book_title": "(徽文高等普通學校) 徽文 第2號",
        "book_title_ko": "(휘문고등보통학교) 휘문 제2호",
        "publish_date": "1924.00.00",
        "publish_year": 1924,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "徽文高等普通學校 文友會 學藝部",
        "publisher_ko": "휘문고등보통학교 문우회 학예부",
        "library": "",
        "school_id": 52818,
        "primaryname": "徽文高等普通學校",
        "primaryname_ko": "휘문고등보통학교"
    },
    {
        "book_id": 10538,
        "book_title": "(徽文高等普通學校) 徽文 第3號",
        "book_title_ko": "(휘문고등보통학교) 휘문 제3호",
        "publish_date": "1925.12.25",
        "publish_year": 1925,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "新垣永昌  徽文高等普通學校 學藝部",
        "publisher_ko": "신원영창  휘문고등보통학교 학예부",
        "library": "국회도서관;독립기념관○",
        "school_id": 52818,
        "primaryname": "徽文高等普通學校",
        "primaryname_ko": "휘문고등보통학교"
    },
    {
        "book_id": 10539,
        "book_title": "(徽文高等普通學校) 徽文 第4號",
        "book_title_ko": "(휘문고등보통학교) 휘문 제4호",
        "publish_date": "1927.01.10",
        "publish_year": 1927,
        "publish_month": 1,
        "publish_day": 10,
        "publisher": "新垣永昌  徽文高等普通學校 文友會 學藝部",
        "publisher_ko": "신원영창  휘문고등보통학교 문우회 학예부",
        "library": "독립기념관△",
        "school_id": 52818,
        "primaryname": "徽文高等普通學校",
        "primaryname_ko": "휘문고등보통학교"
    },
    {
        "book_id": 10540,
        "book_title": "(徽文高等普通學校) 徽文 第5號",
        "book_title_ko": "(휘문고등보통학교) 휘문 제5호",
        "publish_date": "1928.03.01",
        "publish_year": 1928,
        "publish_month": 3,
        "publish_day": 1,
        "publisher": "新垣永昌  徽文高等普通學校 文友會 學藝部",
        "publisher_ko": "신원영창  휘문고등보통학교 문우회 학예부",
        "library": "독립기념관△",
        "school_id": 52818,
        "primaryname": "徽文高等普通學校",
        "primaryname_ko": "휘문고등보통학교"
    },
    {
        "book_id": 10541,
        "book_title": "(徽文高等普通學校) 徽文 第7號",
        "book_title_ko": "(휘문고등보통학교) 휘문 제7호",
        "publish_date": "1929.00.00",
        "publish_year": 1929,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "徽文高等普通學校 文友會 學藝部",
        "publisher_ko": "휘문고등보통학교 문우회 학예부",
        "library": "",
        "school_id": 52818,
        "primaryname": "徽文高等普通學校",
        "primaryname_ko": "휘문고등보통학교"
    },
    {
        "book_id": 10542,
        "book_title": "(徽文高等普通學校) 徽文 第8號",
        "book_title_ko": "(휘문고등보통학교) 휘문 제8호",
        "publish_date": "1930.00.00",
        "publish_year": 1930,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "徽文高等普通學校 文友會 學藝部",
        "publisher_ko": "휘문고등보통학교 문우회 학예부",
        "library": "",
        "school_id": 52818,
        "primaryname": "徽文高等普通學校",
        "primaryname_ko": "휘문고등보통학교"
    },
    {
        "book_id": 10543,
        "book_title": "(徽文高等普通學校) 徽文 第9號",
        "book_title_ko": "(휘문고등보통학교) 휘문 제9호",
        "publish_date": "1931.00.00",
        "publish_year": 1931,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "徽文高等普通學校 文友會 學藝部",
        "publisher_ko": "휘문고등보통학교 문우회 학예부",
        "library": "",
        "school_id": 52818,
        "primaryname": "徽文高等普通學校",
        "primaryname_ko": "휘문고등보통학교"
    },
    {
        "book_id": 10544,
        "book_title": "(徽文高等普通學校) 徽文 創刊號",
        "book_title_ko": "(휘문고등보통학교) 휘문 창간호",
        "publish_date": "1923.01.25",
        "publish_year": 1923,
        "publish_month": 1,
        "publish_day": 25,
        "publisher": "新垣永昌  徽文高等普通學校 文友會 學藝部",
        "publisher_ko": "신원영창  휘문고등보통학교 문우회 학예부",
        "library": "독립기념관;서울대",
        "school_id": 52818,
        "primaryname": "徽文高等普通學校",
        "primaryname_ko": "휘문고등보통학교"
    },
    {
        "book_id": 10564,
        "book_title": "經學院襍誌 第1號",
        "book_title_ko": "경학원잡지 제1호",
        "publish_date": "1913.12.05.",
        "publish_year": 1913,
        "publish_month": 12,
        "publish_day": 5,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10564,
        "book_title": "經學院襍誌 第1號",
        "book_title_ko": "경학원잡지 제1호",
        "publish_date": "1913.12.05.",
        "publish_year": 1913,
        "publish_month": 12,
        "publish_day": 5,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10565,
        "book_title": "經學院襍誌 第2號",
        "book_title_ko": "경학원잡지 제2호",
        "publish_date": "1914.03.25.",
        "publish_year": 1914,
        "publish_month": 3,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10565,
        "book_title": "經學院襍誌 第2號",
        "book_title_ko": "경학원잡지 제2호",
        "publish_date": "1914.03.25.",
        "publish_year": 1914,
        "publish_month": 3,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10566,
        "book_title": "經學院襍誌 第3號",
        "book_title_ko": "경학원잡지 제3호",
        "publish_date": "1914.06.25.",
        "publish_year": 1914,
        "publish_month": 6,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10566,
        "book_title": "經學院襍誌 第3號",
        "book_title_ko": "경학원잡지 제3호",
        "publish_date": "1914.06.25.",
        "publish_year": 1914,
        "publish_month": 6,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10567,
        "book_title": "經學院襍誌 第4號",
        "book_title_ko": "경학원잡지 제4호",
        "publish_date": "1914.09.25.",
        "publish_year": 1914,
        "publish_month": 9,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10567,
        "book_title": "經學院襍誌 第4號",
        "book_title_ko": "경학원잡지 제4호",
        "publish_date": "1914.09.25.",
        "publish_year": 1914,
        "publish_month": 9,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10568,
        "book_title": "經學院襍誌 第5號",
        "book_title_ko": "경학원잡지 제5호",
        "publish_date": "1914.12.25.",
        "publish_year": 1914,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10568,
        "book_title": "經學院襍誌 第5號",
        "book_title_ko": "경학원잡지 제5호",
        "publish_date": "1914.12.25.",
        "publish_year": 1914,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10569,
        "book_title": "經學院襍誌 第6號",
        "book_title_ko": "경학원잡지 제6호",
        "publish_date": "1915.03.25.",
        "publish_year": 1915,
        "publish_month": 3,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10569,
        "book_title": "經學院襍誌 第6號",
        "book_title_ko": "경학원잡지 제6호",
        "publish_date": "1915.03.25.",
        "publish_year": 1915,
        "publish_month": 3,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10570,
        "book_title": "經學院襍誌 第7號",
        "book_title_ko": "경학원잡지 제7호",
        "publish_date": "1915.06.25.",
        "publish_year": 1915,
        "publish_month": 6,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10570,
        "book_title": "經學院襍誌 第7號",
        "book_title_ko": "경학원잡지 제7호",
        "publish_date": "1915.06.25.",
        "publish_year": 1915,
        "publish_month": 6,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10571,
        "book_title": "經學院襍誌 第8號",
        "book_title_ko": "경학원잡지 제8호",
        "publish_date": "1915.09.25.",
        "publish_year": 1915,
        "publish_month": 9,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10571,
        "book_title": "經學院襍誌 第8號",
        "book_title_ko": "경학원잡지 제8호",
        "publish_date": "1915.09.25.",
        "publish_year": 1915,
        "publish_month": 9,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10572,
        "book_title": "經學院襍誌 第9號",
        "book_title_ko": "경학원잡지 제9호",
        "publish_date": "1915.12.25.",
        "publish_year": 1915,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10572,
        "book_title": "經學院襍誌 第9號",
        "book_title_ko": "경학원잡지 제9호",
        "publish_date": "1915.12.25.",
        "publish_year": 1915,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10573,
        "book_title": "經學院襍誌 第10號",
        "book_title_ko": "경학원잡지 제10호",
        "publish_date": "1916.03.25.",
        "publish_year": 1916,
        "publish_month": 3,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10573,
        "book_title": "經學院襍誌 第10號",
        "book_title_ko": "경학원잡지 제10호",
        "publish_date": "1916.03.25.",
        "publish_year": 1916,
        "publish_month": 3,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10574,
        "book_title": "經學院襍誌 第11號",
        "book_title_ko": "경학원잡지 제11호",
        "publish_date": "1916.06.25.",
        "publish_year": 1916,
        "publish_month": 6,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10574,
        "book_title": "經學院襍誌 第11號",
        "book_title_ko": "경학원잡지 제11호",
        "publish_date": "1916.06.25.",
        "publish_year": 1916,
        "publish_month": 6,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10575,
        "book_title": "經學院襍誌 第12號",
        "book_title_ko": "경학원잡지 제12호",
        "publish_date": "1916.12.25.",
        "publish_year": 1916,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10575,
        "book_title": "經學院襍誌 第12號",
        "book_title_ko": "경학원잡지 제12호",
        "publish_date": "1916.12.25.",
        "publish_year": 1916,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10576,
        "book_title": "經學院襍誌 第13號",
        "book_title_ko": "경학원잡지 제13호",
        "publish_date": "1917.03.25.",
        "publish_year": 1917,
        "publish_month": 3,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10576,
        "book_title": "經學院襍誌 第13號",
        "book_title_ko": "경학원잡지 제13호",
        "publish_date": "1917.03.25.",
        "publish_year": 1917,
        "publish_month": 3,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10577,
        "book_title": "經學院襍誌 第14號",
        "book_title_ko": "경학원잡지 제14호",
        "publish_date": "1917.07.25.",
        "publish_year": 1917,
        "publish_month": 7,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10577,
        "book_title": "經學院襍誌 第14號",
        "book_title_ko": "경학원잡지 제14호",
        "publish_date": "1917.07.25.",
        "publish_year": 1917,
        "publish_month": 7,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10578,
        "book_title": "經學院襍誌 第15號",
        "book_title_ko": "경학원잡지 제15호",
        "publish_date": "1917.10.15.",
        "publish_year": 1917,
        "publish_month": 10,
        "publish_day": 15,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10578,
        "book_title": "經學院襍誌 第15號",
        "book_title_ko": "경학원잡지 제15호",
        "publish_date": "1917.10.15.",
        "publish_year": 1917,
        "publish_month": 10,
        "publish_day": 15,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10579,
        "book_title": "經學院襍誌 第16號",
        "book_title_ko": "경학원잡지 제16호",
        "publish_date": "1918.03.25.",
        "publish_year": 1918,
        "publish_month": 3,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10579,
        "book_title": "經學院襍誌 第16號",
        "book_title_ko": "경학원잡지 제16호",
        "publish_date": "1918.03.25.",
        "publish_year": 1918,
        "publish_month": 3,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10580,
        "book_title": "經學院襍誌 第17號",
        "book_title_ko": "경학원잡지 제17호",
        "publish_date": "1918.07.25.",
        "publish_year": 1918,
        "publish_month": 7,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10580,
        "book_title": "經學院襍誌 第17號",
        "book_title_ko": "경학원잡지 제17호",
        "publish_date": "1918.07.25.",
        "publish_year": 1918,
        "publish_month": 7,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10581,
        "book_title": "經學院襍誌 第18號",
        "book_title_ko": "경학원잡지 제18호",
        "publish_date": "1918.09.25.",
        "publish_year": 1918,
        "publish_month": 9,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10581,
        "book_title": "經學院襍誌 第18號",
        "book_title_ko": "경학원잡지 제18호",
        "publish_date": "1918.09.25.",
        "publish_year": 1918,
        "publish_month": 9,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10582,
        "book_title": "經學院襍誌 第19號",
        "book_title_ko": "경학원잡지 제19호",
        "publish_date": "1918.12.25.",
        "publish_year": 1918,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10582,
        "book_title": "經學院襍誌 第19號",
        "book_title_ko": "경학원잡지 제19호",
        "publish_date": "1918.12.25.",
        "publish_year": 1918,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10583,
        "book_title": "經學院襍誌 第20號",
        "book_title_ko": "경학원잡지 제20호",
        "publish_date": "1920.03.25.",
        "publish_year": 1920,
        "publish_month": 3,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10583,
        "book_title": "經學院襍誌 第20號",
        "book_title_ko": "경학원잡지 제20호",
        "publish_date": "1920.03.25.",
        "publish_year": 1920,
        "publish_month": 3,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10584,
        "book_title": "經學院襍誌 第21號",
        "book_title_ko": "경학원잡지 제21호",
        "publish_date": "1921.03.10.",
        "publish_year": 1921,
        "publish_month": 3,
        "publish_day": 10,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10584,
        "book_title": "經學院襍誌 第21號",
        "book_title_ko": "경학원잡지 제21호",
        "publish_date": "1921.03.10.",
        "publish_year": 1921,
        "publish_month": 3,
        "publish_day": 10,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10585,
        "book_title": "經學院襍誌 第22號",
        "book_title_ko": "경학원잡지 제22호",
        "publish_date": "1922.03.10.",
        "publish_year": 1922,
        "publish_month": 3,
        "publish_day": 10,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10585,
        "book_title": "經學院襍誌 第22號",
        "book_title_ko": "경학원잡지 제22호",
        "publish_date": "1922.03.10.",
        "publish_year": 1922,
        "publish_month": 3,
        "publish_day": 10,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10586,
        "book_title": "經學院襍誌 第23號",
        "book_title_ko": "경학원잡지 제23호",
        "publish_date": "1922.12.25.",
        "publish_year": 1922,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10586,
        "book_title": "經學院襍誌 第23號",
        "book_title_ko": "경학원잡지 제23호",
        "publish_date": "1922.12.25.",
        "publish_year": 1922,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10587,
        "book_title": "經學院襍誌 第24號",
        "book_title_ko": "경학원잡지 제24호",
        "publish_date": "1923.12.25.",
        "publish_year": 1923,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10587,
        "book_title": "經學院襍誌 第24號",
        "book_title_ko": "경학원잡지 제24호",
        "publish_date": "1923.12.25.",
        "publish_year": 1923,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10588,
        "book_title": "經學院襍誌 第25號",
        "book_title_ko": "경학원잡지 제25호",
        "publish_date": "1924.12.25.",
        "publish_year": 1924,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10588,
        "book_title": "經學院襍誌 第25號",
        "book_title_ko": "경학원잡지 제25호",
        "publish_date": "1924.12.25.",
        "publish_year": 1924,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10589,
        "book_title": "經學院襍誌 第26號",
        "book_title_ko": "경학원잡지 제26호",
        "publish_date": "1925.12.25.",
        "publish_year": 1925,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10589,
        "book_title": "經學院襍誌 第26號",
        "book_title_ko": "경학원잡지 제26호",
        "publish_date": "1925.12.25.",
        "publish_year": 1925,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10590,
        "book_title": "經學院襍誌 第27號",
        "book_title_ko": "경학원잡지 제27호",
        "publish_date": "1926.12.25.",
        "publish_year": 1926,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10590,
        "book_title": "經學院襍誌 第27號",
        "book_title_ko": "경학원잡지 제27호",
        "publish_date": "1926.12.25.",
        "publish_year": 1926,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10591,
        "book_title": "經學院襍誌 第28號",
        "book_title_ko": "경학원잡지 제28호",
        "publish_date": "1927.12.25.",
        "publish_year": 1927,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10591,
        "book_title": "經學院襍誌 第28號",
        "book_title_ko": "경학원잡지 제28호",
        "publish_date": "1927.12.25.",
        "publish_year": 1927,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10592,
        "book_title": "經學院襍誌 第29號",
        "book_title_ko": "경학원잡지 제29호",
        "publish_date": "1928.12.25.",
        "publish_year": 1928,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10592,
        "book_title": "經學院襍誌 第29號",
        "book_title_ko": "경학원잡지 제29호",
        "publish_date": "1928.12.25.",
        "publish_year": 1928,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10593,
        "book_title": "經學院襍誌 第30號",
        "book_title_ko": "경학원잡지 제30호",
        "publish_date": "1929.12.25.",
        "publish_year": 1929,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10593,
        "book_title": "經學院襍誌 第30號",
        "book_title_ko": "경학원잡지 제30호",
        "publish_date": "1929.12.25.",
        "publish_year": 1929,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10594,
        "book_title": "經學院襍誌 第31號",
        "book_title_ko": "경학원잡지 제31호",
        "publish_date": "1930.08.01.",
        "publish_year": 1930,
        "publish_month": 8,
        "publish_day": 1,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10594,
        "book_title": "經學院襍誌 第31號",
        "book_title_ko": "경학원잡지 제31호",
        "publish_date": "1930.08.01.",
        "publish_year": 1930,
        "publish_month": 8,
        "publish_day": 1,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10595,
        "book_title": "經學院襍誌 第32號",
        "book_title_ko": "경학원잡지 제32호",
        "publish_date": "1930.12.27.",
        "publish_year": 1930,
        "publish_month": 12,
        "publish_day": 27,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10595,
        "book_title": "經學院襍誌 第32號",
        "book_title_ko": "경학원잡지 제32호",
        "publish_date": "1930.12.27.",
        "publish_year": 1930,
        "publish_month": 12,
        "publish_day": 27,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10596,
        "book_title": "經學院襍誌 第33號",
        "book_title_ko": "경학원잡지 제33호",
        "publish_date": "1931.12.25.",
        "publish_year": 1931,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10596,
        "book_title": "經學院襍誌 第33號",
        "book_title_ko": "경학원잡지 제33호",
        "publish_date": "1931.12.25.",
        "publish_year": 1931,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10597,
        "book_title": "經學院襍誌 第34號",
        "book_title_ko": "경학원잡지 제34호",
        "publish_date": "1932.03.31",
        "publish_year": 1932,
        "publish_month": 3,
        "publish_day": 31,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "△",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10597,
        "book_title": "經學院襍誌 第34號",
        "book_title_ko": "경학원잡지 제34호",
        "publish_date": "1932.03.31",
        "publish_year": 1932,
        "publish_month": 3,
        "publish_day": 31,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "△",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10598,
        "book_title": "經學院襍誌 第35號",
        "book_title_ko": "경학원잡지 제35호",
        "publish_date": "1932.12.25",
        "publish_year": 1932,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "△",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10598,
        "book_title": "經學院襍誌 第35號",
        "book_title_ko": "경학원잡지 제35호",
        "publish_date": "1932.12.25",
        "publish_year": 1932,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "△",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10599,
        "book_title": "經學院襍誌 第36號",
        "book_title_ko": "경학원잡지 제36호",
        "publish_date": "1933.12.25",
        "publish_year": 1933,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "△",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10599,
        "book_title": "經學院襍誌 第36號",
        "book_title_ko": "경학원잡지 제36호",
        "publish_date": "1933.12.25",
        "publish_year": 1933,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "△",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10600,
        "book_title": "經學院襍誌 第37號",
        "book_title_ko": "경학원잡지 제37호",
        "publish_date": "1934.10.25.",
        "publish_year": 1934,
        "publish_month": 10,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10600,
        "book_title": "經學院襍誌 第37號",
        "book_title_ko": "경학원잡지 제37호",
        "publish_date": "1934.10.25.",
        "publish_year": 1934,
        "publish_month": 10,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10601,
        "book_title": "經學院襍誌 第38號",
        "book_title_ko": "경학원잡지 제38호",
        "publish_date": "1935.01.30.",
        "publish_year": 1935,
        "publish_month": 1,
        "publish_day": 30,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10601,
        "book_title": "經學院襍誌 第38號",
        "book_title_ko": "경학원잡지 제38호",
        "publish_date": "1935.01.30.",
        "publish_year": 1935,
        "publish_month": 1,
        "publish_day": 30,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10602,
        "book_title": "經學院襍誌 第39號",
        "book_title_ko": "경학원잡지 제39호",
        "publish_date": "1935.10.05.",
        "publish_year": 1935,
        "publish_month": 10,
        "publish_day": 5,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "△",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10602,
        "book_title": "經學院襍誌 第39號",
        "book_title_ko": "경학원잡지 제39호",
        "publish_date": "1935.10.05.",
        "publish_year": 1935,
        "publish_month": 10,
        "publish_day": 5,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "△",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10603,
        "book_title": "經學院襍誌 第40號",
        "book_title_ko": "경학원잡지 제40호",
        "publish_date": "1936.08.25",
        "publish_year": 1936,
        "publish_month": 8,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "△",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10603,
        "book_title": "經學院襍誌 第40號",
        "book_title_ko": "경학원잡지 제40호",
        "publish_date": "1936.08.25",
        "publish_year": 1936,
        "publish_month": 8,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "△",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10604,
        "book_title": "經學院襍誌 第41號",
        "book_title_ko": "경학원잡지 제41호",
        "publish_date": "1937.02.25.",
        "publish_year": 1937,
        "publish_month": 2,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10604,
        "book_title": "經學院襍誌 第41號",
        "book_title_ko": "경학원잡지 제41호",
        "publish_date": "1937.02.25.",
        "publish_year": 1937,
        "publish_month": 2,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10605,
        "book_title": "經學院襍誌 第42號",
        "book_title_ko": "경학원잡지 제42호",
        "publish_date": "1937.12.25",
        "publish_year": 1937,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "△",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10605,
        "book_title": "經學院襍誌 第42號",
        "book_title_ko": "경학원잡지 제42호",
        "publish_date": "1937.12.25",
        "publish_year": 1937,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "△",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10606,
        "book_title": "經學院襍誌 第43號",
        "book_title_ko": "경학원잡지 제43호",
        "publish_date": "1938.12.25.",
        "publish_year": 1938,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10606,
        "book_title": "經學院襍誌 第43號",
        "book_title_ko": "경학원잡지 제43호",
        "publish_date": "1938.12.25.",
        "publish_year": 1938,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10607,
        "book_title": "經學院襍誌 第44號",
        "book_title_ko": "경학원잡지 제44호",
        "publish_date": "1939.10.05",
        "publish_year": 1939,
        "publish_month": 10,
        "publish_day": 5,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "국회도서관△",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10607,
        "book_title": "經學院襍誌 第44號",
        "book_title_ko": "경학원잡지 제44호",
        "publish_date": "1939.10.05",
        "publish_year": 1939,
        "publish_month": 10,
        "publish_day": 5,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "국회도서관△",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10608,
        "book_title": "經學院襍誌 第45號",
        "book_title_ko": "경학원잡지 제45호",
        "publish_date": "1940.12.20.",
        "publish_year": 1940,
        "publish_month": 12,
        "publish_day": 20,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "국회도서관",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10608,
        "book_title": "經學院襍誌 第45號",
        "book_title_ko": "경학원잡지 제45호",
        "publish_date": "1940.12.20.",
        "publish_year": 1940,
        "publish_month": 12,
        "publish_day": 20,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "국회도서관",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10609,
        "book_title": "經學院襍誌 第46號",
        "book_title_ko": "경학원잡지 제46호",
        "publish_date": "1941.12.25.",
        "publish_year": 1941,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "국회도서관",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10609,
        "book_title": "經學院襍誌 第46號",
        "book_title_ko": "경학원잡지 제46호",
        "publish_date": "1941.12.25.",
        "publish_year": 1941,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "국회도서관",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10610,
        "book_title": "經學院襍誌 第47號",
        "book_title_ko": "경학원잡지 제47호",
        "publish_date": "1943.01.25.",
        "publish_year": 1943,
        "publish_month": 1,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "국회도서관",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10610,
        "book_title": "經學院襍誌 第47號",
        "book_title_ko": "경학원잡지 제47호",
        "publish_date": "1943.01.25.",
        "publish_year": 1943,
        "publish_month": 1,
        "publish_day": 25,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "국회도서관",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10611,
        "book_title": "經學院襍誌 第48號",
        "book_title_ko": "경학원잡지 제48호",
        "publish_date": "1944.04.00",
        "publish_year": 1944,
        "publish_month": 4,
        "publish_day": 0,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "국회도서관",
        "school_id": 52962,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10611,
        "book_title": "經學院襍誌 第48號",
        "book_title_ko": "경학원잡지 제48호",
        "publish_date": "1944.04.00",
        "publish_year": 1944,
        "publish_month": 4,
        "publish_day": 0,
        "publisher": "經學院",
        "publisher_ko": "경학원",
        "library": "국회도서관",
        "school_id": 52825,
        "primaryname": "經學院",
        "primaryname_ko": "경학원"
    },
    {
        "book_id": 10614,
        "book_title": "(京城帝國大學) 京城帝大史學會報 第1號",
        "book_title_ko": "(경성제국대학) 경성제대사학회보 제1호",
        "publish_date": "1931.07.01",
        "publish_year": 1931,
        "publish_month": 7,
        "publish_day": 1,
        "publisher": "小田省吾 京城帝大 史學會",
        "publisher_ko": "소전성오 경성제대 사학회",
        "library": "서강대",
        "school_id": 52828,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10615,
        "book_title": "(京城帝國大學) 京城帝大史學會報 第2號",
        "book_title_ko": "(경성제국대학) 경성제대사학회보 제2호",
        "publish_date": "1932.04.23",
        "publish_year": 1932,
        "publish_month": 4,
        "publish_day": 23,
        "publisher": "小田省吾 京城帝大 史學會",
        "publisher_ko": "소전성오 경성제대 사학회",
        "library": "",
        "school_id": 52828,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10616,
        "book_title": "(京城帝國大學) 京城帝大史學會報 第3號",
        "book_title_ko": "(경성제국대학) 경성제대사학회보 제3호",
        "publish_date": "1932.09.30",
        "publish_year": 1932,
        "publish_month": 9,
        "publish_day": 30,
        "publisher": "大谷勝眞 京城帝大 史學會",
        "publisher_ko": "대곡승진 경성제대 사학회",
        "library": "",
        "school_id": 52828,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10617,
        "book_title": "(京城帝國大學) 城大文化 第1號",
        "book_title_ko": "(경성제국대학) 성대문화 제1호",
        "publish_date": "1942.07.08",
        "publish_year": 1942,
        "publish_month": 7,
        "publish_day": 8,
        "publisher": "海老原肇 京城帝國大學 文藝部",
        "publisher_ko": "해로원조 경성제국대학 문예부",
        "library": "",
        "school_id": 52828,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10618,
        "book_title": "(京城帝國大學) 會報 ",
        "book_title_ko": "(경성제국대학) 회보 ",
        "publish_date": "1933.03.25",
        "publish_year": 1933,
        "publish_month": 3,
        "publish_day": 25,
        "publisher": "谷田柳一 京城帝國大學 學友會",
        "publisher_ko": "곡전류일 경성제국대학 학우회",
        "library": "국회도서관",
        "school_id": 52828,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10619,
        "book_title": "(京城帝國大學) 會報(京城帝大法文學部) 第1號",
        "book_title_ko": "(경성제국대학) 회보(경성제대법문학부) 제1호",
        "publish_date": "1930.12.01",
        "publish_year": 1930,
        "publish_month": 12,
        "publish_day": 1,
        "publisher": "高木市之助 京城帝國大學 國語國文學會",
        "publisher_ko": "고목시지조 경성제국대학 국어국문학회",
        "library": "",
        "school_id": 52828,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10620,
        "book_title": "(京城帝國大學) 會報(京城帝大法文學部) 第2號",
        "book_title_ko": "(경성제국대학) 회보(경성제대법문학부) 제2호",
        "publish_date": "1931.06.01",
        "publish_year": 1931,
        "publish_month": 6,
        "publish_day": 1,
        "publisher": "高木市之助 京城帝國大學 國語國文學會",
        "publisher_ko": "고목시지조 경성제국대학 국어국문학회",
        "library": "",
        "school_id": 52828,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10621,
        "book_title": "(京城帝國大學) 會報(京城帝大法文學部) 第3號",
        "book_title_ko": "(경성제국대학) 회보(경성제대법문학부) 제3호",
        "publish_date": "1932.03.01",
        "publish_year": 1932,
        "publish_month": 3,
        "publish_day": 1,
        "publisher": "高木市之助 京城帝國大學 國語國文學會",
        "publisher_ko": "고목시지조 경성제국대학 국어국문학회",
        "library": "",
        "school_id": 52828,
        "primaryname": "京城帝國大學",
        "primaryname_ko": "경성제국대학"
    },
    {
        "book_id": 10639,
        "book_title": "(京城帝國大學豫科) 文友 第4號",
        "book_title_ko": "(경성제국대학예과) 문우 제4호",
        "publish_date": "1927.02.20",
        "publish_year": 1927,
        "publish_month": 2,
        "publish_day": 20,
        "publisher": "李康國 京城大學 豫科 文友會",
        "publisher_ko": "이강국 경성대학 예과 문우회",
        "library": "",
        "school_id": 52829,
        "primaryname": "京城帝國大學豫科",
        "primaryname_ko": "경성제국대학 예과"
    },
    {
        "book_id": 10640,
        "book_title": "(京城帝國大學豫科) 文友 第5號",
        "book_title_ko": "(경성제국대학예과) 문우 제5호",
        "publish_date": "1927.11.10",
        "publish_year": 1927,
        "publish_month": 11,
        "publish_day": 10,
        "publisher": "金在喆 京城大學 豫科 文友會",
        "publisher_ko": "금재철 경성대학 예과 문우회",
        "library": "",
        "school_id": 52829,
        "primaryname": "京城帝國大學豫科",
        "primaryname_ko": "경성제국대학 예과"
    },
    {
        "book_id": 10641,
        "book_title": "(京城帝國大學豫科) 淸凉 第11號",
        "book_title_ko": "(경성제국대학예과) 청량 제11호",
        "publish_date": "1931.03.15",
        "publish_year": 1931,
        "publish_month": 3,
        "publish_day": 15,
        "publisher": "荒內眞佐治 京城帝國大學 豫科 學友會",
        "publisher_ko": "황내진좌치 경성제국대학 예과 학우회",
        "library": "",
        "school_id": 52829,
        "primaryname": "京城帝國大學豫科",
        "primaryname_ko": "경성제국대학 예과"
    },
    {
        "book_id": 10642,
        "book_title": "(京城帝國大學豫科) 淸凉 第12號",
        "book_title_ko": "(경성제국대학예과) 청량 제12호",
        "publish_date": "1931.09.01",
        "publish_year": 1931,
        "publish_month": 9,
        "publish_day": 1,
        "publisher": "荒內眞佐治 京城帝國大學 豫科 學友會",
        "publisher_ko": "황내진좌치 경성제국대학 예과 학우회",
        "library": "",
        "school_id": 52829,
        "primaryname": "京城帝國大學豫科",
        "primaryname_ko": "경성제국대학 예과"
    },
    {
        "book_id": 10643,
        "book_title": "(京城帝國大學豫科) 淸凉 第13號",
        "book_title_ko": "(경성제국대학예과) 청량 제13호",
        "publish_date": "1932.03.16",
        "publish_year": 1932,
        "publish_month": 3,
        "publish_day": 16,
        "publisher": "荒內眞佐治 京城帝國大學 豫科 學友會",
        "publisher_ko": "황내진좌치 경성제국대학 예과 학우회",
        "library": "",
        "school_id": 52829,
        "primaryname": "京城帝國大學豫科",
        "primaryname_ko": "경성제국대학 예과"
    },
    {
        "book_id": 10644,
        "book_title": "(京城帝國大學豫科) 淸凉 第18號",
        "book_title_ko": "(경성제국대학예과) 청량 제18호",
        "publish_date": "1934.07.10",
        "publish_year": 1934,
        "publish_month": 7,
        "publish_day": 10,
        "publisher": "荒內眞佐治 京城帝國大學 豫科 學友會",
        "publisher_ko": "황내진좌치 경성제국대학 예과 학우회",
        "library": "",
        "school_id": 52829,
        "primaryname": "京城帝國大學豫科",
        "primaryname_ko": "경성제국대학 예과"
    },
    {
        "book_id": 10645,
        "book_title": "(京城帝國大學豫科) 淸涼 第1號",
        "book_title_ko": "(경성제국대학예과) 청량 제1호",
        "publish_date": "1925.05.18",
        "publish_year": 1925,
        "publish_month": 5,
        "publish_day": 18,
        "publisher": "荒內眞佐治 京城帝國大學 豫科 學友會",
        "publisher_ko": "황내진좌치 경성제국대학 예과 학우회",
        "library": "국립중앙도서관",
        "school_id": 52829,
        "primaryname": "京城帝國大學豫科",
        "primaryname_ko": "경성제국대학 예과"
    },
    {
        "book_id": 10646,
        "book_title": "(京城帝國大學豫科) 淸凉 第20號",
        "book_title_ko": "(경성제국대학예과) 청량 제20호",
        "publish_date": "1936.01.30",
        "publish_year": 1936,
        "publish_month": 1,
        "publish_day": 30,
        "publisher": "荒內眞佐治 京城帝國大學 豫科 學友會",
        "publisher_ko": "황내진좌치 경성제국대학 예과 학우회",
        "library": "",
        "school_id": 52829,
        "primaryname": "京城帝國大學豫科",
        "primaryname_ko": "경성제국대학 예과"
    },
    {
        "book_id": 10647,
        "book_title": "(京城帝國大學豫科) 淸凉 第23號",
        "book_title_ko": "(경성제국대학예과) 청량 제23호",
        "publish_date": "1937.09.08",
        "publish_year": 1937,
        "publish_month": 9,
        "publish_day": 8,
        "publisher": "烏田被吉 京城帝國大學 豫科 學友會",
        "publisher_ko": "오전피길 경성제국대학 예과 학우회",
        "library": "",
        "school_id": 52829,
        "primaryname": "京城帝國大學豫科",
        "primaryname_ko": "경성제국대학 예과"
    },
    {
        "book_id": 10648,
        "book_title": "(京城帝國大學豫科) 淸凉 第24號",
        "book_title_ko": "(경성제국대학예과) 청량 제24호",
        "publish_date": "1938.02.04",
        "publish_year": 1938,
        "publish_month": 2,
        "publish_day": 4,
        "publisher": "烏田被吉 京城帝國大學 豫科 學友會",
        "publisher_ko": "오전피길 경성제국대학 예과 학우회",
        "library": "",
        "school_id": 52829,
        "primaryname": "京城帝國大學豫科",
        "primaryname_ko": "경성제국대학 예과"
    },
    {
        "book_id": 10649,
        "book_title": "(京城帝國大學豫科) 淸凉 第25號",
        "book_title_ko": "(경성제국대학예과) 청량 제25호",
        "publish_date": "1938.11.25",
        "publish_year": 1938,
        "publish_month": 11,
        "publish_day": 25,
        "publisher": "烏田被吉 京城帝國大學 豫科 學友會",
        "publisher_ko": "오전피길 경성제국대학 예과 학우회",
        "library": "",
        "school_id": 52829,
        "primaryname": "京城帝國大學豫科",
        "primaryname_ko": "경성제국대학 예과"
    },
    {
        "book_id": 10650,
        "book_title": "(京城帝國大學豫科) 淸凉 第27號",
        "book_title_ko": "(경성제국대학예과) 청량 제27호",
        "publish_date": "1939.10.06",
        "publish_year": 1939,
        "publish_month": 10,
        "publish_day": 6,
        "publisher": "烏田被吉 京城帝國大學 豫科 學友會",
        "publisher_ko": "오전피길 경성제국대학 예과 학우회",
        "library": "",
        "school_id": 52829,
        "primaryname": "京城帝國大學豫科",
        "primaryname_ko": "경성제국대학 예과"
    },
    {
        "book_id": 10651,
        "book_title": "(京城帝國大學豫科) 淸凉 第30號",
        "book_title_ko": "(경성제국대학예과) 청량 제30호",
        "publish_date": "1941.03.15",
        "publish_year": 1941,
        "publish_month": 3,
        "publish_day": 15,
        "publisher": "烏田被吉 京城帝國大學 豫科 學友會",
        "publisher_ko": "오전피길 경성제국대학 예과 학우회",
        "library": "",
        "school_id": 52829,
        "primaryname": "京城帝國大學豫科",
        "primaryname_ko": "경성제국대학 예과"
    },
    {
        "book_id": 10652,
        "book_title": "(京城帝國大學豫科) 淸凉 第3號",
        "book_title_ko": "(경성제국대학예과) 청량 제3호",
        "publish_date": "1926.03.16",
        "publish_year": 1926,
        "publish_month": 3,
        "publish_day": 16,
        "publisher": "荒內眞佐治 京城帝國大學 豫科 學友會",
        "publisher_ko": "황내진좌치 경성제국대학 예과 학우회",
        "library": "",
        "school_id": 52829,
        "primaryname": "京城帝國大學豫科",
        "primaryname_ko": "경성제국대학 예과"
    },
    {
        "book_id": 10653,
        "book_title": "(京城帝國大學豫科) 淸凉 第4號",
        "book_title_ko": "(경성제국대학예과) 청량 제4호",
        "publish_date": "1927.01.31",
        "publish_year": 1927,
        "publish_month": 1,
        "publish_day": 31,
        "publisher": "荒內眞佐治 京城帝國大學 豫科 學友會",
        "publisher_ko": "황내진좌치 경성제국대학 예과 학우회",
        "library": "",
        "school_id": 52829,
        "primaryname": "京城帝國大學豫科",
        "primaryname_ko": "경성제국대학 예과"
    },
    {
        "book_id": 10654,
        "book_title": "(京城帝國大學豫科) 淸凉 第9號",
        "book_title_ko": "(경성제국대학예과) 청량 제9호",
        "publish_date": "1930.07.04",
        "publish_year": 1930,
        "publish_month": 7,
        "publish_day": 4,
        "publisher": "荒內眞佐治 京城帝國大學 豫科 學友會",
        "publisher_ko": "황내진좌치 경성제국대학 예과 학우회",
        "library": "",
        "school_id": 52829,
        "primaryname": "京城帝國大學豫科",
        "primaryname_ko": "경성제국대학 예과"
    },
    {
        "book_id": 10655,
        "book_title": "(京城帝國大學豫科) 學友會報 昭和10年號",
        "book_title_ko": "(경성제국대학예과) 학우회보 소화10년호",
        "publish_date": "1936.04.07",
        "publish_year": 1936,
        "publish_month": 4,
        "publish_day": 7,
        "publisher": "荒內眞佐治 京城帝國大學 豫科 學友會",
        "publisher_ko": "황내진좌치 경성제국대학 예과 학우회",
        "library": "",
        "school_id": 52829,
        "primaryname": "京城帝國大學豫科",
        "primaryname_ko": "경성제국대학 예과"
    },
    {
        "book_id": 10656,
        "book_title": "(京城帝國大學豫科) 學友會報 昭和11年號",
        "book_title_ko": "(경성제국대학예과) 학우회보 소화11년호",
        "publish_date": "1937.03.31",
        "publish_year": 1937,
        "publish_month": 3,
        "publish_day": 31,
        "publisher": "荒內眞佐治 京城帝國大學 豫科 學友會",
        "publisher_ko": "황내진좌치 경성제국대학 예과 학우회",
        "library": "",
        "school_id": 52829,
        "primaryname": "京城帝國大學豫科",
        "primaryname_ko": "경성제국대학 예과"
    },
    {
        "book_id": 10657,
        "book_title": "(京城帝國大學豫科) 學友會報 昭和14年號",
        "book_title_ko": "(경성제국대학예과) 학우회보 소화14년호",
        "publish_date": "1940.05.06",
        "publish_year": 1940,
        "publish_month": 5,
        "publish_day": 6,
        "publisher": "烏田被吉 京城帝國大學 豫科 學友會",
        "publisher_ko": "오전피길 경성제국대학 예과 학우회",
        "library": "",
        "school_id": 52829,
        "primaryname": "京城帝國大學豫科",
        "primaryname_ko": "경성제국대학 예과"
    },
    {
        "book_id": 10658,
        "book_title": "(京城帝國大學豫科) 學友會報 第5號",
        "book_title_ko": "(경성제국대학예과) 학우회보 제5호",
        "publish_date": "1929.02.28",
        "publish_year": 1929,
        "publish_month": 2,
        "publish_day": 28,
        "publisher": "荒內眞佐治 京城帝國大學 豫科 學友會",
        "publisher_ko": "황내진좌치 경성제국대학 예과 학우회",
        "library": "국립중앙도서관",
        "school_id": 52829,
        "primaryname": "京城帝國大學豫科",
        "primaryname_ko": "경성제국대학 예과"
    },
    {
        "book_id": 10663,
        "book_title": "(慶尙北道師範學校) 校友 第1號",
        "book_title_ko": "(경상북도사범학교) 교우 제1호",
        "publish_date": "1926.04.30",
        "publish_year": 1926,
        "publish_month": 4,
        "publish_day": 30,
        "publisher": "中村亮平 慶尙北道公立師範學校 校友會",
        "publisher_ko": "중촌량평 경상북도공립사범학교 교우회",
        "library": "국회도서관○",
        "school_id": 52830,
        "primaryname": "慶尙北道師範學校",
        "primaryname_ko": "경상북도사범학교"
    },
    {
        "book_id": 10664,
        "book_title": "(京城師範學校) 醇和會報 第12號",
        "book_title_ko": "(경성사범학교) 순화회보 제12호",
        "publish_date": "1929.11.15",
        "publish_year": 1929,
        "publish_month": 11,
        "publish_day": 15,
        "publisher": "宮原眞太 京城師範學校 醇和會",
        "publisher_ko": "궁원진태 경성사범학교 순화회",
        "library": "국립중앙도서관○",
        "school_id": 52831,
        "primaryname": "京城師範學校",
        "primaryname_ko": "경성사범학교"
    },
    {
        "book_id": 10665,
        "book_title": "(京城師範學校) 醇和會報 第21號",
        "book_title_ko": "(경성사범학교) 순화회보 제21호",
        "publish_date": "1934.12.20",
        "publish_year": 1934,
        "publish_month": 12,
        "publish_day": 20,
        "publisher": "鹽飽順治 京城師範學校 同窓醇和會",
        "publisher_ko": "염포순치 경성사범학교 동창순화회",
        "library": "국회도서관○",
        "school_id": 52831,
        "primaryname": "京城師範學校",
        "primaryname_ko": "경성사범학교"
    },
    {
        "book_id": 10666,
        "book_title": "(京城師範學校) 朝光 第11號 時局特輯號",
        "book_title_ko": "(경성사범학교) 조광 제11호 시국특집호",
        "publish_date": "1938.03.23",
        "publish_year": 1938,
        "publish_month": 3,
        "publish_day": 23,
        "publisher": "久保次助 京城師範學校 學友醇和會",
        "publisher_ko": "구보차조 경성사범학교 학우순화회",
        "library": "한국교원대 교육박물관?○",
        "school_id": 52831,
        "primaryname": "京城師範學校",
        "primaryname_ko": "경성사범학교"
    },
    {
        "book_id": 10667,
        "book_title": "(京城師範學校) 朝光 第12號 長期建設號",
        "book_title_ko": "(경성사범학교) 조광 제12호 장기건설호",
        "publish_date": "1939.03.25",
        "publish_year": 1939,
        "publish_month": 3,
        "publish_day": 25,
        "publisher": "篠田隆治 京城師範學校 學友醇和會",
        "publisher_ko": "소전륭치 경성사범학교 학우순화회",
        "library": "한국교원대 교육박물관?○",
        "school_id": 52831,
        "primaryname": "京城師範學校",
        "primaryname_ko": "경성사범학교"
    },
    {
        "book_id": 10668,
        "book_title": "(京城師範學校) 朝光 第14號",
        "book_title_ko": "(경성사범학교) 조광 제14호",
        "publish_date": "1940.00.00",
        "publish_year": 1940,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城師範學校 學友會",
        "publisher_ko": "경성사범학교 학우회",
        "library": "",
        "school_id": 52831,
        "primaryname": "京城師範學校",
        "primaryname_ko": "경성사범학교"
    },
    {
        "book_id": 10669,
        "book_title": "(全州師範學校) 濟美 創刊號",
        "book_title_ko": "(전주사범학교) 제미 창간호",
        "publish_date": "1937.03.24",
        "publish_year": 1937,
        "publish_month": 3,
        "publish_day": 24,
        "publisher": "全州師範學校濟美學友會",
        "publisher_ko": "전주사범학교제미학우회",
        "library": "서울대",
        "school_id": 52832,
        "primaryname": "全州師範學校",
        "primaryname_ko": "전주사범학교"
    },
    {
        "book_id": 10670,
        "book_title": "(平壤師範學校) 校友會誌 第6號",
        "book_title_ko": "(평양사범학교) 교우회지 제6호",
        "publish_date": "1937.02.28",
        "publish_year": 1937,
        "publish_month": 2,
        "publish_day": 28,
        "publisher": "平壤師範學校 校友會",
        "publisher_ko": "평양사범학교 교우회",
        "library": "",
        "school_id": 52833,
        "primaryname": "平壤師範學校",
        "primaryname_ko": "평양사범학교"
    },
    {
        "book_id": 10679,
        "book_title": "(江景商業學校) 校友會誌 第12號",
        "book_title_ko": "(강경상업학교) 교우회지 제12호",
        "publish_date": "1936.03.25",
        "publish_year": 1936,
        "publish_month": 3,
        "publish_day": 25,
        "publisher": "江景公立商業學校 同窓會",
        "publisher_ko": "강경공립상업학교 동창회",
        "library": "△",
        "school_id": 52836,
        "primaryname": "江景商業學校",
        "primaryname_ko": "강경상업학교"
    },
    {
        "book_id": 10680,
        "book_title": "(京畿商業學校) 聽松 第3號",
        "book_title_ko": "(경기상업학교) 청송 제3호",
        "publish_date": "1937.09.30",
        "publish_year": 1937,
        "publish_month": 9,
        "publish_day": 30,
        "publisher": "水崎渟一 京畿公立商業學校 校友會",
        "publisher_ko": "수기정일 경기공립상업학교 교우회",
        "library": "국회도서관○",
        "school_id": 52837,
        "primaryname": "京畿商業學校",
        "primaryname_ko": "경기상업학교"
    },
    {
        "book_id": 10681,
        "book_title": "(京城農業學校) 京農 昭和15年度",
        "book_title_ko": "(경성농업학교) 경농 소화15년도",
        "publish_date": "1941.03.05",
        "publish_year": 1941,
        "publish_month": 3,
        "publish_day": 5,
        "publisher": "永井陞 京城公立農業學校 校友會 同窓會",
        "publisher_ko": "영정승 경성공립농업학교 교우회 동창회",
        "library": "국회도서관○",
        "school_id": 52838,
        "primaryname": "京城農業學校",
        "primaryname_ko": "경성농업학교"
    },
    {
        "book_id": 10682,
        "book_title": "(京城農業學校) 京農 第10號",
        "book_title_ko": "(경성농업학교) 경농 제10호",
        "publish_date": "1934.03.24",
        "publish_year": 1934,
        "publish_month": 3,
        "publish_day": 24,
        "publisher": "小笠原安重 京城公立農業學校 校友會 同窓會",
        "publisher_ko": "소립원안중 경성공립농업학교 교우회 동창회",
        "library": "서강대○",
        "school_id": 52838,
        "primaryname": "京城農業學校",
        "primaryname_ko": "경성농업학교"
    },
    {
        "book_id": 10683,
        "book_title": "(京城農業學校) 京農 第11號",
        "book_title_ko": "(경성농업학교) 경농 제11호",
        "publish_date": "1935.03.00",
        "publish_year": 1935,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "京城公立農業學校 校友會 同窓會",
        "publisher_ko": "경성공립농업학교 교우회 동창회",
        "library": "국회도서관△",
        "school_id": 52838,
        "primaryname": "京城農業學校",
        "primaryname_ko": "경성농업학교"
    },
    {
        "book_id": 10684,
        "book_title": "(京城農業學校) 京農 第12號",
        "book_title_ko": "(경성농업학교) 경농 제12호",
        "publish_date": "1936.03.31",
        "publish_year": 1936,
        "publish_month": 3,
        "publish_day": 31,
        "publisher": "宇部宮與曾次 京城公立農業學校 校友會 同窓會",
        "publisher_ko": "우부궁여증차 경성공립농업학교 교우회 동창회",
        "library": "국회도서관△",
        "school_id": 52838,
        "primaryname": "京城農業學校",
        "primaryname_ko": "경성농업학교"
    },
    {
        "book_id": 10685,
        "book_title": "(京城農業學校) 京農 第13號",
        "book_title_ko": "(경성농업학교) 경농 제13호",
        "publish_date": "1937.03.06",
        "publish_year": 1937,
        "publish_month": 3,
        "publish_day": 6,
        "publisher": "宇都宮與曾治 京城公立農業學校 校友會 同窓會",
        "publisher_ko": "우도궁여증치 경성공립농업학교 교우회 동창회",
        "library": "서강대○",
        "school_id": 52838,
        "primaryname": "京城農業學校",
        "primaryname_ko": "경성농업학교"
    },
    {
        "book_id": 10686,
        "book_title": "(京城農業學校) 京農 第15號",
        "book_title_ko": "(경성농업학교) 경농 제15호",
        "publish_date": "1940.03.03",
        "publish_year": 1940,
        "publish_month": 3,
        "publish_day": 3,
        "publisher": "永井陞 京城公立農業學校 校友會 同窓會",
        "publisher_ko": "영정승 경성공립농업학교 교우회 동창회",
        "library": "서강대○",
        "school_id": 52838,
        "primaryname": "京城農業學校",
        "primaryname_ko": "경성농업학교"
    },
    {
        "book_id": 10687,
        "book_title": "(京城農業學校) 京農 第18號",
        "book_title_ko": "(경성농업학교) 경농 제18호",
        "publish_date": "1942.04.15",
        "publish_year": 1942,
        "publish_month": 4,
        "publish_day": 15,
        "publisher": "三好寬 京城公立農業學校 校友會 同窓會",
        "publisher_ko": "삼호관 경성공립농업학교 교우회 동창회",
        "library": "국회도서관;서강대○",
        "school_id": 52838,
        "primaryname": "京城農業學校",
        "primaryname_ko": "경성농업학교"
    },
    {
        "book_id": 10688,
        "book_title": "(京城農業學校) 京農 第8號",
        "book_title_ko": "(경성농업학교) 경농 제8호",
        "publish_date": "1932.03.20",
        "publish_year": 1932,
        "publish_month": 3,
        "publish_day": 20,
        "publisher": "野村穩 京城公立農業學校 校友會 同窓會",
        "publisher_ko": "야촌온 경성공립농업학교 교우회 동창회",
        "library": "국회도서관△",
        "school_id": 52838,
        "primaryname": "京城農業學校",
        "primaryname_ko": "경성농업학교"
    },
    {
        "book_id": 10689,
        "book_title": "(京城農業學校) 京農 第9號",
        "book_title_ko": "(경성농업학교) 경농 제9호",
        "publish_date": "1933.03.10",
        "publish_year": 1933,
        "publish_month": 3,
        "publish_day": 10,
        "publisher": "近藤英男 京城公立農業學校 校友會 同窓會",
        "publisher_ko": "근등영남 경성공립농업학교 교우회 동창회",
        "library": "국회도서관△",
        "school_id": 52838,
        "primaryname": "京城農業學校",
        "primaryname_ko": "경성농업학교"
    },
    {
        "book_id": 10690,
        "book_title": "(京城工學院) 工友 第1號",
        "book_title_ko": "(경성공학원) 공우 제1호",
        "publish_date": "1929.02.09",
        "publish_year": 1929,
        "publish_month": 2,
        "publish_day": 9,
        "publisher": "桝田直人 京城工學院 工友會",
        "publisher_ko": "승전직인 경성공학원 공우회",
        "library": "△",
        "school_id": 52839,
        "primaryname": "京城工學院",
        "primaryname_ko": "경성공학원"
    },
    {
        "book_id": 10691,
        "book_title": "(京城工學院) 工友 第2號",
        "book_title_ko": "(경성공학원) 공우 제2호",
        "publish_date": "1929.09.01",
        "publish_year": 1929,
        "publish_month": 9,
        "publish_day": 1,
        "publisher": "桝田直人 京城工學院 工友會",
        "publisher_ko": "승전직인 경성공학원 공우회",
        "library": "○",
        "school_id": 52839,
        "primaryname": "京城工學院",
        "primaryname_ko": "경성공학원"
    },
    {
        "book_id": 10692,
        "book_title": "(京城實業專修學校) 京實 第3號",
        "book_title_ko": "(경성실업전수학교) 경실 제3호",
        "publish_date": "1932.03.28",
        "publish_year": 1932,
        "publish_month": 3,
        "publish_day": 28,
        "publisher": "朴寅圭 京城實業專修學校 校友會",
        "publisher_ko": "박인규 경성실업전수학교 교우회",
        "library": "○",
        "school_id": 52840,
        "primaryname": "京城實業專修學校",
        "primaryname_ko": "경성실업전수학교"
    },
    {
        "book_id": 10693,
        "book_title": "(京城實業專修學校) 京實 第5號",
        "book_title_ko": "(경성실업전수학교) 경실 제5호",
        "publish_date": "1934.04.30",
        "publish_year": 1934,
        "publish_month": 4,
        "publish_day": 30,
        "publisher": "朴學圭 京城實業專修學校 校友會",
        "publisher_ko": "박학규 경성실업전수학교 교우회",
        "library": "○",
        "school_id": 52840,
        "primaryname": "京城實業專修學校",
        "primaryname_ko": "경성실업전수학교"
    },
    {
        "book_id": 10694,
        "book_title": "(忠淸南道農業學校) 校友會報 第4號",
        "book_title_ko": "(충청남도농업학교) 교우회보 제4호",
        "publish_date": "1925.12.21",
        "publish_year": 1925,
        "publish_month": 12,
        "publish_day": 21,
        "publisher": "鮫島一二 忠淸南道公立農業學校 校友會",
        "publisher_ko": "교도일이 충청남도공립농업학교 교우회",
        "library": "○",
        "school_id": 52841,
        "primaryname": "忠淸南道農業學校",
        "primaryname_ko": "충청남도농업학교"
    },
    {
        "book_id": 10695,
        "book_title": "(大東商業學校) 大東 創刊號",
        "book_title_ko": "(대동상업학교) 대동 창간호",
        "publish_date": "1936.03.05",
        "publish_year": 1936,
        "publish_month": 3,
        "publish_day": 5,
        "publisher": "大東商業學校 校友會",
        "publisher_ko": "대동상업학교 교우회",
        "library": "△",
        "school_id": 52842,
        "primaryname": "大東商業學校",
        "primaryname_ko": "대동상업학교"
    },
    {
        "book_id": 10696,
        "book_title": "(木浦商業學校) 回想譜 ",
        "book_title_ko": "(목포상업학교) 회상보 ",
        "publish_date": "1938.03.00",
        "publish_year": 1938,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "木浦公立商業學校",
        "publisher_ko": "목포공립상업학교",
        "library": "△",
        "school_id": 52965,
        "primaryname": "木浦公立商業學校",
        "primaryname_ko": "목포공립상업학교"
    },
    {
        "book_id": 10696,
        "book_title": "(木浦商業學校) 回想譜 ",
        "book_title_ko": "(목포상업학교) 회상보 ",
        "publish_date": "1938.03.00",
        "publish_year": 1938,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "木浦公立商業學校",
        "publisher_ko": "목포공립상업학교",
        "library": "△",
        "school_id": 52843,
        "primaryname": "木浦商業學校",
        "primaryname_ko": "목포상업학교"
    },
    {
        "book_id": 10697,
        "book_title": "(釜山商業專修學校) 學窓 第23號",
        "book_title_ko": "(부산상업전수학교) 학창 제23호",
        "publish_date": "1910.04.05",
        "publish_year": 1910,
        "publish_month": 4,
        "publish_day": 5,
        "publisher": "藤原元太郞 釜山公立商業專修學校 校友會",
        "publisher_ko": "등원원태랑 부산공립상업전수학교 교우회",
        "library": "국사편찬위원회",
        "school_id": 52844,
        "primaryname": "釜山商業專修學校",
        "primaryname_ko": "부산상업전수학교"
    },
    {
        "book_id": 10698,
        "book_title": "(釜山商業專修學校) 學窓 第24號",
        "book_title_ko": "(부산상업전수학교) 학창 제24호",
        "publish_date": "1930.03.06",
        "publish_year": 1930,
        "publish_month": 3,
        "publish_day": 6,
        "publisher": "足立謙三 釜山公立商業專修學校 校友會",
        "publisher_ko": "족립겸삼 부산공립상업전수학교 교우회",
        "library": "국사편찬위원회",
        "school_id": 52844,
        "primaryname": "釜山商業專修學校",
        "primaryname_ko": "부산상업전수학교"
    },
    {
        "book_id": 10699,
        "book_title": "(釜山商業專修學校) 學窓 第30號",
        "book_title_ko": "(부산상업전수학교) 학창 제30호",
        "publish_date": "1936.03.00",
        "publish_year": 1936,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "釜山公立商業專修學校 校友會",
        "publisher_ko": "부산공립상업전수학교 교우회",
        "library": "국사편찬위원회",
        "school_id": 52844,
        "primaryname": "釜山商業專修學校",
        "primaryname_ko": "부산상업전수학교"
    },
    {
        "book_id": 10700,
        "book_title": "(釜山商業專修學校) 學窓 第9號",
        "book_title_ko": "(부산상업전수학교) 학창 제9호",
        "publish_date": "1919.11.25",
        "publish_year": 1919,
        "publish_month": 11,
        "publish_day": 25,
        "publisher": "足立謙三 釜山公立商業專修學校 校友會",
        "publisher_ko": "족립겸삼 부산공립상업전수학교 교우회",
        "library": "국사편찬위원회",
        "school_id": 52844,
        "primaryname": "釜山商業專修學校",
        "primaryname_ko": "부산상업전수학교"
    },
    {
        "book_id": 10701,
        "book_title": "(釜山第二商業學校) 金蓮 19號 25週年特輯號",
        "book_title_ko": "(부산제이상업학교) 금련 19호 25주년특집호",
        "publish_date": "1935.02.03",
        "publish_year": 1935,
        "publish_month": 2,
        "publish_day": 3,
        "publisher": "釜山第二公立商業學校 校友會",
        "publisher_ko": "부산제이공립상업학교 교우회",
        "library": "△",
        "school_id": 52845,
        "primaryname": "釜山第二商業學校",
        "primaryname_ko": "부산제이상업학교"
    },
    {
        "book_id": 10702,
        "book_title": "(善隣商業學校) 靑坡 第12號",
        "book_title_ko": "(선린상업학교) 청파 제12호",
        "publish_date": "1933.01.00",
        "publish_year": 1933,
        "publish_month": 1,
        "publish_day": 0,
        "publisher": "善隣商業學校 校友會",
        "publisher_ko": "선린상업학교 교우회",
        "library": "△",
        "school_id": 52846,
        "primaryname": "善隣商業學校",
        "primaryname_ko": "선린상업학교"
    },
    {
        "book_id": 10703,
        "book_title": "(善隣商業學校) 靑坡 第13號",
        "book_title_ko": "(선린상업학교) 청파 제13호",
        "publish_date": "1934.01.00",
        "publish_year": 1934,
        "publish_month": 1,
        "publish_day": 0,
        "publisher": "善隣商業學校 校友會",
        "publisher_ko": "선린상업학교 교우회",
        "library": "△",
        "school_id": 52846,
        "primaryname": "善隣商業學校",
        "primaryname_ko": "선린상업학교"
    },
    {
        "book_id": 10704,
        "book_title": "(崇仁商業學校) 崇仁 創刊號",
        "book_title_ko": "(숭인상업학교) 숭인 창간호",
        "publish_date": "1926.00.00",
        "publish_year": 1926,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "崇仁學友會",
        "publisher_ko": "숭인학우회",
        "library": "△",
        "school_id": 52847,
        "primaryname": "崇仁商業學校",
        "primaryname_ko": "숭인상업학교"
    },
    {
        "book_id": 10705,
        "book_title": "(裡里農林學校) 鷄林 4號",
        "book_title_ko": "(이리농림학교) 계림 4호",
        "publish_date": "1930.00.00",
        "publish_year": 1930,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "裡里公立農林學校 校友會",
        "publisher_ko": "이리공립농림학교 교우회",
        "library": "△",
        "school_id": 52848,
        "primaryname": "裡里農林學校",
        "primaryname_ko": "이리농림학교"
    },
    {
        "book_id": 10706,
        "book_title": "(忠州農業學校) 校友會報 第2號",
        "book_title_ko": "(충주농업학교) 교우회보 제2호",
        "publish_date": "1935.06.25",
        "publish_year": 1935,
        "publish_month": 6,
        "publish_day": 25,
        "publisher": "海老原虎雄 忠州公立農業學校 校友會",
        "publisher_ko": "해로원호웅 충주공립농업학교 교우회",
        "library": "△",
        "school_id": 52849,
        "primaryname": "忠州農業學校",
        "primaryname_ko": "충주농업학교"
    },
    {
        "book_id": 10707,
        "book_title": "(忠州農業學校) 校友會報 第3號",
        "book_title_ko": "(충주농업학교) 교우회보 제3호",
        "publish_date": "1936.10.30",
        "publish_year": 1936,
        "publish_month": 10,
        "publish_day": 30,
        "publisher": "澤田辰雄 忠州公立農業學校 校友會",
        "publisher_ko": "택전진웅 충주공립농업학교 교우회",
        "library": "△",
        "school_id": 52849,
        "primaryname": "忠州農業學校",
        "primaryname_ko": "충주농업학교"
    },
    {
        "book_id": 10708,
        "book_title": "(忠淸北道農業學校) 校友會誌 第10號",
        "book_title_ko": "(충청북도농업학교) 교우회지 제10호",
        "publish_date": "1930.03.00",
        "publish_year": 1930,
        "publish_month": 3,
        "publish_day": 0,
        "publisher": "忠淸北道公立農業學校 校友會",
        "publisher_ko": "충청북도공립농업학교 교우회",
        "library": "△",
        "school_id": 52850,
        "primaryname": "忠淸北道農業學校",
        "primaryname_ko": "충청북도농업학교"
    },
    {
        "book_id": 10709,
        "book_title": "(忠淸北道農業學校) 校友會誌 第9號",
        "book_title_ko": "(충청북도농업학교) 교우회지 제9호",
        "publish_date": "1929.01.10",
        "publish_year": 1929,
        "publish_month": 1,
        "publish_day": 10,
        "publisher": "小㑨晟 忠淸北道公立農業學校 校友會",
        "publisher_ko": "소오성 충청북도공립농업학교 교우회",
        "library": "○",
        "school_id": 52850,
        "primaryname": "忠淸北道農業學校",
        "primaryname_ko": "충청북도농업학교"
    },
    {
        "book_id": 10710,
        "book_title": "(平壤農業學校) 校友會會報 創刊號",
        "book_title_ko": "(평양농업학교) 교우회회보 창간호",
        "publish_date": "1932.01.31",
        "publish_year": 1932,
        "publish_month": 1,
        "publish_day": 31,
        "publisher": "倉木純一 平壤公立農業學校 校友會",
        "publisher_ko": "창목순일 평양공립농업학교 교우회",
        "library": "△",
        "school_id": 52851,
        "primaryname": "平壤農業學校",
        "primaryname_ko": "평양농업학교"
    },
    {
        "book_id": 10711,
        "book_title": "(協成實業學校) 協實 第2號",
        "book_title_ko": "(협성실업학교) 협실 제2호",
        "publish_date": "1930.05.03",
        "publish_year": 1930,
        "publish_month": 5,
        "publish_day": 3,
        "publisher": "黃大闢 協成實業學校 學生會",
        "publisher_ko": "황대벽 협성실업학교 학생회",
        "library": "서강대○",
        "school_id": 52852,
        "primaryname": "協成實業學校",
        "primaryname_ko": "협성실업학교"
    },
    {
        "book_id": 10712,
        "book_title": "(協成實業學校) 協實 創刊號",
        "book_title_ko": "(협성실업학교) 협실 창간호",
        "publish_date": "1929.07.12",
        "publish_year": 1929,
        "publish_month": 7,
        "publish_day": 12,
        "publisher": "黃大關 協成實業學校 學生會",
        "publisher_ko": "황대관 협성실업학교 학생회",
        "library": "서울대",
        "school_id": 52852,
        "primaryname": "協成實業學校",
        "primaryname_ko": "협성실업학교"
    },
    {
        "book_id": 10757,
        "book_title": "(同德女子高等普通學校) 同德 第2號",
        "book_title_ko": "(동덕여자고등보통학교) 동덕 제2호",
        "publish_date": "1929.00.00",
        "publish_year": 1929,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "同德女子高等普通學校 同德學友會",
        "publisher_ko": "동덕여자고등보통학교 동덕학우회",
        "library": "",
        "school_id": 52883,
        "primaryname": "同德女子高等普通學校",
        "primaryname_ko": "동덕여자고등보통학교"
    },
    {
        "book_id": 10758,
        "book_title": "(同德女子高等普通學校) 同進 第1號",
        "book_title_ko": "(동덕여자고등보통학교) 동진 제1호",
        "publish_date": "1931.00.00",
        "publish_year": 1931,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "同德女子高等普通學校 同進會",
        "publisher_ko": "동덕여자고등보통학교 동진회",
        "library": "",
        "school_id": 52883,
        "primaryname": "同德女子高等普通學校",
        "primaryname_ko": "동덕여자고등보통학교"
    },
    {
        "book_id": 10759,
        "book_title": "(同德女子高等普通學校) 同進會報 ",
        "book_title_ko": "(동덕여자고등보통학교) 동진회보 ",
        "publish_date": "1938.00.00",
        "publish_year": 1938,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "同德女子高等普通學校 同進會",
        "publisher_ko": "동덕여자고등보통학교 동진회",
        "library": "",
        "school_id": 52883,
        "primaryname": "同德女子高等普通學校",
        "primaryname_ko": "동덕여자고등보통학교"
    },
    {
        "book_id": 10760,
        "book_title": "(培花女子高等普通學校) 培花 第10號",
        "book_title_ko": "(배화여자고등보통학교) 배화 제10호",
        "publish_date": "1936.11.13",
        "publish_year": 1936,
        "publish_month": 11,
        "publish_day": 13,
        "publisher": "培花女子高等普通學校 校友會",
        "publisher_ko": "배화녀자고등보통학교 교우회",
        "library": "",
        "school_id": 52884,
        "primaryname": "培花女子高等普通學校",
        "primaryname_ko": "배화여자고등보통학교"
    },
    {
        "book_id": 10761,
        "book_title": "(培花女子高等普通學校) 培花 第11號",
        "book_title_ko": "(배화여자고등보통학교) 배화 제11호",
        "publish_date": "1938.02.21",
        "publish_year": 1938,
        "publish_month": 2,
        "publish_day": 21,
        "publisher": "培花女子高等普通學校 校友會",
        "publisher_ko": "배화녀자고등보통학교 교우회",
        "library": "",
        "school_id": 52884,
        "primaryname": "培花女子高等普通學校",
        "primaryname_ko": "배화여자고등보통학교"
    },
    {
        "book_id": 10762,
        "book_title": "(培花女子高等普通學校) 培花 第12號",
        "book_title_ko": "(배화여자고등보통학교) 배화 제12호",
        "publish_date": "1940.00.00",
        "publish_year": 1940,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "培花女子高等普通學校 校友會",
        "publisher_ko": "배화녀자고등보통학교 교우회",
        "library": "",
        "school_id": 52884,
        "primaryname": "培花女子高等普通學校",
        "primaryname_ko": "배화여자고등보통학교"
    },
    {
        "book_id": 10763,
        "book_title": "(培花女子高等普通學校) 培花 第2號",
        "book_title_ko": "(배화여자고등보통학교) 배화 제2호",
        "publish_date": "1930.05.28",
        "publish_year": 1930,
        "publish_month": 5,
        "publish_day": 28,
        "publisher": "池益水 培花女子高等普通學校 校友會",
        "publisher_ko": "지익수 배화녀자고등보통학교 교우회",
        "library": "국회도서관;서강대○",
        "school_id": 52884,
        "primaryname": "培花女子高等普通學校",
        "primaryname_ko": "배화여자고등보통학교"
    },
    {
        "book_id": 10764,
        "book_title": "(培花女子高等普通學校) 培花 第4號",
        "book_title_ko": "(배화여자고등보통학교) 배화 제4호",
        "publish_date": "1932.07.13",
        "publish_year": 1932,
        "publish_month": 7,
        "publish_day": 13,
        "publisher": "罕利孚義 培花女子高等普通學校 校友會",
        "publisher_ko": "한리부의 배화여자고등보통학교 교우회",
        "library": "국회도서관○",
        "school_id": 52884,
        "primaryname": "培花女子高等普通學校",
        "primaryname_ko": "배화여자고등보통학교"
    },
    {
        "book_id": 10765,
        "book_title": "(培花女子高等普通學校) 培花 第5號",
        "book_title_ko": "(배화여자고등보통학교) 배화 제5호",
        "publish_date": "1933.06.27",
        "publish_year": 1933,
        "publish_month": 6,
        "publish_day": 27,
        "publisher": "罕利孚義 培花女子高等普通學校 校友會",
        "publisher_ko": "한리부의 배화녀자고등보통학교 교우회",
        "library": "독립기념관",
        "school_id": 52884,
        "primaryname": "培花女子高等普通學校",
        "primaryname_ko": "배화여자고등보통학교"
    },
    {
        "book_id": 10766,
        "book_title": "(培花女子高等普通學校) 培花 第6號",
        "book_title_ko": "(배화여자고등보통학교) 배화 제6호",
        "publish_date": "1934.07.17",
        "publish_year": 1934,
        "publish_month": 7,
        "publish_day": 17,
        "publisher": "培花女子高等普通學校 校友會",
        "publisher_ko": "배화녀자고등보통학교 교우회",
        "library": "",
        "school_id": 52884,
        "primaryname": "培花女子高等普通學校",
        "primaryname_ko": "배화여자고등보통학교"
    },
    {
        "book_id": 10767,
        "book_title": "(培花女子高等普通學校) 培花 第7號",
        "book_title_ko": "(배화여자고등보통학교) 배화 제7호",
        "publish_date": "1934.12.31",
        "publish_year": 1934,
        "publish_month": 12,
        "publish_day": 31,
        "publisher": "培花女子高等普通學校 校友會",
        "publisher_ko": "배화녀자고등보통학교 교우회",
        "library": "",
        "school_id": 52884,
        "primaryname": "培花女子高等普通學校",
        "primaryname_ko": "배화여자고등보통학교"
    },
    {
        "book_id": 10768,
        "book_title": "(培花女子高等普通學校) 培花 第8號",
        "book_title_ko": "(배화여자고등보통학교) 배화 제8호",
        "publish_date": "1935.07.21",
        "publish_year": 1935,
        "publish_month": 7,
        "publish_day": 21,
        "publisher": "罕利孚義 培花女子高等普通學校 校友會",
        "publisher_ko": "한리부의 배화여자고등보통학교 교우회",
        "library": "국회도서관○",
        "school_id": 52884,
        "primaryname": "培花女子高等普通學校",
        "primaryname_ko": "배화여자고등보통학교"
    },
    {
        "book_id": 10769,
        "book_title": "(培花女子高等普通學校) 培花 第9號",
        "book_title_ko": "(배화여자고등보통학교) 배화 제9호",
        "publish_date": "1936.02.13",
        "publish_year": 1936,
        "publish_month": 2,
        "publish_day": 13,
        "publisher": "培花女子高等普通學校 校友會",
        "publisher_ko": "배화녀자고등보통학교 교우회",
        "library": "",
        "school_id": 52884,
        "primaryname": "培花女子高等普通學校",
        "primaryname_ko": "배화여자고등보통학교"
    },
    {
        "book_id": 10770,
        "book_title": "(培花女子高等普通學校) 培花 創刊號",
        "book_title_ko": "(배화여자고등보통학교) 배화 창간호",
        "publish_date": "1929.05.10",
        "publish_year": 1929,
        "publish_month": 5,
        "publish_day": 10,
        "publisher": "罕利孚義 培花女子高等普通學校 校友會",
        "publisher_ko": "한리부의 배화여자고등보통학교 교우회",
        "library": "국회도서관○",
        "school_id": 52884,
        "primaryname": "培花女子高等普通學校",
        "primaryname_ko": "배화여자고등보통학교"
    },
    {
        "book_id": 10771,
        "book_title": "(釜山女子高等普通學校) 會誌 創刊號",
        "book_title_ko": "(부산여자고등보통학교) 회지 창간호",
        "publish_date": "1931.00.00",
        "publish_year": 1931,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "釜山女子高等普通學校",
        "publisher_ko": "부산녀자고등보통학교",
        "library": "○",
        "school_id": 52991,
        "primaryname": "釜山女子高等普通學校",
        "primaryname_ko": "부산녀자고등보통학교"
    },
    {
        "book_id": 10771,
        "book_title": "(釜山女子高等普通學校) 會誌 創刊號",
        "book_title_ko": "(부산여자고등보통학교) 회지 창간호",
        "publish_date": "1931.00.00",
        "publish_year": 1931,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "釜山女子高等普通學校",
        "publisher_ko": "부산녀자고등보통학교",
        "library": "○",
        "school_id": 52885,
        "primaryname": "釜山女子高等普通學校",
        "primaryname_ko": "부산여자고등보통학교"
    },
    {
        "book_id": 10772,
        "book_title": "(淑明女子高等普通學校) 淑明 ",
        "book_title_ko": "(숙명여자고등보통학교) 숙명 ",
        "publish_date": "........",
        "publish_year": 0,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "이정기 淑明女子高等學校 校友會",
        "publisher_ko": "이정기 숙명여자고등학교 교우회",
        "library": "",
        "school_id": 52886,
        "primaryname": "淑明女子高等普通學校",
        "primaryname_ko": "숙명여자고등보통학교"
    },
    {
        "book_id": 10773,
        "book_title": "(淑明女子高等普通學校) 淑明 第14號",
        "book_title_ko": "(숙명여자고등보통학교) 숙명 제14호",
        "publish_date": "1931.07.15",
        "publish_year": 1931,
        "publish_month": 7,
        "publish_day": 15,
        "publisher": "鈴木作次 淑明女子高等普通學校 校友會 學藝部",
        "publisher_ko": "영목작차 숙명여자고등보통학교 교우회 학예부",
        "library": "△",
        "school_id": 52886,
        "primaryname": "淑明女子高等普通學校",
        "primaryname_ko": "숙명여자고등보통학교"
    },
    {
        "book_id": 10774,
        "book_title": "(淑明女子高等普通學校) 淑明 第18號",
        "book_title_ko": "(숙명여자고등보통학교) 숙명 제18호",
        "publish_date": "1935.00.00",
        "publish_year": 1935,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "淑明女子高等普通學校 校友會 文藝部 淑女會",
        "publisher_ko": "숙명여자고등보통학교 교우회 문예부 숙녀회",
        "library": "",
        "school_id": 52886,
        "primaryname": "淑明女子高等普通學校",
        "primaryname_ko": "숙명여자고등보통학교"
    },
    {
        "book_id": 10775,
        "book_title": "(淑明女子高等普通學校) 淑明 第20號",
        "book_title_ko": "(숙명여자고등보통학교) 숙명 제20호",
        "publish_date": "1936.07.10",
        "publish_year": 1936,
        "publish_month": 7,
        "publish_day": 10,
        "publisher": "豊川善曄 淑明女子高等普通學校 校友會",
        "publisher_ko": "풍천선엽 숙명여자고등보통학교 교우회",
        "library": "△",
        "school_id": 52886,
        "primaryname": "淑明女子高等普通學校",
        "primaryname_ko": "숙명여자고등보통학교"
    },
    {
        "book_id": 10776,
        "book_title": "(淑明女子高等普通學校) 淑明 第21號",
        "book_title_ko": "(숙명여자고등보통학교) 숙명 제21호",
        "publish_date": "1937.00.00",
        "publish_year": 1937,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "淑明女子高等普通學校 校友會 文藝部 淑女會",
        "publisher_ko": "숙명여자고등보통학교 교우회 문예부 숙녀회",
        "library": "",
        "school_id": 52886,
        "primaryname": "淑明女子高等普通學校",
        "primaryname_ko": "숙명여자고등보통학교"
    },
    {
        "book_id": 10777,
        "book_title": "(淑明女子高等普通學校) 李校長先生 淑明臨時號",
        "book_title_ko": "(숙명여자고등보통학교) 이교장선생 숙명림시호",
        "publish_date": "1935.07.20",
        "publish_year": 1935,
        "publish_month": 7,
        "publish_day": 20,
        "publisher": "豊川善曄 淑明女子高等普通學校 校友會 文藝部 淑女會",
        "publisher_ko": "풍천선엽 숙명여자고등보통학교 교우회 문예부 숙녀회",
        "library": "서울대",
        "school_id": 52886,
        "primaryname": "淑明女子高等普通學校",
        "primaryname_ko": "숙명여자고등보통학교"
    },
    {
        "book_id": 10778,
        "book_title": "(梨花女子高等普通學校) 梨高 第3號",
        "book_title_ko": "(이화여자고등보통학교) 이고 제3호",
        "publish_date": "1937.00.00",
        "publish_year": 1937,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "梨花女高 學生基督靑年會 文學部",
        "publisher_ko": "이화녀고 학생기독청년회 문학부",
        "library": "",
        "school_id": 52887,
        "primaryname": "梨花女子高等普通學校",
        "primaryname_ko": "이화여자고등보통학교"
    },
    {
        "book_id": 10779,
        "book_title": "(梨花女子高等普通學校) 梨高 創刊號",
        "book_title_ko": "(이화여자고등보통학교) 이고 창간호",
        "publish_date": "1934.12.25",
        "publish_year": 1934,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "亞扁薛羅 梨花女高 學生基督靑年會 文學部",
        "publisher_ko": "아편설라 이화여고 학생기독청년회 문학부",
        "library": "○",
        "school_id": 52887,
        "primaryname": "梨花女子高等普通學校",
        "primaryname_ko": "이화여자고등보통학교"
    },
    {
        "book_id": 10780,
        "book_title": "(一新女子高等普通學校) 一新 創刊號",
        "book_title_ko": "(일신여자고등보통학교) 일신 창간호",
        "publish_date": "1927.12.24",
        "publish_year": 1927,
        "publish_month": 12,
        "publish_day": 24,
        "publisher": "一新女子高等普通學校 校友會",
        "publisher_ko": "일신여자고등보통학교 교우회",
        "library": "△",
        "school_id": 52888,
        "primaryname": "一新女子高等普通學校",
        "primaryname_ko": "일신여자고등보통학교(진주)"
    },
    {
        "book_id": 10781,
        "book_title": "(正義女子高等普通學校) 正義 創刊號",
        "book_title_ko": "(정의여자고등보통학교) 정의 창간호",
        "publish_date": "1934.03.08",
        "publish_year": 1934,
        "publish_month": 3,
        "publish_day": 8,
        "publisher": "正義女子高等普通學校 學生基督敎靑年會",
        "publisher_ko": "정의여자고등보통학교 학생기독교청년회",
        "library": "△",
        "school_id": 52889,
        "primaryname": "正義女子高等普通學校",
        "primaryname_ko": "정의여자고등보통학교"
    },
    {
        "book_id": 10782,
        "book_title": "(進明女子高等普通學校) 進明 嚴校長先生八旬祝賀號",
        "book_title_ko": "(진명여자고등보통학교) 진명 엄교장선생팔순축하호",
        "publish_date": "1934.08.05",
        "publish_year": 1934,
        "publish_month": 8,
        "publish_day": 5,
        "publisher": "字多川美嘉   進明女子高等普通學校",
        "publisher_ko": "자다천미가   진명여자고등보통학교",
        "library": "국회도서관○",
        "school_id": 19037,
        "primaryname": "進明女子高等普通學校",
        "primaryname_ko": "진명여자고등보통학교"
    },
    {
        "book_id": 10782,
        "book_title": "(進明女子高等普通學校) 進明 嚴校長先生八旬祝賀號",
        "book_title_ko": "(진명여자고등보통학교) 진명 엄교장선생팔순축하호",
        "publish_date": "1934.08.05",
        "publish_year": 1934,
        "publish_month": 8,
        "publish_day": 5,
        "publisher": "字多川美嘉   進明女子高等普通學校",
        "publisher_ko": "자다천미가   진명여자고등보통학교",
        "library": "국회도서관○",
        "school_id": 52890,
        "primaryname": "進明女子高等普通學校",
        "primaryname_ko": "진명여자고등보통학교"
    },
    {
        "book_id": 10783,
        "book_title": "(進明女子高等普通學校) 進明 嚴校長壽像建立記念號(昭和11年 9月)",
        "book_title_ko": "(진명여자고등보통학교) 진명 엄교장수상건립기념호(소화11년 9월)",
        "publish_date": "1936.10.28",
        "publish_year": 1936,
        "publish_month": 10,
        "publish_day": 28,
        "publisher": "木間武三  進明女子高等普通學校",
        "publisher_ko": "목간무삼  진명여자고등보통학교",
        "library": "△",
        "school_id": 19037,
        "primaryname": "進明女子高等普通學校",
        "primaryname_ko": "진명여자고등보통학교"
    },
    {
        "book_id": 10783,
        "book_title": "(進明女子高等普通學校) 進明 嚴校長壽像建立記念號(昭和11年 9月)",
        "book_title_ko": "(진명여자고등보통학교) 진명 엄교장수상건립기념호(소화11년 9월)",
        "publish_date": "1936.10.28",
        "publish_year": 1936,
        "publish_month": 10,
        "publish_day": 28,
        "publisher": "木間武三  進明女子高等普通學校",
        "publisher_ko": "목간무삼  진명여자고등보통학교",
        "library": "△",
        "school_id": 52890,
        "primaryname": "進明女子高等普通學校",
        "primaryname_ko": "진명여자고등보통학교"
    },
    {
        "book_id": 10784,
        "book_title": "(進明女子高等普通學校) 校誌 ",
        "book_title_ko": "(진명여자고등보통학교) 교지 ",
        "publish_date": "1936.00.00",
        "publish_year": 1936,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "進明女子高等普通學校",
        "publisher_ko": "진명여자고등보통학교",
        "library": "",
        "school_id": 19037,
        "primaryname": "進明女子高等普通學校",
        "primaryname_ko": "진명여자고등보통학교"
    },
    {
        "book_id": 10784,
        "book_title": "(進明女子高等普通學校) 校誌 ",
        "book_title_ko": "(진명여자고등보통학교) 교지 ",
        "publish_date": "1936.00.00",
        "publish_year": 1936,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "進明女子高等普通學校",
        "publisher_ko": "진명여자고등보통학교",
        "library": "",
        "school_id": 52890,
        "primaryname": "進明女子高等普通學校",
        "primaryname_ko": "진명여자고등보통학교"
    },
    {
        "book_id": 10785,
        "book_title": "(好壽敦女子高等普通學校) 好鐘 第10號",
        "book_title_ko": "(호수돈여자고등보통학교) 호종 제10호",
        "publish_date": "1937.12.20",
        "publish_year": 1937,
        "publish_month": 12,
        "publish_day": 20,
        "publisher": "金熙祥 好壽敦女子高等普通學校 校友會",
        "publisher_ko": "금희상 호수돈여자고등보통학교 교우회",
        "library": "국회도서관○",
        "school_id": 52891,
        "primaryname": "好壽敦女子高等普通學校",
        "primaryname_ko": "호수돈여자고등보통학교"
    },
    {
        "book_id": 10786,
        "book_title": "(好壽敦女子高等普通學校) 好鍾 第2號",
        "book_title_ko": "(호수돈여자고등보통학교) 호종 제2호",
        "publish_date": "1929.07.19",
        "publish_year": 1929,
        "publish_month": 7,
        "publish_day": 19,
        "publisher": "咸錫寶 好壽敦女子高等普通學校 學生基督靑年會",
        "publisher_ko": "함석보 호수돈녀자고등보통학교 학생기독청년회",
        "library": "독립기념관",
        "school_id": 52891,
        "primaryname": "好壽敦女子高等普通學校",
        "primaryname_ko": "호수돈여자고등보통학교"
    },
    {
        "book_id": 10787,
        "book_title": "(好壽敦女子高等普通學校) 好鍾 第4號",
        "book_title_ko": "(호수돈여자고등보통학교) 호종 제4호",
        "publish_date": "1931.11.06",
        "publish_year": 1931,
        "publish_month": 11,
        "publish_day": 6,
        "publisher": "金寶玉 好壽敦女子高等普通學校 校友會",
        "publisher_ko": "금보옥 호수돈녀자고등보통학교 교우회",
        "library": "한국학중앙연구원○",
        "school_id": 52891,
        "primaryname": "好壽敦女子高等普通學校",
        "primaryname_ko": "호수돈여자고등보통학교"
    },
    {
        "book_id": 10788,
        "book_title": "(好壽敦女子高等普通學校) 好鍾 第7號",
        "book_title_ko": "(호수돈여자고등보통학교) 호종 제7호",
        "publish_date": "1934.00.00",
        "publish_year": 1934,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "好壽敦女子高等普通學校 校友會",
        "publisher_ko": "호수돈녀자고등보통학교 교우회",
        "library": "",
        "school_id": 52891,
        "primaryname": "好壽敦女子高等普通學校",
        "primaryname_ko": "호수돈여자고등보통학교"
    },
    {
        "book_id": 10808,
        "book_title": "(京城高等工業學校) 會誌 第11號",
        "book_title_ko": "(경성고등공업학교) 회지 제11호",
        "publish_date": "1933.03.01",
        "publish_year": 1933,
        "publish_month": 3,
        "publish_day": 1,
        "publisher": "石堂雋一 京城高等工業學校 校友會",
        "publisher_ko": "석당준일 경성고등공업학교 교우회",
        "library": "○",
        "school_id": 52895,
        "primaryname": "京城高等工業學校",
        "primaryname_ko": "경성고등공업학교"
    },
    {
        "book_id": 10809,
        "book_title": "(京城高等工業學校) 會誌 第12號",
        "book_title_ko": "(경성고등공업학교) 회지 제12호",
        "publish_date": "1934.03.07",
        "publish_year": 1934,
        "publish_month": 3,
        "publish_day": 7,
        "publisher": "石堂雋一 京城高等工業學校 校友會",
        "publisher_ko": "석당준일 경성고등공업학교 교우회",
        "library": "○",
        "school_id": 52895,
        "primaryname": "京城高等工業學校",
        "primaryname_ko": "경성고등공업학교"
    },
    {
        "book_id": 10810,
        "book_title": "(京城高等工業學校) 會誌 第17號",
        "book_title_ko": "(경성고등공업학교) 회지 제17호",
        "publish_date": "1938.12.25",
        "publish_year": 1938,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "上杉重二郞 京城高等工業學校 校友會",
        "publisher_ko": "상삼중이랑 경성고등공업학교 교우회",
        "library": "○",
        "school_id": 52895,
        "primaryname": "京城高等工業學校",
        "primaryname_ko": "경성고등공업학교"
    },
    {
        "book_id": 10811,
        "book_title": "(京城鑛山專門學校) 京城鑛專會報 第1號",
        "book_title_ko": "(경성광산전문학교) 경성광전회보 제1호",
        "publish_date": "1940.05.28",
        "publish_year": 1940,
        "publish_month": 5,
        "publish_day": 28,
        "publisher": "京城鑛山專門學校 校友會",
        "publisher_ko": "경성광산전문학교 교우회",
        "library": "△",
        "school_id": 52896,
        "primaryname": "京城鑛山專門學校",
        "primaryname_ko": "경성광산전문학교"
    },
    {
        "book_id": 10812,
        "book_title": "(京城女子醫學講習所) 校友會誌 創刊號",
        "book_title_ko": "(경성여자의학강습소) 교우회지 창간호",
        "publish_date": "1934.07.28",
        "publish_year": 1934,
        "publish_month": 7,
        "publish_day": 28,
        "publisher": "金鐸遠 京城女子醫學講習所 校友會",
        "publisher_ko": "금탁원 경성녀자의학강습소 교우회",
        "library": "서울대",
        "school_id": 52897,
        "primaryname": "京城女子醫學講習所",
        "primaryname_ko": "경성여자의학강습소"
    },
    {
        "book_id": 10813,
        "book_title": "(京城法學專門學校) 校友會報 第4號",
        "book_title_ko": "(경성법학전문학교) 교우회보 제4호",
        "publish_date": "1922.12.25",
        "publish_year": 1922,
        "publish_month": 12,
        "publish_day": 25,
        "publisher": "松岡修太郞 京城法學專門學校 校友會",
        "publisher_ko": "송강수태랑 경성법학전문학교 교우회",
        "library": "국회도서관○",
        "school_id": 52898,
        "primaryname": "京城法學專門學校",
        "primaryname_ko": "경성법학전문학교"
    },
    {
        "book_id": 10814,
        "book_title": "(京城法學專門學校) 校友會報 第8號",
        "book_title_ko": "(경성법학전문학교) 교우회보 제8호",
        "publish_date": "1927.02.25",
        "publish_year": 1927,
        "publish_month": 2,
        "publish_day": 25,
        "publisher": "京城法學專門學校 校友會 會報部",
        "publisher_ko": "경성법학전문학교 교우회 회보부",
        "library": "국회도서관○",
        "school_id": 52898,
        "primaryname": "京城法學專門學校",
        "primaryname_ko": "경성법학전문학교"
    },
    {
        "book_id": 10815,
        "book_title": "(京城法學專門學校) 法典會誌 第17號",
        "book_title_ko": "(경성법학전문학교) 법전회지 제17호",
        "publish_date": "1939.07.15",
        "publish_year": 1939,
        "publish_month": 7,
        "publish_day": 15,
        "publisher": "水上祐孝 京城法學專門學校 校友會",
        "publisher_ko": "수상우효 경성법학전문학교 교우회",
        "library": "국회도서관○",
        "school_id": 52898,
        "primaryname": "京城法學專門學校",
        "primaryname_ko": "경성법학전문학교"
    },
    {
        "book_id": 10816,
        "book_title": "(京城齒科醫學專門學校) 曉 第1號",
        "book_title_ko": "(경성치과의학전문학교) 효 제1호",
        "publish_date": "1926.12.15",
        "publish_year": 1926,
        "publish_month": 12,
        "publish_day": 15,
        "publisher": "京城齒科醫學專門學校 校友會",
        "publisher_ko": "경성치과의학전문학교 교우회",
        "library": "△",
        "school_id": 52899,
        "primaryname": "京城齒科醫學專門學校",
        "primaryname_ko": "경성치과의학전문학교"
    },
    {
        "book_id": 10817,
        "book_title": "(大同工業專門學校) 大同工學會會報 第1號",
        "book_title_ko": "(대동공업전문학교) 대동공학회회보 제1호",
        "publish_date": "1942.03.01",
        "publish_year": 1942,
        "publish_month": 3,
        "publish_day": 1,
        "publisher": "高島徹雄 大同工業專門學校 大同工學會",
        "publisher_ko": "고도철웅 대동공업전문학교 대동공학회",
        "library": "△",
        "school_id": 52900,
        "primaryname": "大同工業專門學校",
        "primaryname_ko": "대동공업전문학교"
    },
    {
        "book_id": 10818,
        "book_title": "(普成專門學校) 普專校友會報 辛未號",
        "book_title_ko": "(보성전문학교) 보전교우회보 신미호",
        "publish_date": "1931.09.30",
        "publish_year": 1931,
        "publish_month": 9,
        "publish_day": 30,
        "publisher": "金用茂 普成專門學校 校友會",
        "publisher_ko": "금용무 보성전문학교 교우회",
        "library": "○",
        "school_id": 52901,
        "primaryname": "普成專門學校",
        "primaryname_ko": "보성전문학교"
    },
    {
        "book_id": 10819,
        "book_title": "(普成專門學校) 普專校友會報 第2號",
        "book_title_ko": "(보성전문학교) 보전교우회보 제2호",
        "publish_date": "1934.05.00",
        "publish_year": 1934,
        "publish_month": 5,
        "publish_day": 0,
        "publisher": "普成專門學校 校友會",
        "publisher_ko": "보성전문학교 교우회",
        "library": "",
        "school_id": 52901,
        "primaryname": "普成專門學校",
        "primaryname_ko": "보성전문학교"
    },
    {
        "book_id": 10820,
        "book_title": "(奉先寺佛敎專門講院) 弘法友 第1輯",
        "book_title_ko": "(봉선사불교전문강원) 홍법우 제1집",
        "publish_date": "1938.03.12",
        "publish_year": 1938,
        "publish_month": 3,
        "publish_day": 12,
        "publisher": "李在福 奉先寺 弘法講友會",
        "publisher_ko": "이재복 봉선사 홍법강우회",
        "library": "○",
        "school_id": 52902,
        "primaryname": "奉先寺佛敎專門講院",
        "primaryname_ko": "봉선사 불교전문강원"
    },
    {
        "book_id": 10821,
        "book_title": "(セブランス聯合醫學專門學校) セブランス校友會報 ",
        "book_title_ko": "(セブランス연합의학전문학교) セブランス교우회보 ",
        "publish_date": "2016.12.20",
        "publish_year": 2016,
        "publish_month": 12,
        "publish_day": 20,
        "publisher": "연세대 의대 의사학과, 동은의학박물관",
        "publisher_ko": "연세대 의대 의사학과, 동은의학박물관",
        "library": "",
        "school_id": 52903,
        "primaryname": "セブランス聯合醫學專門學校",
        "primaryname_ko": "세브란스연합의학전문학교"
    },
    {
        "book_id": 10822,
        "book_title": "(セブランス聯合醫學專門學校) セブランス校友會報 第24號",
        "book_title_ko": "(セブランス연합의학전문학교) セブランス교우회보 제24호",
        "publish_date": "1935.06.30",
        "publish_year": 1935,
        "publish_month": 6,
        "publish_day": 30,
        "publisher": "李錫申 セブランス聯合醫學專門學校 校友會",
        "publisher_ko": "이석신 セブランス연합의학전문학교 교우회",
        "library": "○",
        "school_id": 52903,
        "primaryname": "セブランス聯合醫學專門學校",
        "primaryname_ko": "세브란스연합의학전문학교"
    },
    {
        "book_id": 10823,
        "book_title": "(セブランス聯合醫學專門學校) セブランス校友會報 第25號",
        "book_title_ko": "(セブランス연합의학전문학교) セブランス교우회보 제25호",
        "publish_date": "1936.02.01",
        "publish_year": 1936,
        "publish_month": 2,
        "publish_day": 1,
        "publisher": "李錫申 セブランス聯合醫學專門學校 校友會",
        "publisher_ko": "이석신 セブランス연합의학전문학교 교우회",
        "library": "○",
        "school_id": 52903,
        "primaryname": "セブランス聯合醫學專門學校",
        "primaryname_ko": "세브란스연합의학전문학교"
    },
    {
        "book_id": 10824,
        "book_title": "(崇實專門學校) 崇實 第10號",
        "book_title_ko": "(숭실전문학교) 숭실 제10호",
        "publish_date": "1930.12.01",
        "publish_year": 1930,
        "publish_month": 12,
        "publish_day": 1,
        "publisher": "",
        "publisher_ko": "",
        "library": "",
        "school_id": 52904,
        "primaryname": "崇實專門學校",
        "primaryname_ko": "숭실전문학교"
    },
    {
        "book_id": 10825,
        "book_title": "(崇實專門學校) 崇實 第11號",
        "book_title_ko": "(숭실전문학교) 숭실 제11호",
        "publish_date": "1931.06.01",
        "publish_year": 1931,
        "publish_month": 6,
        "publish_day": 1,
        "publisher": "",
        "publisher_ko": "",
        "library": "",
        "school_id": 52904,
        "primaryname": "崇實專門學校",
        "primaryname_ko": "숭실전문학교"
    },
    {
        "book_id": 10826,
        "book_title": "(崇實專門學校) 崇實 第12號",
        "book_title_ko": "(숭실전문학교) 숭실 제12호",
        "publish_date": "1931.12.01",
        "publish_year": 1931,
        "publish_month": 12,
        "publish_day": 1,
        "publisher": "",
        "publisher_ko": "",
        "library": "",
        "school_id": 52904,
        "primaryname": "崇實專門學校",
        "primaryname_ko": "숭실전문학교"
    },
    {
        "book_id": 10827,
        "book_title": "(崇實專門學校) 崇實 第15號",
        "book_title_ko": "(숭실전문학교) 숭실 제15호",
        "publish_date": "1934.03.10",
        "publish_year": 1934,
        "publish_month": 3,
        "publish_day": 10,
        "publisher": "尹山溫 崇實專門學校 文藝部",
        "publisher_ko": "윤산온 숭실전문학교 문예부",
        "library": "△",
        "school_id": 52904,
        "primaryname": "崇實專門學校",
        "primaryname_ko": "숭실전문학교"
    },
    {
        "book_id": 10828,
        "book_title": "(崇實專門學校) 崇實 第5號",
        "book_title_ko": "(숭실전문학교) 숭실 제5호",
        "publish_date": "1927.12.01",
        "publish_year": 1927,
        "publish_month": 12,
        "publish_day": 1,
        "publisher": "",
        "publisher_ko": "",
        "library": "",
        "school_id": 52904,
        "primaryname": "崇實專門學校",
        "primaryname_ko": "숭실전문학교"
    },
    {
        "book_id": 10829,
        "book_title": "(崇實專門學校) 崇實 第6號",
        "book_title_ko": "(숭실전문학교) 숭실 제6호",
        "publish_date": "1928.11.30",
        "publish_year": 1928,
        "publish_month": 11,
        "publish_day": 30,
        "publisher": "",
        "publisher_ko": "",
        "library": "",
        "school_id": 52904,
        "primaryname": "崇實專門學校",
        "primaryname_ko": "숭실전문학교"
    },
    {
        "book_id": 10830,
        "book_title": "(崇實專門學校) 崇實 第9號",
        "book_title_ko": "(숭실전문학교) 숭실 제9호",
        "publish_date": "1930.06.01",
        "publish_year": 1930,
        "publish_month": 6,
        "publish_day": 1,
        "publisher": "",
        "publisher_ko": "",
        "library": "",
        "school_id": 52904,
        "primaryname": "崇實專門學校",
        "primaryname_ko": "숭실전문학교"
    },
    {
        "book_id": 10831,
        "book_title": "(延禧專門學校) 文友 ",
        "book_title_ko": "(연희전문학교) 문우 ",
        "publish_date": "1941.06.05",
        "publish_year": 1941,
        "publish_month": 6,
        "publish_day": 5,
        "publisher": "姜處重 延禧專門學校 文友會 文藝部",
        "publisher_ko": "강처중 연희전문학교 문우회 문예부",
        "library": "국립중앙도서관",
        "school_id": 52905,
        "primaryname": "延禧專門學校",
        "primaryname_ko": "연희전문학교"
    },
    {
        "book_id": 10832,
        "book_title": "(延禧專門學校) 文友 第1號",
        "book_title_ko": "(연희전문학교) 문우 제1호",
        "publish_date": "1932.12.18",
        "publish_year": 1932,
        "publish_month": 12,
        "publish_day": 18,
        "publisher": "韓太壽 延禧文友會",
        "publisher_ko": "한태수 연희문우회",
        "library": "서울대",
        "school_id": 52905,
        "primaryname": "延禧專門學校",
        "primaryname_ko": "연희전문학교"
    },
    {
        "book_id": 10833,
        "book_title": "(延禧專門學校) 延禧 第6號",
        "book_title_ko": "(연희전문학교) 연희 제6호",
        "publish_date": "1926.05.21",
        "publish_year": 1926,
        "publish_month": 5,
        "publish_day": 21,
        "publisher": "白雅悳 延禧學生會 智育部",
        "publisher_ko": "백아덕 연희학생회 지육부",
        "library": "국회도서관○",
        "school_id": 52905,
        "primaryname": "延禧專門學校",
        "primaryname_ko": "연희전문학교"
    },
    {
        "book_id": 10834,
        "book_title": "(延禧專門學校) 延禧 第7號 續刊號",
        "book_title_ko": "(연희전문학교) 연희 제7호 속간호",
        "publish_date": "1931.01.01",
        "publish_year": 1931,
        "publish_month": 1,
        "publish_day": 1,
        "publisher": "柳根錫 延專學生會",
        "publisher_ko": "유근석 연전학생회",
        "library": "국회도서관○",
        "school_id": 52905,
        "primaryname": "延禧專門學校",
        "primaryname_ko": "연희전문학교"
    },
    {
        "book_id": 10835,
        "book_title": "(延禧專門學校) 延禧 第8號",
        "book_title_ko": "(연희전문학교) 연희 제8호",
        "publish_date": "1931.12.22",
        "publish_year": 1931,
        "publish_month": 12,
        "publish_day": 22,
        "publisher": "柳根錫 延專學生會",
        "publisher_ko": "유근석 연전학생회",
        "library": "국회도서관○",
        "school_id": 52905,
        "primaryname": "延禧專門學校",
        "primaryname_ko": "연희전문학교"
    },
    {
        "book_id": 10836,
        "book_title": "(延禧專門學校) 연희 (상,하)",
        "book_title_ko": "(연희전문학교) 연희 (상,하)",
        "publish_date": "2014.00.00",
        "publish_year": 2014,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "연세학풍사업단",
        "publisher_ko": "연세학풍사업단",
        "library": "",
        "school_id": 52905,
        "primaryname": "延禧專門學校",
        "primaryname_ko": "연희전문학교"
    },
    {
        "book_id": 10837,
        "book_title": "(延禧專門學校) 延禧同門會報 第22號",
        "book_title_ko": "(연희전문학교) 연희동문회보 제22호",
        "publish_date": "1941.02.28",
        "publish_year": 1941,
        "publish_month": 2,
        "publish_day": 28,
        "publisher": "H.H.언더우드 延禧專門學校 同門會",
        "publisher_ko": "H.H.언더우드 연희전문학교 동문회",
        "library": "○",
        "school_id": 52905,
        "primaryname": "延禧專門學校",
        "primaryname_ko": "연희전문학교"
    },
    {
        "book_id": 10838,
        "book_title": "(延禧專門學校) 延禧詩蘊 第4號",
        "book_title_ko": "(연희전문학교) 연희시온 제4호",
        "publish_date": "1936.00.00",
        "publish_year": 1936,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "延禧專門學校 學生基督敎靑年會",
        "publisher_ko": "연희전문학교 학생기독교청년회",
        "library": "서강대",
        "school_id": 52905,
        "primaryname": "延禧專門學校",
        "primaryname_ko": "연희전문학교"
    },
    {
        "book_id": 10839,
        "book_title": "(梨花女子專門學校;梨花保育學校) 梨專梨保同窓會誌 第4輯",
        "book_title_ko": "(이화여자전문학교;이화보육학교) 이전리보동창회지 제4집",
        "publish_date": "1940.07.21",
        "publish_year": 1940,
        "publish_month": 7,
        "publish_day": 21,
        "publisher": "梨花女子專門學校 同窓會",
        "publisher_ko": "이화여자전문학교 동창회",
        "library": "△",
        "school_id": 52906,
        "primaryname": "梨花女子專門學校;梨花保育學校",
        "primaryname_ko": "이화여자전문학교;이화보육학교"
    },
    {
        "book_id": 10840,
        "book_title": "(梨花女子專門學校;梨花保育學校) 梨花 第5輯",
        "book_title_ko": "(이화여자전문학교;이화보육학교) 이화 제5집",
        "publish_date": "1934.05.31",
        "publish_year": 1934,
        "publish_month": 5,
        "publish_day": 31,
        "publisher": "朴鳳子 梨花女子專門學校, 梨花保育學校 學生基督敎靑年會 文學部",
        "publisher_ko": "박봉자 이화여자전문학교, 이화보육학교 학생기독교청년회 문학부",
        "library": "서울대",
        "school_id": 52906,
        "primaryname": "梨花女子專門學校;梨花保育學校",
        "primaryname_ko": "이화여자전문학교;이화보육학교"
    },
    {
        "book_id": 10841,
        "book_title": "(朝鮮藥學校) 校友會誌 第6號",
        "book_title_ko": "(조선약학교) 교우회지 제6호",
        "publish_date": "1925.12.15",
        "publish_year": 1925,
        "publish_month": 12,
        "publish_day": 15,
        "publisher": "朝鮮藥學校 校友會",
        "publisher_ko": "조선약학교 교우회",
        "library": "△",
        "school_id": 52907,
        "primaryname": "朝鮮藥學校",
        "primaryname_ko": "조선약학교"
    },
    {
        "book_id": 10842,
        "book_title": "(水原高等農林學校) 同窓會報 第97號",
        "book_title_ko": "(수원고등농림학교) 동창회보 제97호",
        "publish_date": "1943.01.30",
        "publish_year": 1943,
        "publish_month": 1,
        "publish_day": 30,
        "publisher": "西村久三郞 水原高等農林學校 同窓會",
        "publisher_ko": "서촌구삼랑 수원고등농림학교 동창회",
        "library": "△",
        "school_id": 52908,
        "primaryname": "水原高等農林學校",
        "primaryname_ko": "수원고등농림학교"
    },
    {
        "book_id": 10843,
        "book_title": "(水原高等農林學校) 水原農學會報 第2號",
        "book_title_ko": "(수원고등농림학교) 수원농학회보 제2호",
        "publish_date": "1937.04.11",
        "publish_year": 1937,
        "publish_month": 4,
        "publish_day": 11,
        "publisher": "水原高等農林學校 水原農學會",
        "publisher_ko": "수원고등농림학교 수원농학회",
        "library": "△",
        "school_id": 52908,
        "primaryname": "水原高等農林學校",
        "primaryname_ko": "수원고등농림학교"
    },
    {
        "book_id": 10844,
        "book_title": "(水原高等農林學校) 水原農學會報 第3號",
        "book_title_ko": "(수원고등농림학교) 수원농학회보 제3호",
        "publish_date": "1938.03.01",
        "publish_year": 1938,
        "publish_month": 3,
        "publish_day": 1,
        "publisher": "水原高等農林學校 水原農學會",
        "publisher_ko": "수원고등농림학교 수원농학회",
        "library": "△",
        "school_id": 52908,
        "primaryname": "水原高等農林學校",
        "primaryname_ko": "수원고등농림학교"
    },
    {
        "book_id": 10845,
        "book_title": "(水原高等農林學校) 水原農學會報 第4號",
        "book_title_ko": "(수원고등농림학교) 수원농학회보 제4호",
        "publish_date": "........",
        "publish_year": 0,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "水原高等農林學校 水原農學會",
        "publisher_ko": "수원고등농림학교 수원농학회",
        "library": "△",
        "school_id": 52908,
        "primaryname": "水原高等農林學校",
        "primaryname_ko": "수원고등농림학교"
    },
    {
        "book_id": 10846,
        "book_title": "(水原高等農林學校) 水原農學會報 第5號",
        "book_title_ko": "(수원고등농림학교) 수원농학회보 제5호",
        "publish_date": "1940.03.31",
        "publish_year": 1940,
        "publish_month": 3,
        "publish_day": 31,
        "publisher": "水原高等農林學校 水原農學會",
        "publisher_ko": "수원고등농림학교 수원농학회",
        "library": "△",
        "school_id": 52908,
        "primaryname": "水原高等農林學校",
        "primaryname_ko": "수원고등농림학교"
    },
    {
        "book_id": 10847,
        "book_title": "(水原高等農林學校) 水原農學會報 第7號",
        "book_title_ko": "(수원고등농림학교) 수원농학회보 제7호",
        "publish_date": "1942.07.25",
        "publish_year": 1942,
        "publish_month": 7,
        "publish_day": 25,
        "publisher": "水原高等農林學校 水原農學會",
        "publisher_ko": "수원고등농림학교 수원농학회",
        "library": "서울대",
        "school_id": 52908,
        "primaryname": "水原高等農林學校",
        "primaryname_ko": "수원고등농림학교"
    },
    {
        "book_id": 10848,
        "book_title": "(水原高等農林學校) 水原農學會報 創刊號",
        "book_title_ko": "(수원고등농림학교) 수원농학회보 창간호",
        "publish_date": "1936.03.31",
        "publish_year": 1936,
        "publish_month": 3,
        "publish_day": 31,
        "publisher": "川口淸利 水原高等農林學校 水原農學會",
        "publisher_ko": "천구청리 수원고등농림학교 수원농학회",
        "library": "국립중앙도서관;서울대△",
        "school_id": 52908,
        "primaryname": "水原高等農林學校",
        "primaryname_ko": "수원고등농림학교"
    },
    {
        "book_id": 10849,
        "book_title": "(水原高等農林學校) 水原學報 第18券 第9號",
        "book_title_ko": "(수원고등농림학교) 수원학보 제18권 제9호",
        "publish_date": "1925.09.10",
        "publish_year": 1925,
        "publish_month": 9,
        "publish_day": 10,
        "publisher": "葛野淺太郞 水原高等農林學校 校友會",
        "publisher_ko": "갈야천태랑 수원고등농림학교 교우회",
        "library": "국회도서관",
        "school_id": 52908,
        "primaryname": "水原高等農林學校",
        "primaryname_ko": "수원고등농림학교"
    },
    {
        "book_id": 10850,
        "book_title": "(水原高等農林學校) 水原學報 第19券 第8號",
        "book_title_ko": "(수원고등농림학교) 수원학보 제19권 제8호",
        "publish_date": "1926.08.10",
        "publish_year": 1926,
        "publish_month": 8,
        "publish_day": 10,
        "publisher": "葛野淺太郞 水原高等農林學校 校友會",
        "publisher_ko": "갈야천태랑 수원고등농림학교 교우회",
        "library": "국회도서관○",
        "school_id": 52908,
        "primaryname": "水原高等農林學校",
        "primaryname_ko": "수원고등농림학교"
    },
    {
        "book_id": 10851,
        "book_title": "(水原高等農林學校) 水原學報 第20券 第2號",
        "book_title_ko": "(수원고등농림학교) 수원학보 제20권 제2호",
        "publish_date": "1927.12.10",
        "publish_year": 1927,
        "publish_month": 12,
        "publish_day": 10,
        "publisher": "葛野淺太郞 水原高等農林學校 校友會",
        "publisher_ko": "갈야천태랑 수원고등농림학교 교우회",
        "library": "국회도서관○",
        "school_id": 52908,
        "primaryname": "水原高等農林學校",
        "primaryname_ko": "수원고등농림학교"
    },
    {
        "book_id": 10852,
        "book_title": "(水原高等農林學校) 水原學報 第21券 第1號",
        "book_title_ko": "(수원고등농림학교) 수원학보 제21권 제1호",
        "publish_date": "1928.07.10",
        "publish_year": 1928,
        "publish_month": 7,
        "publish_day": 10,
        "publisher": "市島吉太郞 水原高等農林學校 校友會",
        "publisher_ko": "시도길태랑 수원고등농림학교 교우회",
        "library": "국회도서관○",
        "school_id": 52908,
        "primaryname": "水原高等農林學校",
        "primaryname_ko": "수원고등농림학교"
    },
    {
        "book_id": 10853,
        "book_title": "(水原高等農林學校) 水原學報 第41號",
        "book_title_ko": "(수원고등농림학교) 수원학보 제41호",
        "publish_date": "1924.01.10",
        "publish_year": 1924,
        "publish_month": 1,
        "publish_day": 10,
        "publisher": "鈴木外代一 水原高等農林學校 校友會",
        "publisher_ko": "영목외대일 수원고등농림학교 교우회",
        "library": "국회도서관○",
        "school_id": 52908,
        "primaryname": "水原高等農林學校",
        "primaryname_ko": "수원고등농림학교"
    },
    {
        "book_id": 10854,
        "book_title": "(水原高等農林學校) 水原學報 第44號",
        "book_title_ko": "(수원고등농림학교) 수원학보 제44호",
        "publish_date": "1924.03.10",
        "publish_year": 1924,
        "publish_month": 3,
        "publish_day": 10,
        "publisher": "鈴木外代一 水原高等農林學校 校友會",
        "publisher_ko": "영목외대일 수원고등농림학교 교우회",
        "library": "국회도서관○",
        "school_id": 52908,
        "primaryname": "水原高等農林學校",
        "primaryname_ko": "수원고등농림학교"
    },
    {
        "book_id": 10855,
        "book_title": "(中央佛敎專門學校) 藍毘尼(룸비니) 第1輯",
        "book_title_ko": "(중앙불교전문학교) 룸비니 제1집",
        "publish_date": "1937.05.07",
        "publish_year": 1937,
        "publish_month": 5,
        "publish_day": 7,
        "publisher": "梁泳祚 中央佛敎專門學校 學生會",
        "publisher_ko": "양영조 중앙불교전문학교 학생회",
        "library": "국회도서관○",
        "school_id": 52909,
        "primaryname": "中央佛敎專門學校",
        "primaryname_ko": "중앙불교전문학교"
    },
    {
        "book_id": 10856,
        "book_title": "(中央佛敎專門學校) 藍毘尼(룸비니) 第2輯",
        "book_title_ko": "(중앙불교전문학교) 룸비니 제2집",
        "publish_date": "1938.00.00",
        "publish_year": 1938,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "中央佛敎專門學校 學生會",
        "publisher_ko": "중앙불교전문학교 학생회",
        "library": "국회도서관○",
        "school_id": 52909,
        "primaryname": "中央佛敎專門學校",
        "primaryname_ko": "중앙불교전문학교"
    },
    {
        "book_id": 10857,
        "book_title": "(中央佛敎專門學校) 藍毘尼(룸비니) 第3輯",
        "book_title_ko": "(중앙불교전문학교) 룸비니 제3집",
        "publish_date": "1939.01.30",
        "publish_year": 1939,
        "publish_month": 1,
        "publish_day": 30,
        "publisher": "文東漢 中央佛敎專門學校 學生會",
        "publisher_ko": "문동한 중앙불교전문학교 학생회",
        "library": "국회도서관○",
        "school_id": 52909,
        "primaryname": "中央佛敎專門學校",
        "primaryname_ko": "중앙불교전문학교"
    },
    {
        "book_id": 10858,
        "book_title": "(中央佛敎專門學校) 藍毘尼(룸비니) 第4輯",
        "book_title_ko": "(중앙불교전문학교) 룸비니 제4집",
        "publish_date": "1940.03.10",
        "publish_year": 1940,
        "publish_month": 3,
        "publish_day": 10,
        "publisher": "金容泰 中央佛敎專門學校 學生會",
        "publisher_ko": "금용태 중앙불교전문학교 학생회",
        "library": "국회도서관○",
        "school_id": 52909,
        "primaryname": "中央佛敎專門學校",
        "primaryname_ko": "중앙불교전문학교"
    },
    {
        "book_id": 10859,
        "book_title": "(中央佛敎專門學校) 一光 第2號",
        "book_title_ko": "(중앙불교전문학교) 일광 제2호",
        "publish_date": "1929.09.09",
        "publish_year": 1929,
        "publish_month": 9,
        "publish_day": 9,
        "publisher": "宋鐘憲 中央佛敎專門學校 校友會",
        "publisher_ko": "송종헌 중앙불교전문학교 교우회",
        "library": "국회도서관○",
        "school_id": 52909,
        "primaryname": "中央佛敎專門學校",
        "primaryname_ko": "중앙불교전문학교"
    },
    {
        "book_id": 10860,
        "book_title": "(中央佛敎專門學校) 一光 第3號",
        "book_title_ko": "(중앙불교전문학교) 일광 제3호",
        "publish_date": "1931.03.10",
        "publish_year": 1931,
        "publish_month": 3,
        "publish_day": 10,
        "publisher": "宋鐘憲 中央佛敎專門學校 校友會",
        "publisher_ko": "송종헌 중앙불교전문학교 교우회",
        "library": "국회도서관○",
        "school_id": 52909,
        "primaryname": "中央佛敎專門學校",
        "primaryname_ko": "중앙불교전문학교"
    },
    {
        "book_id": 10861,
        "book_title": "(中央佛敎專門學校) 一光 第5號",
        "book_title_ko": "(중앙불교전문학교) 일광 제5호",
        "publish_date": "1935.01.20",
        "publish_year": 1935,
        "publish_month": 1,
        "publish_day": 20,
        "publisher": "朴漢永 中央佛敎專門學校 校友會",
        "publisher_ko": "박한영 중앙불교전문학교 교우회",
        "library": "국회도서관○",
        "school_id": 52909,
        "primaryname": "中央佛敎專門學校",
        "primaryname_ko": "중앙불교전문학교"
    },
    {
        "book_id": 10935,
        "book_title": "(京畿中學校) 向上 第8號",
        "book_title_ko": "(경기중학교) 향상 제8호",
        "publish_date": "1938.00.00",
        "publish_year": 1938,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京畿公立中學校",
        "publisher_ko": "경기공립중학교",
        "library": "",
        "school_id": 53004,
        "primaryname": "京畿公立中學校",
        "primaryname_ko": "경기공립중학교"
    },
    {
        "book_id": 10935,
        "book_title": "(京畿中學校) 向上 第8號",
        "book_title_ko": "(경기중학교) 향상 제8호",
        "publish_date": "1938.00.00",
        "publish_year": 1938,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京畿公立中學校",
        "publisher_ko": "경기공립중학교",
        "library": "",
        "school_id": 52918,
        "primaryname": "京畿中學校",
        "primaryname_ko": "경기중학교"
    },
    {
        "book_id": 10936,
        "book_title": "(景福中學校) 校友會誌 第1號",
        "book_title_ko": "(경복중학교) 교우회지 제1호",
        "publish_date": "1946.06.00",
        "publish_year": 1946,
        "publish_month": 6,
        "publish_day": 0,
        "publisher": "笠松重雄 景福公立中學校 校友會",
        "publisher_ko": "입송중웅 경복공립중학교 교우회",
        "library": "",
        "school_id": 52801,
        "primaryname": "景福中學校",
        "primaryname_ko": "경복중학교"
    },
    {
        "book_id": 10937,
        "book_title": "(景福中學校) 校友會誌 第5號",
        "book_title_ko": "(경복중학교) 교우회지 제5호",
        "publish_date": "1939.03.10",
        "publish_year": 1939,
        "publish_month": 3,
        "publish_day": 10,
        "publisher": "笠松重雄 景福中學校 校友會",
        "publisher_ko": "입송중웅 경복중학교 교우회",
        "library": "국회도서관",
        "school_id": 52801,
        "primaryname": "景福中學校",
        "primaryname_ko": "경복중학교"
    },
    {
        "book_id": 10938,
        "book_title": "(景福中學校) 校友會誌 第6號",
        "book_title_ko": "(경복중학교) 교우회지 제6호",
        "publish_date": "1940.04.10",
        "publish_year": 1940,
        "publish_month": 4,
        "publish_day": 10,
        "publisher": "笠松重雄 景福中學校 校友會",
        "publisher_ko": "입송중웅 경복중학교 교우회",
        "library": "국회도서관",
        "school_id": 52801,
        "primaryname": "景福中學校",
        "primaryname_ko": "경복중학교"
    },
    {
        "book_id": 10939,
        "book_title": "(京城中學校) 京中 第31號",
        "book_title_ko": "(경성중학교) 경중 제31호",
        "publish_date": "1940.00.00",
        "publish_year": 1940,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城公立中學校 校友會",
        "publisher_ko": "경성공립중학교 교우회",
        "library": "○",
        "school_id": 52919,
        "primaryname": "京城中學校",
        "primaryname_ko": "경성중학교"
    },
    {
        "book_id": 10940,
        "book_title": "(京城中學校) 慶熙史林 ",
        "book_title_ko": "(경성중학교) 경희사림 ",
        "publish_date": "1940.09.10",
        "publish_year": 1940,
        "publish_month": 9,
        "publish_day": 10,
        "publisher": "山口正之  京城公立中學校",
        "publisher_ko": "산구정지  경성공립중학교",
        "library": "○",
        "school_id": 53005,
        "primaryname": "京城公立中學校",
        "primaryname_ko": "경성공립중학교"
    },
    {
        "book_id": 10940,
        "book_title": "(京城中學校) 慶熙史林 ",
        "book_title_ko": "(경성중학교) 경희사림 ",
        "publish_date": "1940.09.10",
        "publish_year": 1940,
        "publish_month": 9,
        "publish_day": 10,
        "publisher": "山口正之  京城公立中學校",
        "publisher_ko": "산구정지  경성공립중학교",
        "library": "○",
        "school_id": 52919,
        "primaryname": "京城中學校",
        "primaryname_ko": "경성중학교"
    },
    {
        "book_id": 10941,
        "book_title": "(京城中學校) 校友會誌 第26號",
        "book_title_ko": "(경성중학교) 교우회지 제26호",
        "publish_date": "1935.03.01",
        "publish_year": 1935,
        "publish_month": 3,
        "publish_day": 1,
        "publisher": "遠藤明三 京城公立中學校 校友會",
        "publisher_ko": "원등명삼 경성공립중학교 교우회",
        "library": "○",
        "school_id": 52919,
        "primaryname": "京城中學校",
        "primaryname_ko": "경성중학교"
    },
    {
        "book_id": 10942,
        "book_title": "(京城中學校) 校友會誌 第27號",
        "book_title_ko": "(경성중학교) 교우회지 제27호",
        "publish_date": "1936.03.23",
        "publish_year": 1936,
        "publish_month": 3,
        "publish_day": 23,
        "publisher": "富山民藏 京城公立中學校 校友會",
        "publisher_ko": "부산민장 경성공립중학교 교우회",
        "library": "○",
        "school_id": 52919,
        "primaryname": "京城中學校",
        "primaryname_ko": "경성중학교"
    },
    {
        "book_id": 10943,
        "book_title": "(京城中學校) 校友會誌 第28號",
        "book_title_ko": "(경성중학교) 교우회지 제28호",
        "publish_date": "1937.03.03",
        "publish_year": 1937,
        "publish_month": 3,
        "publish_day": 3,
        "publisher": "富山民藏 京城公立中學校 校友會",
        "publisher_ko": "부산민장 경성공립중학교 교우회",
        "library": "○",
        "school_id": 52919,
        "primaryname": "京城中學校",
        "primaryname_ko": "경성중학교"
    },
    {
        "book_id": 10944,
        "book_title": "(京城中學校) 校友會誌 第29號",
        "book_title_ko": "(경성중학교) 교우회지 제29호",
        "publish_date": "1938.03.07",
        "publish_year": 1938,
        "publish_month": 3,
        "publish_day": 7,
        "publisher": "富山民藏 京城公立中學校 校友會",
        "publisher_ko": "부산민장 경성공립중학교 교우회",
        "library": "○",
        "school_id": 52919,
        "primaryname": "京城中學校",
        "primaryname_ko": "경성중학교"
    },
    {
        "book_id": 10945,
        "book_title": "(京城中學校) 校友會誌 第30號",
        "book_title_ko": "(경성중학교) 교우회지 제30호",
        "publish_date": "1939.03.06",
        "publish_year": 1939,
        "publish_month": 3,
        "publish_day": 6,
        "publisher": "富山民藏 京城公立中學校 校友會",
        "publisher_ko": "부산민장 경성공립중학교 교우회",
        "library": "○",
        "school_id": 52919,
        "primaryname": "京城中學校",
        "primaryname_ko": "경성중학교"
    },
    {
        "book_id": 10946,
        "book_title": "(群山中學校) 校友會誌 第14號",
        "book_title_ko": "(군산중학교) 교우회지 제14호",
        "publish_date": "1938.02.25",
        "publish_year": 1938,
        "publish_month": 2,
        "publish_day": 25,
        "publisher": "直村勳 群山公立中學校 校友會",
        "publisher_ko": "직촌훈 군산공립중학교 교우회",
        "library": "독립기념관",
        "school_id": 52920,
        "primaryname": "群山中學校",
        "primaryname_ko": "군산중학교"
    },
    {
        "book_id": 10947,
        "book_title": "(群山中學校) 校友會誌 第15號",
        "book_title_ko": "(군산중학교) 교우회지 제15호",
        "publish_date": "1939.03.05",
        "publish_year": 1939,
        "publish_month": 3,
        "publish_day": 5,
        "publisher": "五十嵐泰吉 群山公立中學校 校友會",
        "publisher_ko": "오십람태길 군산공립중학교 교우회",
        "library": "독립기념관",
        "school_id": 52920,
        "primaryname": "群山中學校",
        "primaryname_ko": "군산중학교"
    },
    {
        "book_id": 10948,
        "book_title": "(群山中學校) 校友會誌 創立 10週年 記念號",
        "book_title_ko": "(군산중학교) 교우회지 창립 10주년 기념호",
        "publish_date": "1934.09.01",
        "publish_year": 1934,
        "publish_month": 9,
        "publish_day": 1,
        "publisher": "群山公立中學校 校友會",
        "publisher_ko": "군산공립중학교 교우회",
        "library": "",
        "school_id": 52920,
        "primaryname": "群山中學校",
        "primaryname_ko": "군산중학교"
    },
    {
        "book_id": 10949,
        "book_title": "(金泉中學校) 校友會誌 第5輯",
        "book_title_ko": "(금천중학교) 교우회지 제5집",
        "publish_date": "1941.03.03",
        "publish_year": 1941,
        "publish_month": 3,
        "publish_day": 3,
        "publisher": "高橋象造 金泉中學校 校友會",
        "publisher_ko": "고교상조 금천중학교 교우회",
        "library": "△",
        "school_id": 52921,
        "primaryname": "金泉中學校",
        "primaryname_ko": "김천중학교"
    },
    {
        "book_id": 10950,
        "book_title": "(慶北中學校) 慶北公立中學校同窓會報 第17號",
        "book_title_ko": "(경북중학교) 경북공립중학교동창회보 제17호",
        "publish_date": "1942.12.00",
        "publish_year": 1942,
        "publish_month": 12,
        "publish_day": 0,
        "publisher": "慶北公立中學校 同窓會",
        "publisher_ko": "경북공립중학교 동창회",
        "library": "△",
        "school_id": 52922,
        "primaryname": "慶北中學校",
        "primaryname_ko": "경북중학교"
    },
    {
        "book_id": 10951,
        "book_title": "(同德女子中學校) 同德 第18號",
        "book_title_ko": "(동덕여자중학교) 동덕 제18호",
        "publish_date": "1954.00.00",
        "publish_year": 1954,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "同德女子中學校",
        "publisher_ko": "동덕여자중학교",
        "library": "",
        "school_id": 53006,
        "primaryname": "同德女子中學校",
        "primaryname_ko": "동덕여자중학교"
    },
    {
        "book_id": 10951,
        "book_title": "(同德女子中學校) 同德 第18號",
        "book_title_ko": "(동덕여자중학교) 동덕 제18호",
        "publish_date": "1954.00.00",
        "publish_year": 1954,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "同德女子中學校",
        "publisher_ko": "동덕여자중학교",
        "library": "",
        "school_id": 52923,
        "primaryname": "同德女子中學校",
        "primaryname_ko": "동덕여자중학교"
    },
    {
        "book_id": 10952,
        "book_title": "(普成中學校) 普成 第6號",
        "book_title_ko": "(보성중학교) 보성 제6호",
        "publish_date": "1940.03.01",
        "publish_year": 1940,
        "publish_month": 3,
        "publish_day": 1,
        "publisher": "朴格欽 普成中學校 學友會",
        "publisher_ko": "박격흠 보성중학교 학우회",
        "library": "서울대",
        "school_id": 52924,
        "primaryname": "普成中學校",
        "primaryname_ko": "보성중학교"
    },
    {
        "book_id": 10953,
        "book_title": "(普成中學校) 普中親睦會報 第1號",
        "book_title_ko": "(보성중학교) 보중친목회보 제1호",
        "publish_date": "1910.06.10",
        "publish_year": 1910,
        "publish_month": 6,
        "publish_day": 10,
        "publisher": "李秀三 普中親睦會",
        "publisher_ko": "이수삼 보중친목회",
        "library": "국회도서관;서울대△",
        "school_id": 52924,
        "primaryname": "普成中學校",
        "primaryname_ko": "보성중학교"
    },
    {
        "book_id": 10954,
        "book_title": "(普成中學校) 普中親睦會報 第2號",
        "book_title_ko": "(보성중학교) 보중친목회보 제2호",
        "publish_date": "1910.12.31",
        "publish_year": 1910,
        "publish_month": 12,
        "publish_day": 31,
        "publisher": "李秀三 普中親睦會",
        "publisher_ko": "이수삼 보중친목회",
        "library": "국회도서관△",
        "school_id": 52924,
        "primaryname": "普成中學校",
        "primaryname_ko": "보성중학교"
    },
    {
        "book_id": 10955,
        "book_title": "(養正中學校) 養正 第16號",
        "book_title_ko": "(양정중학교) 양정 제16호",
        "publish_date": "1940.00.00",
        "publish_year": 1940,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "養正中學校 校友會",
        "publisher_ko": "양정중학교 교우회",
        "library": "",
        "school_id": 52925,
        "primaryname": "養正中學校",
        "primaryname_ko": "양정중학교"
    },
    {
        "book_id": 10956,
        "book_title": "(養正中學校) 養正 第17號",
        "book_title_ko": "(양정중학교) 양정 제17호",
        "publish_date": "1941.02.27",
        "publish_year": 1941,
        "publish_month": 2,
        "publish_day": 27,
        "publisher": "稻見俊次 養正中學校 校友會",
        "publisher_ko": "도견준차 양정중학교 교우회",
        "library": "△",
        "school_id": 52925,
        "primaryname": "養正中學校",
        "primaryname_ko": "양정중학교"
    },
    {
        "book_id": 10957,
        "book_title": "(養正中學校) 養正 第18號",
        "book_title_ko": "(양정중학교) 양정 제18호",
        "publish_date": "1941.00.00",
        "publish_year": 1941,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "國民總力養正中學校聯盟",
        "publisher_ko": "국민총력양정중학교련맹",
        "library": "",
        "school_id": 52925,
        "primaryname": "養正中學校",
        "primaryname_ko": "양정중학교"
    },
    {
        "book_id": 10958,
        "book_title": "(養正中學校) 養正 第19號",
        "book_title_ko": "(양정중학교) 양정 제19호",
        "publish_date": "1943.02.15",
        "publish_year": 1943,
        "publish_month": 2,
        "publish_day": 15,
        "publisher": "古市保 國民總力養正中學校聯盟",
        "publisher_ko": "고시보 국민총력양정중학교련맹",
        "library": "독립기념관",
        "school_id": 52925,
        "primaryname": "養正中學校",
        "primaryname_ko": "양정중학교"
    },
    {
        "book_id": 10959,
        "book_title": "(養正中學校) 養正 第20號",
        "book_title_ko": "(양정중학교) 양정 제20호",
        "publish_date": "1946.06.15",
        "publish_year": 1946,
        "publish_month": 6,
        "publish_day": 15,
        "publisher": "全尙錫 養正學友會 文藝部",
        "publisher_ko": "전상석 양정학우회 문예부",
        "library": "△",
        "school_id": 52925,
        "primaryname": "養正中學校",
        "primaryname_ko": "양정중학교"
    },
    {
        "book_id": 10960,
        "book_title": "(養正中學校) 養正 第21號",
        "book_title_ko": "(양정중학교) 양정 제21호",
        "publish_date": "1948.08.10",
        "publish_year": 1948,
        "publish_month": 8,
        "publish_day": 10,
        "publisher": "文熙奭 養正中學校 學生會 文藝會",
        "publisher_ko": "문희석 양정중학교 학생회 문예회",
        "library": "독립기념관",
        "school_id": 52925,
        "primaryname": "養正中學校",
        "primaryname_ko": "양정중학교"
    },
    {
        "book_id": 10961,
        "book_title": "(龍山中學校) 龍友會誌 第16號",
        "book_title_ko": "(용산중학교) 용우회지 제16호",
        "publish_date": "1935.03.05",
        "publish_year": 1935,
        "publish_month": 3,
        "publish_day": 5,
        "publisher": "宇多川寬道 龍山公立中學校校友會",
        "publisher_ko": "우다천관도 용산공립중학교교우회",
        "library": "국회도서관",
        "school_id": 52926,
        "primaryname": "龍山中學校",
        "primaryname_ko": "용산중학교"
    },
    {
        "book_id": 10962,
        "book_title": "(裡里工業中學校) 技林 創刊號",
        "book_title_ko": "(이리공업중학교) 기림 창간호",
        "publish_date": "1949.06.01",
        "publish_year": 1949,
        "publish_month": 6,
        "publish_day": 1,
        "publisher": "裡里公立工業中學校",
        "publisher_ko": "이리공립공업중학교",
        "library": "○",
        "school_id": 53007,
        "primaryname": "裡里公立工業中學校",
        "primaryname_ko": "이리공립공업중학교"
    },
    {
        "book_id": 10962,
        "book_title": "(裡里工業中學校) 技林 創刊號",
        "book_title_ko": "(이리공업중학교) 기림 창간호",
        "publish_date": "1949.06.01",
        "publish_year": 1949,
        "publish_month": 6,
        "publish_day": 1,
        "publisher": "裡里公立工業中學校",
        "publisher_ko": "이리공립공업중학교",
        "library": "○",
        "school_id": 52927,
        "primaryname": "裡里工業中學校",
        "primaryname_ko": "이리공업중학교"
    },
    {
        "book_id": 10963,
        "book_title": "(晋州中學校) 飛鳳 第10號",
        "book_title_ko": "(진주중학교) 비봉 제10호",
        "publish_date": "1940.03.25",
        "publish_year": 1940,
        "publish_month": 3,
        "publish_day": 25,
        "publisher": "渡部政德 晋州公立中學校 校友會",
        "publisher_ko": "도부정덕 진주공립중학교 교우회",
        "library": "○",
        "school_id": 52928,
        "primaryname": "晋州中學校",
        "primaryname_ko": "진주중학교"
    },
    {
        "book_id": 10964,
        "book_title": "(淸州中學校) 舟城 第9號",
        "book_title_ko": "(청주중학교) 주성 제9호",
        "publish_date": "1938.05.15",
        "publish_year": 1938,
        "publish_month": 5,
        "publish_day": 15,
        "publisher": "堤眞一 淸州公立中學校 校友會",
        "publisher_ko": "제진일 청주공립중학교 교우회",
        "library": "△",
        "school_id": 52929,
        "primaryname": "淸州中學校",
        "primaryname_ko": "청주중학교"
    },
    {
        "book_id": 10965,
        "book_title": "(徽文中學校) 徽文 第20號",
        "book_title_ko": "(휘문중학교) 휘문 제20호",
        "publish_date": "1948.00.00",
        "publish_year": 1948,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "徽文中學校 文藝部",
        "publisher_ko": "휘문중학교 문예부",
        "library": "",
        "school_id": 52930,
        "primaryname": "徽文中學校",
        "primaryname_ko": "휘문중학교"
    },
    {
        "book_id": 10981,
        "book_title": "우라키 1輯",
        "book_title_ko": "우라키 1집",
        "publish_date": "1925.09.26",
        "publish_year": 1925,
        "publish_month": 9,
        "publish_day": 26,
        "publisher": "北美學生總會",
        "publisher_ko": "북미학생총회",
        "library": "○",
        "school_id": null,
        "primaryname": null,
        "primaryname_ko": null
    },
    {
        "book_id": 10982,
        "book_title": "우라키 3輯",
        "book_title_ko": "우라키 3집",
        "publish_date": "1928.04.07",
        "publish_year": 1928,
        "publish_month": 4,
        "publish_day": 7,
        "publisher": "北美學生總會",
        "publisher_ko": "북미학생총회",
        "library": "○",
        "school_id": null,
        "primaryname": null,
        "primaryname_ko": null
    },
    {
        "book_id": 10983,
        "book_title": "우라키 4輯 留米學生總會10週年 記念號",
        "book_title_ko": "우라키 4집 류미학생총회10주년 기념호",
        "publish_date": "1930.06.14",
        "publish_year": 1930,
        "publish_month": 6,
        "publish_day": 14,
        "publisher": "北美學生總會",
        "publisher_ko": "북미학생총회",
        "library": "○",
        "school_id": null,
        "primaryname": null,
        "primaryname_ko": null
    }
]

export default AlumniData;